function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("style", {
  type: "text/css"
}, "\r\n\t.sty0{fill:url(#SVGID_1_);}\r\n\t.sty1{opacity:0.2;fill:url(#SVGID_2_);enable-background:new    ;}\r\n\t.sty2{fill:none;stroke:url(#SVGID_3_);stroke-width:0.7744;stroke-miterlimit:10;}\r\n\t.sty3{opacity:0.75;fill:none;stroke:url(#SVGID_4_);stroke-width:0.5226;stroke-miterlimit:10;enable-background:new    ;}\r\n\t.sty4{fill:url(#SVGID_5_);}\r\n\t.sty5{fill:url(#SVGID_6_);}\r\n\t.sty6{fill:url(#SVGID_7_);}\r\n\t.sty7{fill:url(#SVGID_8_);}\r\n\t.sty8{opacity:0.15;fill:url(#SVGID_9_);enable-background:new    ;}\r\n\t.sty9{opacity:0.65;}\r\n\t.sty10{fill:#FFFFFF;}\r\n\t.sty11{fill:#48347A;}\r\n\t.sty12{fill:#6752AA;}\r\n\t.sty13{fill:url(#SVGID_10_);}\r\n\t.sty14{fill:#7D7D7D;}\r\n\t.sty15{fill:#CCCCCC;}\r\n\t.sty16{fill:url(#SVGID_11_);}\r\n\t.sty17{fill:url(#SVGID_12_);}\r\n\t.sty18{fill:url(#SVGID_13_);}\r\n\t.sty19{fill:#7F4B28;}\r\n\t.sty20{fill:#AF6B38;}\r\n\t.sty21{fill:none;stroke:#F4973B;stroke-width:0.1673;stroke-linecap:round;stroke-miterlimit:10;}\r\n\t.sty22{fill:#BABABA;}\r\n\t.sty23{fill:url(#SVGID_14_);}\r\n\t.sty24{fill:url(#SVGID_15_);}\r\n\t.sty25{fill:#EFBD9C;}\r\n\t.sty26{fill:#FECFAE;}\r\n\t.sty27{fill:#F6BEFC;}\r\n\t.sty28{fill:url(#SVGID_16_);}\r\n\t.sty29{fill:url(#SVGID_17_);}\r\n\t.sty30{fill:url(#SVGID_18_);}\r\n\t.sty31{fill:url(#SVGID_19_);}\r\n\t.sty32{fill:#D1A586;}\r\n\t.sty33{fill:#352C5B;}\r\n\t.sty34{fill:#4A3F7A;}\r\n\t.sty35{fill:#554684;}\r\n\t.sty36{fill:#D146A6;}\r\n\t.sty37{fill:#CE956E;}\r\n\t.sty38{fill:#EDBB98;}\r\n\t.sty39{fill:#F9BDFF;}\r\n\t.sty40{fill:url(#SVGID_20_);}\r\n\t.sty41{fill:url(#SVGID_21_);}\r\n\t.sty42{fill:url(#SVGID_22_);}\r\n\t.sty43{fill:#EAB18B;}\r\n\t.sty44{fill:url(#SVGID_23_);}\r\n\t.sty45{fill:#B58368;}\r\n\t.sty46{fill:#FFCBAE;}\r\n\t.sty47{fill:#BF8567;}\r\n\t.sty48{fill:#A8735B;}\r\n\t.sty49{fill:#7A4327;}\r\n\t.sty50{fill:#E09C3B;}\r\n\t.sty51{fill:url(#SVGID_24_);}\r\n\t.sty52{fill:url(#SVGID_25_);}\r\n\t.sty53{fill:#469191;}\r\n\t.sty54{fill:#58A3A5;}\r\n\t.sty55{fill:url(#SVGID_26_);}\r\n\t.sty56{fill:#E26196;}\r\n\t.sty57{fill:url(#SVGID_27_);}\r\n\t.sty58{fill:url(#SVGID_28_);}\r\n\t.sty59{fill:#CE8E6E;}\r\n\t.sty60{fill:#DD9F7C;}\r\n\t.sty61{fill:#DD9E7A;}\r\n\t.sty62{fill:#C98865;}\r\n\t.sty63{fill:url(#SVGID_29_);}\r\n\t.sty64{fill:url(#SVGID_30_);}\r\n\t.sty65{fill:#6B361F;}\r\n\t.sty66{opacity:0.4;fill:#D39779;enable-background:new    ;}\r\n\t.sty67{fill:#FCF5FF;}\r\n\t.sty68{fill:url(#SVGID_31_);}\r\n\t.sty69{fill:url(#SVGID_32_);}\r\n\t.sty70{fill:url(#SVGID_33_);}\r\n\t.sty71{fill:url(#SVGID_34_);}\r\n\t.sty72{fill:url(#SVGID_35_);}\r\n\t.sty73{fill:url(#SVGID_36_);}\r\n\t.sty74{fill:url(#SVGID_37_);}\r\n\t.sty75{fill:url(#SVGID_38_);}\r\n\t.sty76{fill:url(#SVGID_39_);}\r\n\t.sty77{fill:#6B4D39;}\r\n\t.sty78{fill:url(#SVGID_40_);}\r\n\t.sty79{fill:url(#SVGID_41_);}\r\n\t.sty80{fill:url(#SVGID_42_);}\r\n\t.sty81{fill:url(#SVGID_43_);}\r\n\t.sty82{fill:url(#SVGID_44_);}\r\n\t.sty83{fill:url(#SVGID_45_);}\r\n\t.sty84{fill:url(#SVGID_46_);}\r\n\t.sty85{fill:url(#SVGID_47_);}\r\n\t.sty86{fill:url(#SVGID_48_);}\r\n\t.sty87{fill:url(#SVGID_49_);}\r\n\t.sty88{fill:url(#SVGID_50_);}\r\n\t.sty89{fill:url(#SVGID_51_);}\r\n\t.sty90{fill:url(#SVGID_52_);}\r\n\t.sty91{fill:#E59218;}\r\n\t.sty92{fill:url(#SVGID_53_);}\r\n\t.sty93{fill:url(#SVGID_54_);}\r\n\t.sty94{fill:url(#SVGID_55_);}\r\n\t.sty95{opacity:0.15;fill:url(#SVGID_56_);enable-background:new    ;}\r\n\t.sty96{fill:#FFFFFF;stroke:#89A3E5;stroke-width:0.25;stroke-miterlimit:10;}\r\n");

var _ref3 = /*#__PURE__*/React.createElement("path", {
  className: "sty0",
  d: "M18,0h67c9.9,0,18,8.1,18,18v65c0,9.9-8.1,18-18,18H18c-9.9,0-18-8.1-18-18V18C0,8.1,8.1,0,18,0z"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  className: "sty1",
  d: "M51.4,40.6c-18.7,0.3-33.8,10.2-33.6,22s15.5,21.3,34.3,20.9s33.8-10.2,33.6-22 C85.5,49.7,70.1,40.3,51.4,40.6z"
});

var _ref5 = /*#__PURE__*/React.createElement("ellipse", {
  transform: "matrix(0.9999 -1.603092e-02 1.603092e-02 0.9999 -0.8304 0.8367)",
  className: "sty2",
  cx: 51.8,
  cy: 52.2,
  rx: 37.6,
  ry: 25.1
});

var _ref6 = /*#__PURE__*/React.createElement("ellipse", {
  transform: "matrix(0.9999 -1.603064e-02 1.603064e-02 0.9999 -0.8304 0.8367)",
  className: "sty3",
  cx: 51.8,
  cy: 52.2,
  rx: 40.9,
  ry: 27.3
});

var _ref7 = /*#__PURE__*/React.createElement("path", {
  className: "sty4",
  d: "M52.2,73.3C70.9,73,85.9,63.1,85.7,51.1l0-1.9l-67.8,1.5v1.5C18.1,64.2,33.4,73.6,52.2,73.3z"
});

var _ref8 = /*#__PURE__*/React.createElement("path", {
  className: "sty5",
  d: "M51.4,28.5c-18.7,0.3-33.7,10.2-33.5,22.2c0.2,11.9,15.5,21.4,34.2,21.1s33.7-10.2,33.5-22.2 S70.1,28.2,51.4,28.5z"
});

var _ref9 = /*#__PURE__*/React.createElement("path", {
  className: "sty6",
  d: "M52.1,68.3c16-0.2,28.9-8.8,28.7-19v-2.7l-58.1,1.3v2.3C22.9,60.5,36,68.6,52.1,68.3z"
});

var _ref10 = /*#__PURE__*/React.createElement("path", {
  className: "sty7",
  d: "M51.5,28.9c-16,0.2-28.9,8.8-28.7,19C22.9,58.2,36,66.3,52.1,66S81,57.2,80.9,47 C80.6,36.8,67.5,28.7,51.5,28.9z"
});

var _ref11 = /*#__PURE__*/React.createElement("path", {
  className: "sty8",
  d: "M51.8,5.9c-16,0-29,8.3-29,18.7c0,5.5,0,12.9,0,18.4c0-10.3,13-18.7,29-18.7s29,8.3,29,18.7V24.5 C80.8,14.2,67.8,5.9,51.8,5.9z"
});

var _ref12 = /*#__PURE__*/React.createElement("g", {
  className: "sty9"
}, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  className: "sty10",
  d: "M49.4,8.1l0.4,0l0.7,0.5l-0.3,0.3l-0.4-0.3c0,0.4,0,1,0,1.4l-0.4,0C49.4,9.4,49.4,8.6,49.4,8.1"
}), /*#__PURE__*/React.createElement("path", {
  className: "sty10",
  d: "M47.1,9.8c0.1,0,0.3-0.1,0.3-0.4c0,0,0.1-0.5-0.1-0.7c-0.2-0.2-0.7,0-0.5,0.8 C46.8,9.7,46.9,9.8,47.1,9.8 M47.1,8.3c1.1-0.1,0.9,1.2,0.6,1.6c-0.3,0.4-1.3,0.5-1.4-0.4C46.2,9.3,46.2,8.4,47.1,8.3"
}), /*#__PURE__*/React.createElement("path", {
  className: "sty10",
  d: "M48.4,10.6c0.1,0.2,0.3,0.3,0.3,0.5c0.1,0.1,0.1,0.3,0.1,0.6c0,0.5-0.3,1-0.4,1.2l0,0 c-0.1,0-0.2-0.1-0.3-0.1c0.5-0.8,0.5-1.3,0-2L48.4,10.6"
}), /*#__PURE__*/React.createElement("path", {
  className: "sty10",
  d: "M46.8,10.8c0.1,0,0.2,0.1,0.3,0.1c-0.5,0.8-0.5,1.3,0,2L46.8,13c-0.1-0.2-0.2-0.3-0.3-0.5 c-0.1-0.1-0.1-0.3-0.1-0.6C46.3,11.4,46.6,11,46.8,10.8L46.8,10.8"
}), /*#__PURE__*/React.createElement("path", {
  className: "sty10",
  d: "M49.3,13.8c0.9,0,1,0.7,0.7,1.1c-0.3,0.2-0.9,0.3-1.2,0.1c0.1-0.1,0.2-0.2,0.3-0.3 c0.2,0.2,0.7,0,0.6-0.3s-0.4-0.3-0.6-0.1c-0.1-0.1-0.2-0.2-0.3-0.2C49,13.8,49.2,13.8,49.3,13.8"
}), /*#__PURE__*/React.createElement("path", {
  className: "sty10",
  d: "M47.2,14.9c0.3,0,0.4-0.3,0.2-0.4c0,0-0.1-0.1-0.2-0.1c-0.1,0.1-0.3,0.3-0.4,0.4 C47,14.9,47.1,14.9,47.2,14.9 M47.1,14c0.1-0.1,0.2-0.2,0.2-0.2c0-0.1,0-0.1-0.2-0.1c-0.2,0-0.3,0.2-0.2,0.3 C47,14,47.1,14,47.1,14 M47.1,13.3c0.8-0.1,0.8,0.4,0.5,0.7c0,0-0.1,0.1-0.1,0.1c0.5,0.1,0.6,0.6,0.2,0.9 c-0.1,0.1-0.7,0.4-1.2,0l-0.2,0.2l-0.6,0.1l0.5-0.5l-0.4-0.4l0.5-0.1l0.2,0.2c0.1-0.1,0.2-0.2,0.3-0.3 c-0.5-0.2-0.5-0.7-0.1-0.8C46.8,13.4,46.9,13.4,47.1,13.3"
}), /*#__PURE__*/React.createElement("path", {
  className: "sty10",
  d: "M49.9,6.4l0.4-0.5c-0.2,0-0.4,0-0.5,0l-0.2,0.3L49.3,6c-0.2,0-0.3,0-0.5,0l0.4,0.5l-0.6,0.7l0.5,0 l0.3-0.4l0.3,0.4l0.5,0L49.9,6.4"
}), /*#__PURE__*/React.createElement("path", {
  className: "sty10",
  d: "M46.7,6.1c-0.1,0-0.2,0-0.3,0C46.6,6.5,46.8,7,47,7.4l0.3-0.1C47.1,7,46.9,6.5,46.7,6.1"
}), /*#__PURE__*/React.createElement("path", {
  className: "sty10",
  d: "M49.4,18.2l0.4,0l0.7,0.5l-0.3,0.3l-0.4-0.3c0,0.4,0,1,0,1.4l-0.4,0C49.4,19.5,49.4,18.7,49.4,18.2"
}), /*#__PURE__*/React.createElement("path", {
  className: "sty10",
  d: "M47.1,19.9c0.1,0,0.3-0.1,0.3-0.4c0,0,0.1-0.5-0.1-0.7c-0.2-0.2-0.7,0-0.5,0.8 C46.8,19.8,46.9,19.9,47.1,19.9 M47.1,18.3c1.1-0.1,0.9,1.2,0.6,1.6c-0.3,0.4-1.3,0.5-1.4-0.4C46.2,19.4,46.2,18.4,47.1,18.3"
}), /*#__PURE__*/React.createElement("path", {
  className: "sty10",
  d: "M48.4,20.7c0.1,0.2,0.3,0.3,0.3,0.5c0.1,0.1,0.1,0.3,0.1,0.6c0,0.5-0.3,1-0.4,1.2l0,0 c-0.1,0-0.2-0.1-0.3-0.1c0.5-0.8,0.5-1.3,0-2L48.4,20.7"
}), /*#__PURE__*/React.createElement("path", {
  className: "sty10",
  d: "M46.8,20.9c0.1,0,0.2,0.1,0.3,0.1c-0.5,0.8-0.5,1.3,0,2l-0.3,0.2c-0.1-0.2-0.2-0.3-0.3-0.5 c-0.1-0.1-0.1-0.3-0.1-0.6C46.3,21.5,46.6,21,46.8,20.9L46.8,20.9"
}), /*#__PURE__*/React.createElement("path", {
  className: "sty10",
  d: "M50.2,24.3c0-0.1-0.2-0.5-0.8-0.5c-0.2,0-0.4,0.1-0.5,0.2c0.1,0.1,0.2,0.2,0.3,0.2 c0.2-0.2,0.5-0.1,0.6,0.1C49.9,24.4,50,24.4,50.2,24.3C50.2,24.3,50.2,24.3,50.2,24.3"
}), /*#__PURE__*/React.createElement("path", {
  className: "sty10",
  d: "M47.3,24.5c0,0-0.1,0-0.1,0l-0.1,0.1C47.2,24.5,47.3,24.5,47.3,24.5C47.3,24.5,47.3,24.5,47.3,24.5  M47.1,24.1c0.1-0.1,0.2-0.2,0.2-0.2c0-0.1,0-0.1-0.2-0.1c-0.2,0-0.3,0.2-0.2,0.3C47,24.1,47.1,24.1,47.1,24.1 M46.4,24.4 l0.2,0.2c-0.2,0-0.3,0-0.5,0.1l-0.2-0.2L46.4,24.4 M47.9,24.5L47.9,24.5c-0.4,0-0.9,0.1-1.3,0.1l0.2-0.2 c-0.6-0.2-0.4-0.7-0.1-0.8c0.2-0.1,0.3-0.1,0.5-0.1c0.5,0,0.8,0.3,0.3,0.8C47.7,24.3,47.8,24.3,47.9,24.5"
}), /*#__PURE__*/React.createElement("polyline", {
  className: "sty10",
  points: "48.8,16 49.3,15.9 49.5,16.2 49.8,15.9 50.4,15.9 49.9,16.5 50.5,17.1 49.9,17.1 49.6,16.7  49.2,17.2 48.7,17.2 49.3,16.5 48.8,16  "
}), /*#__PURE__*/React.createElement("path", {
  className: "sty10",
  d: "M46.6,15.9c0.2,0.4,0.5,1.1,0.7,1.5L47,17.5c-0.2-0.4-0.5-1-0.7-1.5L46.6,15.9"
}), /*#__PURE__*/React.createElement("path", {
  className: "sty10",
  d: "M45.4,6.5l-0.6,0.1V6.4c-0.1,0-0.2,0-0.4,0.1v0.2l-0.6,0.1v0.3L44.4,7v0.5l0.4-0.1V7l0.6-0.1V6.5"
}), /*#__PURE__*/React.createElement("path", {
  className: "sty10",
  d: "M44.9,9.9c0.2,0,0.3,0.2,0.2,0.3c-0.2,0.2-0.4,0.2-0.5,0C44.6,10.1,44.7,9.9,44.9,9.9 M44.7,8.6l0.4-0.1 c0,0.4,0,0.9,0,1.2l-0.4,0.1C44.7,9.5,44.7,9,44.7,8.6"
}), /*#__PURE__*/React.createElement("path", {
  className: "sty10",
  d: "M42.8,10.3c0.2,0,0.3,0.2,0.2,0.3c-0.1,0.2-0.4,0.2-0.5,0C42.5,10.5,42.6,10.4,42.8,10.3 M42.8,8.9 c0.4-0.1,0.7,0.1,0.7,0.4c-0.1,0-0.3,0.1-0.4,0.1c0-0.2-0.3-0.2-0.4-0.1c-0.1,0.2,0,0.2,0.2,0.3C43,9.8,43,9.8,43,10v0.1 l-0.4,0.1c0-0.1,0-0.2-0.1-0.2c-0.2-0.1-0.4-0.2-0.3-0.5C42.2,9.2,42.5,9,42.8,8.9"
}), /*#__PURE__*/React.createElement("path", {
  className: "sty10",
  d: "M40.2,9.6l0.4-0.1l0.7,0.3L41,10.2l-0.4-0.2c0,0.4,0,1,0,1.4l-0.4,0.1C40.2,10.9,40.2,10.1,40.2,9.6"
}), /*#__PURE__*/React.createElement("path", {
  className: "sty10",
  d: "M38.2,11.7c0.1,0,0.2-0.1,0.3-0.4c0-0.1,0.1-0.7-0.2-0.7c-0.1,0-0.3,0-0.4,0.3c-0.1,0.2-0.1,0.7,0,0.8 C38,11.7,38.1,11.7,38.2,11.7 M38.2,10.2c0.9-0.3,0.8,1.1,0.5,1.4c-0.2,0.4-1,0.8-1.2,0C37.5,11.4,37.5,10.5,38.2,10.2"
}), /*#__PURE__*/React.createElement("path", {
  className: "sty10",
  d: "M44.9,12.4l0-0.3l-0.3,0l0,0.3L44.9,12.4 M44.2,11.5l0.3,0l0.1,0.5l0.3,0l-0.1-0.5l0.3,0l0.1,0.5l0.3,0 v0.2l-0.2,0l0,0.3l0.3,0v0.2l-0.2,0l0.1,0.5l-0.3,0l-0.1-0.5l-0.3,0l0.1,0.5l-0.3,0l-0.1-0.5l-0.3,0v-0.2l0.2,0l0-0.3l-0.3,0 V12l0.2,0L44.2,11.5"
}), /*#__PURE__*/React.createElement("path", {
  className: "sty10",
  d: "M41.4,13.6c0.3-0.1,0.3-0.4,0.2-0.5c-0.2-0.1-0.5,0.1-0.4,0.4C41.2,13.6,41.3,13.7,41.4,13.6 M41.4,12.9 c0.5-0.1,0.7,0.3,0.5,0.7c-0.3,0.4-0.9,0.5-1,0.1C40.8,13.3,41.1,12.9,41.4,12.9 M42.8,12.4c0.3-0.1,0.3-0.4,0.2-0.5 c-0.2-0.1-0.5,0.1-0.4,0.3C42.6,12.4,42.7,12.5,42.8,12.4 M42.8,11.7c0.5-0.1,0.7,0.4,0.5,0.7c-0.3,0.4-0.9,0.4-1,0 C42.2,12.1,42.5,11.8,42.8,11.7 M41.6,11.9c0.4,0.5,0.8,1.1,1.2,1.6l-0.2,0.2c-0.4-0.5-0.8-1.1-1.2-1.6L41.6,11.9"
}), /*#__PURE__*/React.createElement("path", {
  className: "sty10",
  d: "M39.4,12.3c0.3,0.4,0.7,1.1,0,2.3l0,0c-0.1,0-0.2,0-0.3-0.1c0.5-0.9,0.5-1.4,0-2L39.4,12.3"
}), /*#__PURE__*/React.createElement("path", {
  className: "sty10",
  d: "M37.9,12.8c0.1,0,0.2,0,0.3,0.1c-0.4,0.9-0.4,1.4,0,2L37.9,15C37.7,14.8,37.2,14.1,37.9,12.8L37.9,12.8"
}), /*#__PURE__*/React.createElement("path", {
  className: "sty10",
  d: "M44.9,15.3c0.2,0,0.2-0.2,0.2-0.3c-0.1-0.1-0.3,0-0.4,0l-0.1,0c0,0.1,0,0.2,0.1,0.2 C44.7,15.3,44.8,15.3,44.9,15.3 M44.8,14.2c0.3,0,0.5,0,0.7,0.1c-0.1,0.1-0.2,0.2-0.2,0.2c-0.3-0.2-0.7-0.1-0.7,0.2 c1.4-0.2,0.9,0.5,0.9,0.5c-0.2,0.2-0.7,0.4-0.9,0.1l0,0v0.2l-0.4,0.1c0-0.9,0-0.9,0.1-1C44.3,14.3,44.6,14.3,44.8,14.2"
}), /*#__PURE__*/React.createElement("path", {
  className: "sty10",
  d: "M42.5,15.6c0.4-0.1,0.4-0.5,0.2-0.6c-0.2-0.1-0.7,0.1-0.5,0.5C42.2,15.6,42.3,15.7,42.5,15.6 M42.8,13.9 l0.4-0.1c0,0.5,0,1.3,0,1.9c0,0,0,0.1,0,0.1l-0.4,0.1v-0.2c-0.5,0.5-1.1,0.3-1.1-0.2c0-0.7,0.8-1,1.1-0.8l0,0L42.8,13.9"
}), /*#__PURE__*/React.createElement("path", {
  className: "sty10",
  d: "M40.2,15.2c0.8-0.2,0.9,0.4,0.6,0.9c-0.2,0.4-0.8,0.6-1.1,0.4c0.1-0.1,0.2-0.2,0.3-0.3 c0.2,0.1,0.5-0.1,0.5-0.4c0-0.3-0.3-0.2-0.5-0.1l0,0c-0.1-0.1-0.2-0.1-0.3-0.2C39.9,15.3,40.1,15.3,40.2,15.2"
}), /*#__PURE__*/React.createElement("path", {
  className: "sty10",
  d: "M38.3,16.8c0.2-0.1,0.3-0.4,0.1-0.4c0,0-0.1,0-0.1,0c-0.1,0.1-0.2,0.3-0.3,0.4 C38.1,16.8,38.2,16.8,38.3,16.8 M38.3,16c0.1-0.1,0.1-0.2,0.2-0.3c0-0.1-0.1-0.1-0.1-0.1c-0.2,0-0.3,0.2-0.2,0.3 C38.1,15.9,38.2,16,38.3,16 M38.2,15.3c0.7-0.2,0.7,0.3,0.5,0.5c0,0.1-0.1,0.1-0.1,0.2c0.5,0,0.5,0.5,0.1,0.9 c0,0-0.5,0.5-1,0.2l-0.2,0.2l-0.5,0.2l0.4-0.6l-0.4-0.4l0.4-0.2l0.2,0.2c0.1-0.1,0.2-0.2,0.2-0.3c-0.5-0.1-0.4-0.6-0.1-0.9 C38,15.4,38.1,15.3,38.2,15.3"
}), /*#__PURE__*/React.createElement("polyline", {
  className: "sty10",
  points: "42.2,7.3 42.9,7.1 42.9,7.4 42.2,7.6 42.2,7.3  "
}), /*#__PURE__*/React.createElement("path", {
  className: "sty10",
  d: "M40.7,7.8L41,7.2c-0.2,0-0.3,0.1-0.5,0.1l-0.2,0.3l-0.2-0.2c-0.1,0-0.3,0.1-0.4,0.1L40.1,8l-0.5,0.8 l0.5-0.1l0.3-0.5l0.3,0.3l0.5-0.2L40.7,7.8"
}), /*#__PURE__*/React.createElement("path", {
  className: "sty10",
  d: "M37.9,8.1c-0.1,0-0.2,0.1-0.3,0.1C37.8,8.6,38,9,38.1,9.3l0.2-0.1C38.2,8.9,38.1,8.4,37.9,8.1"
}), /*#__PURE__*/React.createElement("polyline", {
  className: "sty10",
  points: "44.4,16.2 44.8,16.2 44.8,16.7 45.4,16.6 45.4,17 44.8,17 44.8,17.6 44.4,17.6 44.4,17.1  43.7,17.2 43.7,16.9 44.4,16.8 44.4,16.2  "
}), /*#__PURE__*/React.createElement("path", {
  className: "sty10",
  d: "M44.9,20c0.2,0,0.3,0.2,0.2,0.3c-0.2,0.2-0.4,0.2-0.5,0C44.6,20.2,44.7,20,44.9,20 M44.7,18.7l0.4-0.1 c0,0.4,0,0.9,0,1.2l-0.4,0.1C44.7,19.5,44.7,19,44.7,18.7"
}), /*#__PURE__*/React.createElement("path", {
  className: "sty10",
  d: "M42.8,20.4c0.2,0,0.3,0.2,0.2,0.3c-0.1,0.2-0.4,0.2-0.5,0C42.5,20.6,42.6,20.4,42.8,20.4 M42.8,19 c0.4-0.1,0.7,0.1,0.7,0.4c-0.1,0-0.3,0.1-0.4,0.1c0-0.2-0.3-0.2-0.4-0.1c-0.1,0.2,0,0.2,0.2,0.3c0.2,0.1,0.2,0.1,0.2,0.3v0.1 l-0.4,0.1c0-0.1,0-0.2-0.1-0.2c-0.2-0.1-0.4-0.2-0.3-0.5C42.2,19.3,42.5,19,42.8,19"
}), /*#__PURE__*/React.createElement("path", {
  className: "sty10",
  d: "M40.2,19.7l0.4-0.1l0.7,0.3L41,20.2L40.6,20c0,0.4,0,1,0,1.4l-0.4,0.1C40.2,20.9,40.2,20.2,40.2,19.7"
}), /*#__PURE__*/React.createElement("path", {
  className: "sty10",
  d: "M38.2,21.8c0.1,0,0.2-0.1,0.3-0.4c0-0.1,0.1-0.7-0.2-0.7c-0.1,0-0.3,0-0.4,0.3c-0.1,0.2-0.1,0.7,0,0.8 C38,21.8,38.1,21.8,38.2,21.8 M38.2,20.2c0.9-0.3,0.8,1.1,0.5,1.4c-0.2,0.4-1,0.8-1.2,0C37.5,21.4,37.5,20.5,38.2,20.2"
}), /*#__PURE__*/React.createElement("path", {
  className: "sty10",
  d: "M44.9,22.5l0-0.3l-0.3,0l0,0.3L44.9,22.5 M44.2,21.5l0.3,0l0.1,0.5l0.3,0l-0.1-0.5l0.3,0l0.1,0.5l0.3,0 v0.2l-0.2,0l0,0.3l0.3,0v0.2l-0.2,0l0.1,0.5l-0.3,0l-0.1-0.5l-0.3,0l0.1,0.5l-0.3,0l-0.1-0.5l-0.3,0v-0.2l0.2,0l0-0.3l-0.3,0 v-0.2l0.2,0L44.2,21.5"
}), /*#__PURE__*/React.createElement("path", {
  className: "sty10",
  d: "M41.4,23.7c0.3-0.1,0.3-0.4,0.2-0.5c-0.2-0.1-0.5,0.1-0.4,0.4C41.2,23.7,41.3,23.7,41.4,23.7 M41.4,22.9 c0.5-0.1,0.7,0.3,0.5,0.7c-0.3,0.4-0.9,0.5-1,0.1C40.8,23.4,41.1,23,41.4,22.9 M42.8,22.5c0.3-0.1,0.3-0.4,0.2-0.5 c-0.2-0.1-0.5,0.1-0.4,0.3C42.6,22.5,42.7,22.5,42.8,22.5 M42.8,21.8c0.5-0.1,0.7,0.4,0.5,0.7c-0.3,0.4-0.9,0.4-1,0 C42.2,22.2,42.5,21.8,42.8,21.8 M41.6,22c0.4,0.5,0.8,1.1,1.2,1.6l-0.2,0.2c-0.4-0.5-0.8-1.1-1.2-1.6L41.6,22"
}), /*#__PURE__*/React.createElement("path", {
  className: "sty10",
  d: "M39.4,22.3c0.3,0.4,0.7,1.1,0,2.3l0,0c-0.1,0-0.2,0-0.3-0.1c0.5-0.9,0.5-1.4,0-2L39.4,22.3"
}), /*#__PURE__*/React.createElement("path", {
  className: "sty10",
  d: "M37.9,22.8c0.1,0,0.2,0,0.3,0.1c-0.4,0.9-0.4,1.4,0,2l-0.3,0.2C37.7,24.9,37.2,24.2,37.9,22.8L37.9,22.8 "
}), /*#__PURE__*/React.createElement("path", {
  className: "sty10",
  d: "M45.4,24.4C45.4,24.4,45.4,24.4,45.4,24.4c0,0.1-0.1,0.2-0.2,0.3c-0.3-0.2-0.6-0.1-0.7,0.2 c0.2,0,0.5-0.1,0.7,0c-0.4,0.1-0.7,0.1-1.1,0.2v-0.1c0-0.3,0.2-0.5,0.8-0.6C45,24.3,45.2,24.3,45.4,24.4"
}), /*#__PURE__*/React.createElement("path", {
  className: "sty10",
  d: "M42.8,25.2c-0.1-0.2-0.5-0.1-0.7,0.1v0C42.4,25.3,42.6,25.3,42.8,25.2C42.8,25.2,42.8,25.2,42.8,25.2  M43.2,23.9c0,0.4,0,0.9,0,1.2c-0.5,0.1-1,0.2-1.5,0.3v0c0.2-0.8,0.9-0.8,1.1-0.6l0,0V24L43.2,23.9"
}), /*#__PURE__*/React.createElement("path", {
  className: "sty10",
  d: "M40.9,25.6c0-0.1-0.2-0.4-0.7-0.3c-0.2,0.1-0.3,0.1-0.5,0.3c0.1,0.1,0.2,0.1,0.3,0.2 c0.1-0.2,0.4-0.2,0.5,0C40.7,25.7,40.8,25.7,40.9,25.6C40.9,25.6,40.9,25.6,40.9,25.6"
}), /*#__PURE__*/React.createElement("path", {
  className: "sty10",
  d: "M38.5,26.4C38.4,26.4,38.4,26.4,38.5,26.4l-0.1,0C38.4,26.4,38.4,26.4,38.5,26.4L38.5,26.4 M38.3,26 c0.1-0.1,0.1-0.2,0.2-0.3c0-0.1-0.1-0.1-0.1-0.1c-0.2,0-0.3,0.2-0.2,0.3C38.1,26,38.2,26,38.3,26 M37.6,26.5l0.2,0.1 c-0.1,0.1-0.3,0.1-0.4,0.2l-0.2-0.1L37.6,26.5 M39,26.2L39,26.2c-0.4,0.1-0.8,0.3-1.1,0.4l0.2-0.3c-0.6-0.1-0.3-0.7,0-0.9 c0.1-0.1,0.2-0.1,0.3-0.1c0.4-0.1,0.7,0.2,0.3,0.8C38.7,26.1,38.9,26.1,39,26.2"
}), /*#__PURE__*/React.createElement("polyline", {
  className: "sty10",
  points: "42.2,17.4 42.9,17.2 42.9,17.5 42.2,17.7 42.2,17.4  "
}), /*#__PURE__*/React.createElement("polyline", {
  className: "sty10",
  points: "39.7,17.5 40.1,17.4 40.4,17.7 40.6,17.3 41.1,17.2 40.7,17.8 41.2,18.4 40.7,18.5 40.4,18.2  40.1,18.7 39.6,18.8 40.1,18 39.7,17.5  "
}), /*#__PURE__*/React.createElement("path", {
  className: "sty10",
  d: "M37.8,17.9c0.2,0.4,0.4,1,0.6,1.4l-0.2,0.1c-0.2-0.4-0.4-1-0.6-1.4L37.8,17.9"
}), /*#__PURE__*/React.createElement("path", {
  className: "sty10",
  d: "M36.8,8.8L36.2,9V8.8c-0.1,0-0.2,0.1-0.3,0.1v0.2l-0.5,0.2v0.3l0.5-0.2V10l0.3-0.1V9.3l0.5-0.2V8.8"
}), /*#__PURE__*/React.createElement("path", {
  className: "sty10",
  d: "M36.4,12.2c0.2-0.1,0.3,0.1,0.2,0.3c-0.1,0.2-0.4,0.3-0.4,0.1C36.1,12.5,36.2,12.3,36.4,12.2 M36.2,11 l0.4-0.1c0,0.4,0,0.9,0,1.2l-0.4,0.1C36.2,11.8,36.2,11.4,36.2,11"
}), /*#__PURE__*/React.createElement("path", {
  className: "sty10",
  d: "M34.6,13c0.2-0.1,0.3,0.1,0.2,0.2c-0.1,0.2-0.3,0.3-0.4,0.2S34.4,13.1,34.6,13 M34.6,11.6 c0.3-0.2,0.5-0.1,0.6,0.3c-0.1,0.1-0.3,0.1-0.4,0.2c0-0.2-0.3-0.1-0.3,0c-0.2,0.2,0,0.3,0.1,0.3c0.2,0.1,0.2,0.1,0.2,0.2v0.1 l-0.4,0.2c0-0.1,0-0.2-0.1-0.2c-0.2-0.1-0.3-0.1-0.3-0.4C34.1,12,34.3,11.8,34.6,11.6"
}), /*#__PURE__*/React.createElement("path", {
  className: "sty10",
  d: "M32.5,12.8l0.3-0.2l0.5,0.2l-0.2,0.3L32.8,13c0,0.4,0,1,0,1.4l-0.3,0.2C32.5,14,32.5,13.3,32.5,12.8"
}), /*#__PURE__*/React.createElement("path", {
  className: "sty10",
  d: "M30.9,15.2c0.4-0.3,0.3-1.2,0.1-1.2c0,0-0.2,0-0.3,0.4c0,0.2-0.1,0.7,0,0.8 C30.8,15.3,30.8,15.3,30.9,15.2 M30.9,13.7c0.8-0.4,0.5,1.1,0.5,1.1c-0.2,0.7-0.7,1.1-0.9,0.8C30.3,15.3,30.2,14.1,30.9,13.7"
}), /*#__PURE__*/React.createElement("path", {
  className: "sty10",
  d: "M36.4,14.7l0-0.3l-0.2,0.1l0,0.3L36.4,14.7 M35.7,13.9l0.2-0.1l0.1,0.5l0.2-0.1l-0.1-0.5l0.2-0.1 l0.1,0.5l0.2-0.1v0.2l-0.2,0.1l0,0.3l0.2-0.1v0.2l-0.2,0.1l0.1,0.5l-0.2,0.1l-0.1-0.5L36.1,15l0.1,0.5l-0.2,0.1l-0.1-0.5 l-0.2,0.1V15l0.2-0.1l0-0.3l-0.2,0.1v-0.2l0.2-0.1L35.7,13.9"
}), /*#__PURE__*/React.createElement("path", {
  className: "sty10",
  d: "M33.4,16.6c0.2-0.1,0.3-0.5,0.1-0.5c-0.2,0-0.4,0.3-0.3,0.5C33.3,16.6,33.4,16.6,33.4,16.6 M33.4,15.8 c0.4-0.2,0.5,0.1,0.4,0.5c-0.2,0.5-0.7,0.7-0.8,0.4C32.9,16.5,33.1,16,33.4,15.8 M34.6,15.1c0.2-0.1,0.3-0.4,0.1-0.5 c-0.2,0-0.4,0.3-0.3,0.5C34.5,15.2,34.5,15.2,34.6,15.1 M34.6,14.4c0.4-0.2,0.5,0.2,0.4,0.5c-0.2,0.4-0.7,0.7-0.9,0.3 C34.1,15,34.3,14.5,34.6,14.4 M33.6,14.8c0.6,0.9,0.6,0.9,1,1.4l-0.2,0.2c-0.7-0.9-0.7-0.9-1-1.4L33.6,14.8"
}), /*#__PURE__*/React.createElement("path", {
  className: "sty10",
  d: "M31.8,15.6c0.3,0.3,0.5,0.9,0,2.3l0,0c-0.1,0-0.2,0-0.2,0c0.4-0.9,0.4-1.5,0-2L31.8,15.6"
}), /*#__PURE__*/React.createElement("path", {
  className: "sty10",
  d: "M30.7,16.4c0.1,0,0.1,0,0.2,0c-0.3,0.9-0.3,1.5,0,2l-0.2,0.3C30.5,18.4,30.1,17.9,30.7,16.4L30.7,16.4"
}), /*#__PURE__*/React.createElement("path", {
  className: "sty10",
  d: "M36.3,17.6c0.2-0.1,0.2-0.3,0.1-0.3c-0.1,0-0.2,0-0.3,0.1l-0.1,0c0,0.1,0,0.2,0.1,0.2 C36.2,17.6,36.3,17.6,36.3,17.6 M36.3,16.6c0.3-0.1,0.4-0.1,0.5,0c-0.1,0.1-0.1,0.2-0.2,0.3c-0.2-0.1-0.5,0.1-0.5,0.3 c1.1-0.4,0.9,0.2,0.8,0.3c-0.1,0.3-0.6,0.5-0.8,0.3l0,0v0.2l-0.3,0.1C35.7,17,35.7,16.8,36.3,16.6"
}), /*#__PURE__*/React.createElement("path", {
  className: "sty10",
  d: "M34.3,18.4c0.3-0.2,0.3-0.6,0.2-0.7c-0.3-0.1-0.5,0.4-0.4,0.6C34.1,18.5,34.3,18.4,34.3,18.4 M34.6,16.7 l0.4-0.2c0,0.5,0,1.3,0,1.9c0,0,0,0.1,0,0.1l-0.3,0.2v-0.2c-0.4,0.6-0.9,0.5-0.9,0.1c-0.1-0.7,0.6-1.3,0.9-1.1l0,0l0,0 L34.6,16.7"
}), /*#__PURE__*/React.createElement("path", {
  className: "sty10",
  d: "M32.4,18.4c0.6-0.3,0.7,0.2,0.5,0.6c-0.2,0.5-0.7,0.9-0.9,0.8c0.1-0.1,0.1-0.3,0.2-0.4 c0.2,0.1,0.5-0.2,0.4-0.5c0-0.2-0.3-0.1-0.4,0c0,0,0,0,0,0c-0.1,0-0.1-0.1-0.2-0.1C32.2,18.6,32.4,18.5,32.4,18.4"
}), /*#__PURE__*/React.createElement("path", {
  className: "sty10",
  d: "M31,20.3c0.2-0.1,0.3-0.4,0.1-0.5c0,0,0,0-0.1,0c-0.1,0.2-0.2,0.4-0.3,0.5C30.8,20.4,30.9,20.4,31,20.3  M30.9,19.5c0-0.1,0.1-0.2,0.1-0.3c0-0.1,0-0.1-0.1-0.1c-0.1,0-0.3,0.3-0.1,0.4C30.9,19.5,30.9,19.5,30.9,19.5 M30.9,18.8 c0.5-0.3,0.5,0.1,0.4,0.3c0,0.1-0.1,0.2-0.1,0.3c0.4-0.1,0.4,0.4,0.1,0.8c-0.1,0.1-0.5,0.6-0.8,0.4l-0.1,0.2l-0.4,0.3l0.3-0.7 l-0.3-0.3l0.3-0.2l0.1,0.1c0.1-0.1,0.1-0.3,0.2-0.4c-0.4,0-0.3-0.6,0-0.9C30.8,18.9,30.9,18.8,30.9,18.8"
}), /*#__PURE__*/React.createElement("polyline", {
  className: "sty10",
  points: "34.1,10.1 34.6,9.8 34.6,10.1 34.1,10.4 34.1,10.1  "
}), /*#__PURE__*/React.createElement("path", {
  className: "sty10",
  d: "M32.8,10.9l0.3-0.7c-0.1,0.1-0.3,0.1-0.4,0.2l-0.1,0.3l-0.1-0.2c-0.1,0.1-0.2,0.1-0.4,0.2l0.3,0.3L32,12 l0.4-0.2l0.2-0.5l0.2,0.3l0.4-0.2L32.8,10.9"
}), /*#__PURE__*/React.createElement("path", {
  className: "sty10",
  d: "M30.7,11.7c-0.1,0-0.1,0.1-0.2,0.1c0.1,0.3,0.3,0.7,0.4,1l0.2-0.2C30.9,12.4,30.8,12,30.7,11.7"
}), /*#__PURE__*/React.createElement("polyline", {
  className: "sty10",
  points: "35.9,18.7 36.2,18.5 36.2,19 36.8,18.8 36.8,19.2 36.2,19.4 36.2,19.9 35.9,20 35.9,19.5  35.4,19.7 35.4,19.4 35.9,19.2 35.9,18.7  "
}), /*#__PURE__*/React.createElement("path", {
  className: "sty10",
  d: "M36.4,22.3c0.2-0.1,0.3,0.1,0.2,0.3c-0.1,0.2-0.4,0.3-0.4,0.1C36.1,22.6,36.2,22.4,36.4,22.3 M36.2,21 l0.4-0.1c0,0.4,0,0.9,0,1.2l-0.4,0.1C36.2,21.9,36.2,21.4,36.2,21"
}), /*#__PURE__*/React.createElement("path", {
  className: "sty10",
  d: "M34.6,23.1c0.2-0.1,0.3,0.1,0.2,0.2c-0.1,0.2-0.3,0.3-0.4,0.2C34.3,23.4,34.4,23.2,34.6,23.1 M34.6,21.7 c0.3-0.2,0.5-0.1,0.6,0.3c-0.1,0.1-0.3,0.1-0.4,0.2c0-0.2-0.3-0.1-0.3,0c-0.2,0.2,0,0.3,0.1,0.3c0.2,0.1,0.2,0.1,0.2,0.2v0.1 L34.4,23c0-0.1,0-0.2-0.1-0.2c-0.2-0.1-0.3-0.1-0.3-0.4C34.1,22.1,34.3,21.8,34.6,21.7"
}), /*#__PURE__*/React.createElement("path", {
  className: "sty10",
  d: "M32.5,22.9l0.3-0.2l0.5,0.2l-0.2,0.3l-0.3-0.1c0,0.4,0,1,0,1.4l-0.3,0.2C32.5,24.1,32.5,23.4,32.5,22.9"
}), /*#__PURE__*/React.createElement("path", {
  className: "sty10",
  d: "M30.9,25.3c0.4-0.3,0.3-1.2,0.1-1.2c0,0-0.2,0-0.3,0.4c0,0.2-0.1,0.7,0,0.8 C30.8,25.4,30.8,25.4,30.9,25.3 M30.9,23.8c0.8-0.4,0.5,1.1,0.5,1.1c-0.2,0.7-0.7,1.1-0.9,0.8C30.3,25.4,30.2,24.2,30.9,23.8"
}), /*#__PURE__*/React.createElement("path", {
  className: "sty10",
  d: "M36.4,24.8l0-0.3l-0.2,0.1l0,0.3L36.4,24.8 M35.7,24l0.2-0.1l0.1,0.5l0.2-0.1l-0.1-0.5l0.2-0.1l0.1,0.5 l0.2-0.1v0.2l-0.2,0.1l0,0.3l0.2-0.1v0.2l-0.2,0.1l0.1,0.5l-0.2,0.1L36.4,25l-0.2,0.1l0.1,0.5l-0.2,0.1l-0.1-0.5l-0.2,0.1 v-0.2l0.2-0.1l0-0.3l-0.2,0.1v-0.2l0.2-0.1L35.7,24"
}), /*#__PURE__*/React.createElement("path", {
  className: "sty10",
  d: "M33.4,26.6c0.2-0.1,0.3-0.5,0.1-0.5c-0.2,0-0.4,0.3-0.3,0.5C33.3,26.7,33.4,26.7,33.4,26.6 M33.4,25.9 c0.4-0.2,0.5,0.1,0.4,0.5c-0.2,0.5-0.7,0.7-0.8,0.4C32.9,26.6,33.1,26.1,33.4,25.9 M34.6,25.2c0.2-0.1,0.3-0.4,0.1-0.5 c-0.2,0-0.4,0.3-0.3,0.5C34.5,25.2,34.5,25.2,34.6,25.2 M34.6,24.4c0.4-0.2,0.5,0.2,0.4,0.5c-0.2,0.4-0.7,0.7-0.9,0.3 C34.1,25.1,34.3,24.6,34.6,24.4 M33.6,24.9c0.6,0.9,0.6,0.9,1,1.4l-0.2,0.2c-0.7-0.9-0.7-0.9-1-1.4L33.6,24.9"
}), /*#__PURE__*/React.createElement("path", {
  className: "sty10",
  d: "M31.8,25.7c0.3,0.3,0.5,0.9,0,2.3l0,0c-0.1,0-0.2,0-0.2,0c0.4-0.9,0.4-1.5,0-2L31.8,25.7"
}), /*#__PURE__*/React.createElement("path", {
  className: "sty10",
  d: "M30.7,26.4c0.1,0,0.1,0,0.2,0c-0.3,0.9-0.3,1.5,0,2l-0.2,0.3C30.5,28.5,30.1,27.9,30.7,26.4L30.7,26.4"
}), /*#__PURE__*/React.createElement("path", {
  className: "sty10",
  d: "M36.7,26.6C36.8,26.6,36.8,26.6,36.7,26.6c0,0.1-0.1,0.2-0.1,0.3c-0.2-0.1-0.5,0-0.5,0.3 c0.2-0.1,0.4-0.2,0.5-0.2c-0.3,0.1-0.6,0.2-0.9,0.4v-0.1c0-0.3,0.1-0.6,0.6-0.8C36.4,26.6,36.6,26.6,36.7,26.6"
}), /*#__PURE__*/React.createElement("path", {
  className: "sty10",
  d: "M34.6,27.9c-0.1-0.2-0.4,0-0.5,0.2c0,0,0,0.1,0,0.1C34.2,28.1,34.4,28,34.6,27.9 C34.6,27.9,34.6,27.9,34.6,27.9 M35,26.6c0,0.4,0,0.9,0,1.2c-0.4,0.2-0.9,0.4-1.2,0.6v0c0.1-0.8,0.7-0.9,0.9-0.8l0,0v-0.8 L35,26.6"
}), /*#__PURE__*/React.createElement("path", {
  className: "sty10",
  d: "M33,28.7c0-0.1-0.1-0.4-0.6-0.2c-0.2,0.1-0.3,0.2-0.4,0.4c0.1,0,0.1,0.1,0.2,0.1 c0.1-0.2,0.3-0.3,0.4-0.1c0,0,0,0,0,0C32.8,28.8,32.9,28.8,33,28.7C33.1,28.7,33,28.7,33,28.7"
}), /*#__PURE__*/React.createElement("path", {
  className: "sty10",
  d: "M31.1,29.9C31.1,29.9,31,29.9,31.1,29.9L31,30C31,29.9,31,29.9,31.1,29.9L31.1,29.9 M30.9,29.6 c0.3-0.5,0-0.4,0-0.4c-0.1,0-0.3,0.3-0.1,0.4C30.9,29.6,30.9,29.6,30.9,29.6 M30.4,30.1l0.1,0.1c-0.1,0.1-0.2,0.2-0.3,0.2 l-0.1-0.1L30.4,30.1 M31.5,29.6L31.5,29.6c-0.3,0.2-0.6,0.4-0.9,0.6l0.2-0.3c-0.4,0-0.3-0.7,0.1-1c0,0,0.1-0.1,0.2-0.1 c0.5-0.2,0.3,0.4,0.3,0.5c0,0.1-0.1,0.1-0.1,0.2C31.3,29.5,31.4,29.5,31.5,29.6"
}), /*#__PURE__*/React.createElement("polyline", {
  className: "sty10",
  points: "34.1,20.2 34.6,19.9 34.6,20.2 34.1,20.5 34.1,20.2  "
}), /*#__PURE__*/React.createElement("polyline", {
  className: "sty10",
  points: "32,20.8 32.4,20.6 32.6,20.8 32.8,20.4 33.2,20.2 32.8,21 33.3,21.4 32.9,21.6 32.6,21.3  32.4,21.9 32,22.1 32.4,21.2 32,20.8  "
}), /*#__PURE__*/React.createElement("path", {
  className: "sty10",
  d: "M30.6,21.5c0.1,0.4,0.3,0.9,0.5,1.2L30.9,23c-0.1-0.4-0.3-0.9-0.5-1.2L30.6,21.5"
}), /*#__PURE__*/React.createElement("path", {
  className: "sty10",
  d: "M29.8,12.6l-0.4,0.3v-0.2c-0.1,0.1-0.2,0.1-0.2,0.2v0.2l-0.4,0.3v0.3l0.4-0.3v0.5l0.2-0.2v-0.5l0.4-0.3 V12.6"
}), /*#__PURE__*/React.createElement("path", {
  className: "sty10",
  d: "M29.5,16.1c0.1-0.1,0.2,0,0.2,0.2c0,0.2-0.2,0.4-0.3,0.3C29.3,16.5,29.3,16.2,29.5,16.1 M29.3,14.9 l0.3-0.2c0,0.4,0,0.9,0,1.2l-0.3,0.2C29.3,15.8,29.3,15.3,29.3,14.9"
}), /*#__PURE__*/React.createElement("path", {
  className: "sty10",
  d: "M28.2,17.2c0.1-0.1,0.2,0,0.2,0.1c0,0.2-0.2,0.4-0.3,0.3C27.9,17.6,28.1,17.3,28.2,17.2 M28.2,15.8 c0.3-0.2,0.4-0.2,0.4,0.2c-0.1,0.1-0.2,0.2-0.3,0.3c0-0.2-0.2,0-0.2,0c0,0-0.2,0.3,0,0.4c0.1,0.1,0.1,0.1,0.1,0.2V17L28,17.2 c0-0.1,0-0.2-0.1-0.2c-0.1,0-0.2-0.1-0.2-0.4C27.8,16.3,28,16,28.2,15.8"
}), /*#__PURE__*/React.createElement("path", {
  className: "sty10",
  d: "M26.7,17.3l0.2-0.2l0.4,0.1l-0.1,0.4l-0.2-0.1c0,0.4,0,1,0,1.4l-0.2,0.2C26.7,18.6,26.5,17.8,26.7,17.3"
}), /*#__PURE__*/React.createElement("path", {
  className: "sty10",
  d: "M25.6,20.1c0.2-0.3,0.2-1.2,0.1-1.2c0,0-0.1,0-0.2,0.4c0,0.2,0,0.7,0,0.8C25.5,20.1,25.6,20.1,25.6,20.1  M25.6,18.6c0.1-0.1,0.3-0.3,0.3,0.2c0.1,1.1-0.4,1.9-0.6,1.8C25.2,20.4,25.2,19.1,25.6,18.6"
}), /*#__PURE__*/React.createElement("path", {
  className: "sty10",
  d: "M29.5,18.6l0-0.3l-0.2,0.1l0,0.3L29.5,18.6 M29,17.9l0.2-0.1l0.1,0.5l0.2-0.1l-0.1-0.5l0.2-0.1l0.1,0.5 l0.2-0.1v0.2l-0.2,0.1l0,0.3l0.2-0.1v0.2l-0.2,0.1l0.1,0.5l-0.1,0l-0.1-0.5l-0.2,0.1l0.1,0.5l-0.2,0.1l-0.1-0.5l-0.2,0.1V19 l0.2-0.1l0-0.2l-0.2,0.1v-0.2l0.2-0.1L29,17.9"
}), /*#__PURE__*/React.createElement("path", {
  className: "sty10",
  d: "M27.3,21c0.2-0.2,0.2-0.5,0.1-0.5c-0.2,0-0.3,0.5-0.2,0.6C27.3,21,27.3,21,27.3,21 M27.3,20.2 c0.2-0.2,0.3,0,0.3,0.2c0,0.5-0.4,1-0.5,0.8C26.9,21.1,27.1,20.5,27.3,20.2 M28.2,19.3c0.2-0.2,0.2-0.5,0.1-0.5 c-0.1,0-0.3,0.4-0.2,0.5C28.1,19.4,28.1,19.4,28.2,19.3 M28.2,18.6c0.3-0.2,0.4,0,0.3,0.3c-0.1,0.5-0.4,1-0.6,0.7 C27.7,19.4,27.9,18.8,28.2,18.6 M27.5,19.1c0.4,0.8,0.4,0.8,0.7,1.2l-0.1,0.2c-0.4-0.7-0.4-0.8-0.7-1.2L27.5,19.1"
}), /*#__PURE__*/React.createElement("path", {
  className: "sty10",
  d: "M26.2,20.3c0.2,0.3,0.4,0.8,0,2.3l0,0c0,0-0.1,0-0.1,0c0.2-1,0.2-1.5,0-2L26.2,20.3"
}), /*#__PURE__*/React.createElement("path", {
  className: "sty10",
  d: "M25.5,21.2c0,0,0.1,0,0.1,0c-0.2,1-0.2,1.6,0,2l-0.1,0.3C25.3,23.1,25.3,22.3,25.5,21.2L25.5,21.2"
}), /*#__PURE__*/React.createElement("path", {
  className: "sty10",
  d: "M29.5,21.4c0.1-0.1,0.2-0.3,0.1-0.3c-0.1,0-0.2,0.1-0.2,0.1l-0.1,0.1c0,0.1,0,0.2,0,0.2 C29.3,21.6,29.4,21.5,29.5,21.4 M29.4,20.5c0.2-0.2,0.3-0.1,0.4-0.1c0,0.1-0.1,0.2-0.2,0.3c-0.2-0.1-0.4,0.1-0.4,0.4 c0.5-0.4,0.7-0.3,0.6,0c-0.1,0.4-0.5,0.8-0.6,0.6l0,0v0.2L29,22.1C29,21,29,20.8,29.4,20.5"
}), /*#__PURE__*/React.createElement("path", {
  className: "sty10",
  d: "M28,22.7c0.3-0.2,0.2-0.7,0.1-0.7c-0.2,0-0.4,0.6-0.3,0.7C27.8,22.7,27.9,22.7,28,22.7 M28.2,20.8 l0.3-0.2c0,0.5,0,1.3,0,1.9c0,0,0,0.1,0,0.1l-0.2,0.2v-0.2c-0.3,0.7-0.5,0.6-0.6,0.4c-0.2-0.5,0.3-1.5,0.5-1.4c0,0,0,0,0,0 l0,0V20.8"
}), /*#__PURE__*/React.createElement("path", {
  className: "sty10",
  d: "M26.6,23c0.3-0.3,0.4,0,0.4,0.2c0,0.7-0.5,1.3-0.7,1.2c0-0.1,0.1-0.3,0.1-0.4c0.1,0.1,0.3-0.3,0.3-0.6 c0-0.2-0.1-0.1-0.2,0c0,0-0.1,0.1-0.1,0.2c0,0-0.1-0.1-0.1-0.1C26.5,23.2,26.6,23.1,26.6,23"
}), /*#__PURE__*/React.createElement("path", {
  className: "sty10",
  d: "M25.7,25.1c0.1-0.1,0.1-0.3,0.1-0.4c0-0.2,0-0.1-0.1-0.1c0,0.2-0.1,0.4-0.2,0.5 C25.6,25.2,25.6,25.2,25.7,25.1 M25.6,24.3c0.2-0.5,0-0.4,0-0.4C25.6,24,25.5,24.3,25.6,24.3C25.6,24.3,25.6,24.3,25.6,24.3  M25.6,23.6c0.2-0.3,0.3-0.1,0.3,0c0,0.2,0,0.4-0.1,0.7c0.2-0.1,0.2,0.2,0.2,0.6c-0.1,0.3-0.4,0.9-0.6,0.8l-0.1,0.3l-0.2,0.3 l0.2-0.7l-0.2-0.2l0.2-0.3l0.1,0.1c0-0.1,0.1-0.3,0.1-0.4c-0.3,0.1-0.2-0.6,0-0.9C25.6,23.7,25.6,23.6,25.6,23.6"
}), /*#__PURE__*/React.createElement("polyline", {
  className: "sty10",
  points: "27.8,14.4 28.2,14 28.2,14.3 27.8,14.7 27.8,14.4  "
}), /*#__PURE__*/React.createElement("path", {
  className: "sty10",
  d: "M26.9,15.4l0.2-0.7c-0.1,0.1-0.2,0.2-0.3,0.3l-0.1,0.3l-0.1-0.1c-0.1,0.1-0.2,0.2-0.2,0.3l0.2,0.3 l-0.3,1l0.3-0.3l0.2-0.6L27,16l0.3-0.3L26.9,15.4"
}), /*#__PURE__*/React.createElement("path", {
  className: "sty10",
  d: "M25.5,16.6c0,0.1-0.1,0.1-0.1,0.2c0.1,0.3,0.2,0.7,0.2,1l0.1-0.2C25.6,17.2,25.6,16.9,25.5,16.6"
}), /*#__PURE__*/React.createElement("polyline", {
  className: "sty10",
  points: "29.1,22.6 29.4,22.4 29.4,23 29.8,22.7 29.8,23 29.4,23.3 29.4,23.8 29.1,24 29.1,23.5  28.7,23.8 28.7,23.5 29.1,23.1 29.1,22.6  "
}), /*#__PURE__*/React.createElement("path", {
  className: "sty10",
  d: "M29.5,26.2c0.1-0.1,0.2,0,0.2,0.2c0,0.2-0.2,0.4-0.3,0.3C29.3,26.6,29.3,26.3,29.5,26.2 M29.3,25 l0.3-0.2c0,0.4,0,0.9,0,1.2l-0.3,0.2C29.3,25.8,29.3,25.3,29.3,25"
}), /*#__PURE__*/React.createElement("path", {
  className: "sty10",
  d: "M28.2,27.3c0.1-0.1,0.2,0,0.2,0.1c0,0.2-0.2,0.4-0.3,0.3C27.9,27.7,28.1,27.4,28.2,27.3 M28.2,25.9 c0.3-0.2,0.4-0.2,0.4,0.2c-0.1,0.1-0.2,0.2-0.3,0.3c0-0.2-0.2,0-0.2,0c0,0-0.2,0.3,0,0.4c0.1,0.1,0.1,0.1,0.1,0.2V27L28,27.3 c0-0.1,0-0.2-0.1-0.2c-0.1,0-0.2-0.1-0.2-0.4C27.8,26.3,28,26.1,28.2,25.9"
}), /*#__PURE__*/React.createElement("path", {
  className: "sty10",
  d: "M26.7,27.4l0.2-0.2l0.4,0.1l-0.1,0.4l-0.2-0.1c0,0.4,0,1,0,1.4l-0.2,0.2C26.7,28.7,26.5,27.9,26.7,27.4"
}), /*#__PURE__*/React.createElement("path", {
  className: "sty10",
  d: "M25.6,30.1c0.2-0.3,0.2-1.2,0.1-1.2c0,0-0.1,0-0.2,0.4c0,0.2,0,0.7,0,0.8C25.5,30.2,25.6,30.2,25.6,30.1  M25.6,28.6c0.1-0.1,0.3-0.3,0.3,0.2c0.1,1.1-0.4,1.9-0.6,1.8C25.2,30.5,25.2,29.2,25.6,28.6"
}), /*#__PURE__*/React.createElement("path", {
  className: "sty10",
  d: "M29.5,28.7l0-0.3l-0.2,0.1l0,0.3L29.5,28.7 M29,28l0.2-0.1l0.1,0.5l0.2-0.1l-0.1-0.5l0.2-0.1l0.1,0.5 l0.2-0.1v0.2l-0.1,0.1l0,0.3l0.2-0.1v0.2l-0.2,0.1l0.1,0.5l-0.2,0.1l-0.1-0.5L29.3,29l0.1,0.5l-0.2,0.1l-0.1-0.5l-0.2,0.1V29 l0.2-0.1l0-0.3l-0.2,0.1v-0.2l0.2-0.1L29,28"
}), /*#__PURE__*/React.createElement("path", {
  className: "sty10",
  d: "M27.3,31c0.2-0.2,0.2-0.5,0.1-0.5c-0.2,0-0.3,0.5-0.2,0.6C27.3,31.1,27.3,31.1,27.3,31 M27.3,30.3 c0.2-0.2,0.3,0,0.3,0.2c0,0.5-0.4,1-0.5,0.8C26.9,31.2,27.1,30.5,27.3,30.3 M28.2,29.4c0.2-0.2,0.2-0.5,0.1-0.5 c-0.1,0-0.3,0.4-0.2,0.5C28.1,29.4,28.1,29.4,28.2,29.4 M28.2,28.6c0.3-0.2,0.4,0,0.3,0.3c-0.1,0.5-0.4,1-0.6,0.7 C27.7,29.5,27.9,28.9,28.2,28.6 M27.5,29.2c0.4,0.8,0.4,0.8,0.7,1.2l-0.1,0.2c-0.4-0.7-0.4-0.8-0.7-1.2L27.5,29.2"
}), /*#__PURE__*/React.createElement("path", {
  className: "sty10",
  d: "M26.2,30.3c0.2,0.3,0.4,0.8,0,2.3l0,0c0,0-0.1,0-0.1,0c0.2-1,0.2-1.5,0-2L26.2,30.3"
}), /*#__PURE__*/React.createElement("path", {
  className: "sty10",
  d: "M25.5,31.3c0,0,0.1,0,0.1,0c-0.2,1-0.2,1.6,0,2l-0.1,0.3C25.3,33.1,25.3,32.4,25.5,31.3L25.5,31.3"
}), /*#__PURE__*/React.createElement("path", {
  className: "sty10",
  d: "M29.8,30.4L29.8,30.4c0,0.1-0.1,0.2-0.1,0.3c-0.2-0.1-0.4,0.1-0.4,0.4c0.1-0.1,0.3-0.2,0.4-0.3 c-0.2,0.2-0.4,0.3-0.7,0.5v-0.1c0-0.3,0.1-0.6,0.5-0.9C29.5,30.4,29.6,30.4,29.8,30.4"
}), /*#__PURE__*/React.createElement("path", {
  className: "sty10",
  d: "M28.2,32.1c-0.1-0.2-0.2,0-0.3,0.1c-0.1,0.1-0.1,0.2-0.1,0.2C27.9,32.4,28.1,32.2,28.2,32.1L28.2,32.1  M28.4,30.7c0,0.4,0,0.9,0,1.2c-0.3,0.3-0.6,0.5-0.9,0.8v0c0.1-0.8,0.5-1.1,0.6-1l0,0v-0.8L28.4,30.7"
}), /*#__PURE__*/React.createElement("path", {
  className: "sty10",
  d: "M27.1,33.1c0-0.1-0.1-0.4-0.4-0.1c-0.1,0.1-0.2,0.2-0.2,0.4c0,0,0.1,0.1,0.1,0.1 c0.1-0.2,0.2-0.3,0.3-0.2c0,0,0,0,0,0.1C26.9,33.4,27,33.3,27.1,33.1C27.1,33.2,27.1,33.2,27.1,33.1"
}), /*#__PURE__*/React.createElement("path", {
  className: "sty10",
  d: "M25.8,34.7L25.8,34.7L25.8,34.7C25.7,34.7,25.8,34.7,25.8,34.7L25.8,34.7 M25.6,34.4 c0.2-0.5,0-0.4,0-0.4C25.6,34,25.5,34.4,25.6,34.4C25.6,34.4,25.6,34.4,25.6,34.4 M25.3,35l0.1,0.1c-0.1,0.1-0.1,0.2-0.2,0.3 l-0.1-0.1L25.3,35 M26,34.4L26,34.4c-0.2,0.2-0.4,0.5-0.5,0.8l0.1-0.4c-0.3,0.1-0.2-0.6,0-1c0,0,0.1-0.1,0.1-0.1 c0.2-0.2,0.3-0.1,0.2,0.2c0,0.2,0,0.3-0.1,0.5C25.9,34.3,26,34.3,26,34.4"
}), /*#__PURE__*/React.createElement("polyline", {
  className: "sty10",
  points: "27.8,24.4 28.2,24.1 28.2,24.4 27.8,24.7 27.8,24.4  "
}), /*#__PURE__*/React.createElement("polyline", {
  className: "sty10",
  points: "26.4,25.5 26.6,25.2 26.8,25.4 26.9,24.9 27.2,24.6 26.9,25.4 27.2,25.8 27,26.1 26.8,25.8  26.6,26.5 26.3,26.7 26.6,25.8 26.4,25.5  "
}), /*#__PURE__*/React.createElement("path", {
  className: "sty10",
  d: "M25.4,26.4c0.1,0.3,0.2,0.8,0.3,1.2l-0.1,0.2c-0.1-0.3-0.2-0.8-0.3-1.2L25.4,26.4"
}), /*#__PURE__*/React.createElement("path", {
  className: "sty10",
  d: "M25,17.6L24.7,18v-0.2c0,0.1-0.1,0.1-0.1,0.2v0.2l-0.2,0.4v0.3l0.2-0.4v0.5l0.1-0.2v-0.5l0.2-0.4 L25,17.6"
}), /*#__PURE__*/React.createElement("path", {
  className: "sty10",
  d: "M24.8,21.2c0.1-0.1,0.1,0,0.1,0c0,0.2-0.1,0.5-0.2,0.5C24.6,21.7,24.7,21.3,24.8,21.2 M24.7,20l0.2-0.3 c0,0.4,0,0.9,0,1.2l-0.2,0.3C24.7,20.8,24.6,20.4,24.7,20"
}), /*#__PURE__*/React.createElement("path", {
  className: "sty10",
  d: "M24,22.5C24.1,22.4,24.1,22.4,24,22.5c0.1,0.1,0,0.5-0.1,0.5C23.9,23,24,22.7,24,22.5 M24,21.1 c0-0.1,0.1-0.3,0.2-0.1c0,0.1,0,0.1,0,0.2c0,0.1-0.1,0.2-0.1,0.3c0-0.1,0-0.1,0-0.1c-0.1,0-0.2,0.4-0.1,0.5 c0.1,0.1,0.1,0.1,0.1,0.2v0.1L24,22.5c0-0.1,0-0.2,0-0.2c0,0-0.1,0-0.1-0.3C23.9,21.7,24,21.3,24,21.1"
}), /*#__PURE__*/React.createElement("path", {
  className: "sty10",
  d: "M23.3,22.9l0.1-0.3l0.2,0.1l-0.1,0.4l-0.1-0.1c0,0.4,0,1,0,1.4l-0.1,0.3C23.3,24.2,23.2,23.4,23.3,22.9"
}), /*#__PURE__*/React.createElement("path", {
  className: "sty10",
  d: "M23,25.9c0.1-0.4,0.1-1.2,0-1.2C22.9,24.7,22.9,25.8,23,25.9C23,25.9,23,25.9,23,25.9 M23,24.4 c0-0.1,0-0.2,0.1-0.2c0.1,0.1,0,2-0.1,2.2l0,0C22.9,26.2,22.9,24.9,23,24.4"
}), /*#__PURE__*/React.createElement("path", {
  className: "sty10",
  d: "M24.8,23.7l0-0.3l-0.1,0.2l0,0.3L24.8,23.7 M24.5,23.1l0.1-0.2l0,0.4l0.1-0.2l0-0.4l0.1-0.2l0,0.4 l0.1-0.2v0.2l-0.1,0.1l0,0.3l0.1-0.2v0.2l-0.1,0.1l0,0.4l-0.1,0.2l0-0.4L24.7,24l0,0.4l-0.1,0.2l0-0.4l-0.1,0.2v-0.2l0.1-0.1 l0-0.2l-0.1,0.2v-0.2l0.1-0.1L24.5,23.1"
}), /*#__PURE__*/React.createElement("path", {
  className: "sty10",
  d: "M23.7,26.4c0.1-0.2,0.1-0.6,0-0.5C23.6,25.9,23.6,26.5,23.7,26.4C23.6,26.5,23.6,26.5,23.7,26.4  M23.7,25.7c0.1-0.1,0.1-0.2,0.1-0.1c0.1,0.2-0.1,1.3-0.2,1.2C23.4,26.8,23.5,26,23.7,25.7 M24.1,24.6c0.1-0.2,0.1-0.6,0-0.5 C24,24.1,23.9,24.6,24.1,24.6C24,24.7,24,24.7,24.1,24.6 M24.1,23.9c0.1-0.2,0.1-0.1,0.2-0.1c0.1,0.3-0.1,1.2-0.3,1.2 C23.8,25,23.9,24.2,24.1,23.9 M23.7,24.6c0.2,0.7,0.2,0.7,0.3,1.1L24,25.9c-0.2-0.7-0.2-0.7-0.3-1.1L23.7,24.6"
}), /*#__PURE__*/React.createElement("path", {
  className: "sty10",
  d: "M23.2,25.9c0.1,0.4,0.1,1.1,0,2.2l0,0c0,0,0,0-0.1,0c0.1-0.9,0.1-1.5,0-2L23.2,25.9"
}), /*#__PURE__*/React.createElement("path", {
  className: "sty10",
  d: "M22.9,27C22.9,27,23,27,22.9,27c-0.1,1.4,0,1.8,0,1.9l0,0.3C22.8,28.8,22.9,27.6,22.9,27L22.9,27"
}), /*#__PURE__*/React.createElement("path", {
  className: "sty10",
  d: "M24.8,26.6c0.1-0.1,0.1-0.3,0-0.3c0,0-0.1,0.1-0.1,0.2l0,0.1C24.6,26.6,24.6,26.7,24.8,26.6 C24.7,26.6,24.7,26.6,24.8,26.6 M24.7,25.6c0.1-0.2,0.2-0.2,0.2-0.2c0,0.1-0.1,0.2-0.1,0.3c-0.1-0.1-0.2,0.2-0.2,0.5 c0.1-0.1,0.3-0.5,0.3-0.3c0.1,0.3-0.2,1-0.3,0.9l0,0l0,0V27l-0.1,0.2C24.5,26.2,24.5,25.9,24.7,25.6"
}), /*#__PURE__*/React.createElement("path", {
  className: "sty10",
  d: "M23.9,28c0.1-0.3,0.1-0.7,0.1-0.7C23.9,27.3,23.8,28,23.9,28C23.9,28.1,23.9,28,23.9,28 M24,26.2 l0.1-0.3c0,0.5,0,1.3,0,1.9c0,0,0,0.1,0,0.1L24,28.1v-0.2c-0.2,0.8-0.3,0.6-0.3,0.6C23.6,28.3,23.8,27,24,27c0,0,0,0,0,0l0,0 L24,26.2"
}), /*#__PURE__*/React.createElement("path", {
  className: "sty10",
  d: "M23.3,28.6c0-0.1,0.1-0.3,0.1-0.2c0.1,0.2-0.1,1.6-0.2,1.6l0,0c0-0.1,0-0.3,0.1-0.4l0,0l0,0 c0.1-0.1,0.2-0.8,0.1-0.8c-0.1,0-0.1,0.2-0.1,0.3c0,0,0,0-0.1-0.1C23.3,28.8,23.3,28.7,23.3,28.6"
}), /*#__PURE__*/React.createElement("path", {
  className: "sty10",
  d: "M23,30.9c0-0.2,0.1-0.5,0-0.5l0,0C23,30.5,23,30.8,23,30.9C23,31,23,31,23,30.9 M23,30.1 c0-0.2,0-0.4,0-0.4l0,0C23,29.7,22.9,30.1,23,30.1L23,30.1 M23,29.4c0-0.2,0-0.2,0.1-0.2c0.1,0,0,0.6,0,0.8c0,0,0,0,0,0 c0.1,0.1-0.1,1.4-0.1,1.5l0,0l0,0.3l-0.1,0.4l0-0.8l0-0.2l0-0.3l0,0.1c0-0.1,0-0.3,0-0.4l0,0l0,0C22.9,30.4,22.9,29.8,23,29.4 "
}), /*#__PURE__*/React.createElement("polyline", {
  className: "sty10",
  points: "23.9,19.8 24.1,19.3 24.1,19.6 23.9,20.1 23.9,19.8  "
}), /*#__PURE__*/React.createElement("path", {
  className: "sty10",
  d: "M23.4,20.9l0.1-0.8c0,0.1-0.1,0.2-0.1,0.3L23.4,20.9l-0.1-0.2c0,0.1-0.1,0.2-0.1,0.3l0.1,0.2l-0.1,1 l0.1-0.3l0.1-0.6l0.1,0.2l0.1-0.3L23.4,20.9"
}), /*#__PURE__*/React.createElement("path", {
  className: "sty10",
  d: "M22.9,22.4c0,0.1,0,0.1,0,0.2c0,0.3,0,0.6,0.1,0.9l0-0.2C23,23,22.9,22.7,22.9,22.4"
}), /*#__PURE__*/React.createElement("polyline", {
  className: "sty10",
  points: "24.6,27.7 24.7,27.5 24.7,28 25,27.7 25,28 24.7,28.4 24.7,28.9 24.6,29.1 24.6,28.6 24.3,29  24.3,28.7 24.6,28.3 24.6,27.7  "
}), /*#__PURE__*/React.createElement("path", {
  className: "sty10",
  d: "M24.8,31.3c0.1-0.1,0.1,0,0.1,0c0,0.2-0.1,0.5-0.2,0.5C24.6,31.7,24.7,31.4,24.8,31.3 M24.7,30.1 l0.2-0.3c0,0.4,0,0.9,0,1.2l-0.2,0.3C24.7,30.9,24.6,30.4,24.7,30.1"
}), /*#__PURE__*/React.createElement("path", {
  className: "sty10",
  d: "M24,32.6C24.1,32.5,24.1,32.5,24,32.6c0.1,0.1,0,0.5-0.1,0.5C23.9,33.1,24,32.7,24,32.6 M24,31.2 c0-0.1,0.1-0.3,0.2-0.1c0,0.1,0,0.1,0,0.2c0,0.1-0.1,0.2-0.1,0.3c0-0.1,0-0.1,0-0.1C24,31.6,23.9,32,24,32 c0.1,0.1,0.1,0.1,0.1,0.2v0.1L24,32.6c0-0.1,0-0.2,0-0.2c0,0-0.1,0-0.1-0.3C23.9,31.7,24,31.4,24,31.2"
}), /*#__PURE__*/React.createElement("path", {
  className: "sty10",
  d: "M23.3,33l0.1-0.3l0.2,0.1l-0.1,0.4l-0.1,0c0,0.4,0,1,0,1.4l-0.1,0.3C23.3,34.3,23.2,33.5,23.3,33"
}), /*#__PURE__*/React.createElement("path", {
  className: "sty10",
  d: "M23,35.9c0.1-0.4,0.1-1.2,0-1.2C22.9,34.7,22.9,35.9,23,35.9C23,36,23,36,23,35.9 M23,34.4 c0-0.1,0-0.2,0.1-0.2c0.1,0.1,0,2-0.1,2.2l0,0C22.9,36.3,22.9,35,23,34.4"
}), /*#__PURE__*/React.createElement("path", {
  className: "sty10",
  d: "M24.8,33.7l0-0.3l-0.1,0.2l0,0.3L24.8,33.7 M24.5,33.2l0.1-0.2l0,0.4l0.1-0.2l0-0.4l0.1-0.2l0,0.4 l0.1-0.2v0.2l-0.1,0.1l0,0.3l0.1-0.2v0.2l-0.1,0.1l0,0.4l-0.1,0.2l0-0.4l-0.1,0.2l0,0.4l-0.1,0.2l0-0.4l-0.1,0.2v-0.2l0.1-0.1 l0-0.3L24.4,34v-0.2l0.1-0.1L24.5,33.2"
}), /*#__PURE__*/React.createElement("path", {
  className: "sty10",
  d: "M23.7,36.5c0.1-0.2,0.1-0.6,0-0.5C23.6,36,23.6,36.5,23.7,36.5C23.6,36.6,23.6,36.6,23.7,36.5  M23.7,35.7c0.1-0.1,0.1-0.2,0.1-0.1c0.1,0.2-0.1,1.3-0.2,1.2C23.4,36.9,23.5,36.1,23.7,35.7 M24.1,34.7 c0.1-0.2,0.1-0.6,0-0.5C24,34.2,23.9,34.7,24.1,34.7C24,34.7,24,34.7,24.1,34.7 M24.1,33.9c0.1-0.2,0.1-0.1,0.2-0.1 c0.1,0.3-0.1,1.2-0.3,1.2C23.8,35,23.9,34.3,24.1,33.9 M23.7,34.7c0.2,0.7,0.2,0.7,0.3,1.1L24,36c-0.2-0.7-0.2-0.7-0.3-1.1 L23.7,34.7"
}), /*#__PURE__*/React.createElement("path", {
  className: "sty10",
  d: "M23.2,36c0.1,0.4,0.1,1.1,0,2.2l0,0c0,0,0,0-0.1,0c0.1-0.9,0.1-1.5,0-2L23.2,36"
}), /*#__PURE__*/React.createElement("path", {
  className: "sty10",
  d: "M22.9,37.1C22.9,37.1,23,37.1,22.9,37.1c-0.1,1.4,0,1.8,0,1.9l0,0.3C22.8,38.9,22.9,37.6,22.9,37.1 L22.9,37.1"
}), /*#__PURE__*/React.createElement("path", {
  className: "sty10",
  d: "M24.9,35.4C25,35.4,25,35.5,24.9,35.4c0,0.1,0,0.2-0.1,0.4c-0.1-0.1-0.2,0.2-0.2,0.5 c0.1-0.1,0.2-0.3,0.2-0.3c-0.1,0.2-0.3,0.4-0.4,0.7v-0.1c0-0.4,0.1-0.6,0.3-1C24.8,35.5,24.9,35.4,24.9,35.4"
}), /*#__PURE__*/React.createElement("path", {
  className: "sty10",
  d: "M24,37.4C24,37.3,24,37.3,24,37.4c-0.1,0-0.2,0.1-0.2,0.4C23.9,37.7,24,37.6,24,37.4L24,37.4 M24.2,35.9 c0,0.4,0,0.9,0,1.2c-0.2,0.3-0.3,0.7-0.4,1v0C23.8,37.2,24,37,24,37l0,0l0,0v-0.8L24.2,35.9"
}), /*#__PURE__*/React.createElement("path", {
  className: "sty10",
  d: "M23.5,38.7c0-0.2,0-0.2-0.1-0.2c0,0-0.1,0.1-0.1,0.2c0,0.1-0.1,0.3-0.1,0.5c0,0,0,0,0.1,0.1 c0-0.2,0.1-0.3,0.1-0.3l0,0c0,0,0,0,0,0.1C23.5,38.9,23.5,38.8,23.5,38.7C23.5,38.7,23.5,38.7,23.5,38.7"
}), /*#__PURE__*/React.createElement("path", {
  className: "sty10",
  d: "M23,40.4C23,40.5,23,40.5,23,40.4l0,0.1C23,40.5,23,40.5,23,40.4L23,40.4 M23,40.2c0-0.2,0-0.4,0-0.4 l0,0C23,39.8,22.9,40.2,23,40.2L23,40.2 M22.9,40.9l0,0.1c0,0.1,0,0.2-0.1,0.3v-0.1L22.9,40.9 M23.1,40.1 C23.1,40.1,23.1,40.1,23.1,40.1c-0.1,0.3-0.1,0.6-0.2,0.9l0-0.4c0,0,0,0,0,0c0,0,0-0.7,0.1-1.2c0-0.1,0-0.1,0-0.1 C23.1,39.3,23,39.9,23.1,40.1C23,40.1,23,40,23.1,40.1L23.1,40.1C23.1,40,23.1,40.1,23.1,40.1"
}), /*#__PURE__*/React.createElement("polyline", {
  className: "sty10",
  points: "23.9,29.8 24.1,29.4 24.1,29.7 23.9,30.1 23.9,29.8  "
}), /*#__PURE__*/React.createElement("polyline", {
  className: "sty10",
  points: "23.2,31.1 23.3,30.8 23.4,31 23.4,30.4 23.6,30.1 23.4,31 23.6,31.3 23.4,31.6 23.4,31.4  23.3,32.1 23.2,32.4 23.3,31.4 23.2,31.1  "
}), /*#__PURE__*/React.createElement("path", {
  className: "sty10",
  d: "M22.9,32.2c0,0.3,0.1,0.8,0.1,1.1l0,0.2c0-0.3-0.1-0.8-0.1-1.1L22.9,32.2"
}), /*#__PURE__*/React.createElement("path", {
  className: "sty10",
  d: "M22.8,23.5l0,0.4v-0.2c0,0.1,0,0.2,0,0.3v0.2v0.4V25v-0.4v0.5v-0.3v-0.5l0-0.4V23.5"
}), /*#__PURE__*/React.createElement("path", {
  className: "sty10",
  d: "M22.8,27.2C22.8,27.1,22.8,27.1,22.8,27.2c0,0,0,0.5,0,0.5S22.8,27.3,22.8,27.2 M22.8,26l0-0.3 c0,0.4,0,0.9,0,1.2l0,0.3C22.8,26.8,22.8,26.4,22.8,26"
}), /*#__PURE__*/React.createElement("path", {
  className: "sty10",
  d: "M22.8,29.7v-0.3V29.7v0.2V29.7 M22.8,29.1v-0.2v0.4V29.1v-0.4v-0.2v0.4l0-0.2V29L22.8,29.1l0,0.3l0-0.2 v0.2v0.2v0.4l0,0.2v-0.4V30v0.4v0.2v-0.4v0.2v-0.2V30v-0.3V30v-0.2v-0.2L22.8,29.1"
}), /*#__PURE__*/React.createElement("path", {
  className: "sty10",
  d: "M22.8,32.5c0-0.2,0-0.3,0-0.3c0,0,0,0,0,0.2L22.8,32.5c0,0.1,0,0.1,0,0.1C22.8,32.6,22.8,32.6,22.8,32.5  M22.8,31.5c0-0.2,0-0.2,0-0.2l0,0c0,0.1,0,0.3,0,0.4l0,0c0,0.1,0,0.5,0,0.5c0-0.3,0-0.4,0-0.4c0,0.1,0,1,0,1.1c0,0,0,0,0,0 l0,0V33v0.3C22.8,32.1,22.8,31.9,22.8,31.5"
}), /*#__PURE__*/React.createElement("polyline", {
  className: "sty10",
  points: "22.8,33.7 22.8,33.5 22.8,34 22.8,33.6 22.8,33.9 22.8,34.4 22.8,34.9 22.8,35.1 22.8,34.6  22.7,35 22.7,34.7 22.8,34.3 22.8,33.7  "
}), /*#__PURE__*/React.createElement("path", {
  className: "sty10",
  d: "M22.8,37.2C22.8,37.2,22.8,37.2,22.8,37.2c0,0,0,0.5,0,0.5S22.8,37.4,22.8,37.2 M22.8,36l0-0.3 c0,0.4,0,0.9,0,1.2l0,0.3C22.8,36.9,22.8,36.4,22.8,36"
}), /*#__PURE__*/React.createElement("path", {
  className: "sty10",
  d: "M22.8,39.7v-0.3V39.7v0.2V39.7 M22.8,39.2V39v0.4V39.2v-0.4v-0.2V39l0-0.2V39L22.8,39.2l0,0.3l0-0.2v0.2 v0.2v0.4l0,0.2v-0.4v0.2v0.4v0.2v-0.4v0.2v-0.2v-0.2v-0.3V40v-0.2v-0.2L22.8,39.2"
}), /*#__PURE__*/React.createElement("path", {
  className: "sty10",
  d: "M22.8,41.4v0.4l0,0c0,0,0,0.4,0,0.5c0-0.1,0-0.3,0-0.4c0,0.2,0,0.5,0,0.7v-0.1c0-0.5,0-0.8,0-1 C22.8,41.4,22.8,41.4,22.8,41.4"
}), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  className: "sty10",
  d: "M50.8,6.1h0.7V5.9c0.1,0,0.3,0,0.4,0v0.2l0.7,0v0.3l-0.7,0V7h-0.4V6.4h-0.7V6.1"
}), /*#__PURE__*/React.createElement("path", {
  className: "sty10",
  d: "M51.8,9.4c-0.3,0-0.4,0.2-0.2,0.4C51.7,10,52,9.9,52,9.7C52.1,9.5,51.9,9.4,51.8,9.4 M52,8.1h-0.5 c0,0.4,0,0.9,0,1.2H52C52,8.9,52,8.4,52,8.1"
}), /*#__PURE__*/React.createElement("path", {
  className: "sty10",
  d: "M51.4,11.9l0.1-0.3h0.3l-0.1,0.3H51.4 M52.2,10.8h-0.3l-0.1,0.5h-0.3l0.1-0.5h-0.3l-0.1,0.5h-0.3v0.2 h0.3l-0.1,0.3h-0.3v0.2H51l-0.1,0.5h0.3l0.1-0.5h0.3l-0.1,0.5h0.3l0.1-0.5h0.3v-0.2H52l0.1-0.3h0.3v-0.2h-0.3L52.2,10.8"
}), /*#__PURE__*/React.createElement("path", {
  className: "sty10",
  d: "M51.4,14.8c-0.2,0-0.3-0.1-0.2-0.2c0.1-0.1,0.3-0.1,0.4-0.1h0.1c0,0.1,0,0.2-0.1,0.2 C51.6,14.7,51.5,14.8,51.4,14.8 M51.5,13.7c-0.4,0-0.6,0.1-0.7,0.2c0.1,0.1,0.2,0.1,0.2,0.2c0.3-0.2,0.7-0.2,0.7,0.1 c-0.2,0-0.7,0-0.9,0.1c-0.2,0.2-0.2,0.4-0.1,0.5c0.2,0.2,0.7,0.2,1,0l0,0V15h0.4c0-0.9,0-0.9-0.1-1 C52,13.7,51.7,13.7,51.5,13.7"
}), /*#__PURE__*/React.createElement("polyline", {
  className: "sty10",
  points: "51.9,15.8 51.6,15.8 51.6,16.2 51.1,16.2 51.1,16.5 51.6,16.5 51.6,16.9 51.9,16.9 51.9,16.5  52.5,16.4 52.5,16.2 51.9,16.2 51.9,15.8  "
}), /*#__PURE__*/React.createElement("path", {
  className: "sty10",
  d: "M51.7,19.5c-0.3,0-0.4,0.2-0.2,0.4c0.2,0.2,0.5,0.1,0.5-0.1C52,19.6,51.9,19.5,51.7,19.5 M52,18.2h-0.5 c0,0.4,0,0.9,0,1.2H52C52,19,52,18.5,52,18.2"
}), /*#__PURE__*/React.createElement("path", {
  className: "sty10",
  d: "M51.4,22l0.1-0.3h0.3L51.7,22H51.4 M52.2,20.9h-0.3l-0.1,0.5h-0.3l0.1-0.5h-0.3l-0.1,0.5h-0.3v0.2h0.3 L51.1,22h-0.3v0.2H51l-0.1,0.5h0.3l0.1-0.5h0.3l-0.1,0.5h0.3l0.1-0.5h0.3V22H52l0.1-0.3h0.3v-0.2h-0.3L52.2,20.9"
}), /*#__PURE__*/React.createElement("path", {
  className: "sty10",
  d: "M50.9,23.9C50.8,23.9,50.8,24,50.9,23.9c0,0.1,0.1,0.2,0.2,0.2c0.3-0.2,0.7-0.2,0.7,0.1 c-0.2,0-0.5,0-0.7,0.1c0.4,0,0.8,0,1.2,0v-0.1c-0.1-0.4-0.3-0.5-0.8-0.5C51.3,23.8,51.1,23.8,50.9,23.9"
}))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  className: "sty10",
  d: "M80.8,26.9v1.5v-0.1C80.8,27.8,80.8,27.4,80.8,26.9"
}), /*#__PURE__*/React.createElement("path", {
  className: "sty10",
  d: "M80.8,29.5c0,0.5,0,1,0,1.6V29.5"
}), /*#__PURE__*/React.createElement("path", {
  className: "sty10",
  d: "M80.8,32.1v0.3v0C80.8,32.3,80.8,32.2,80.8,32.1 M80.8,32.8v0.7v0v-0.4v-0.1v-0.8v0.3V32.8"
}), /*#__PURE__*/React.createElement("path", {
  className: "sty10",
  d: "M80.8,24.5C80.8,24.5,80.8,24.5,80.8,24.5v0.2V24.5"
}), /*#__PURE__*/React.createElement("path", {
  className: "sty10",
  d: "M80.8,37v1.5v-0.1C80.8,37.9,80.8,37.4,80.8,37"
}), /*#__PURE__*/React.createElement("path", {
  className: "sty10",
  d: "M80.8,39.6c0,0.5,0,1,0,1.6V39.6"
}), /*#__PURE__*/React.createElement("path", {
  className: "sty10",
  d: "M80.8,42.1v0.3v0C80.8,42.3,80.8,42.2,80.8,42.1 M80.8,42.9L80.8,42.9c0,0,0-0.1,0-0.2v-0.3v0.3V42.9"
}), /*#__PURE__*/React.createElement("polyline", {
  className: "sty10",
  points: "80.8,34.3 80.8,34.2 80.8,34.8 80.8,34.3  "
}), /*#__PURE__*/React.createElement("path", {
  className: "sty10",
  d: "M80.8,24l0-0.4v-0.2c0-0.1,0-0.2,0-0.2v0.2l-0.1-0.4v0.3l0.1,0.4v0.5l0,0.2v-0.5l0,0.4V24"
}), /*#__PURE__*/React.createElement("path", {
  className: "sty10",
  d: "M80.8,27c0,0.2,0,0.5,0,0.5C80.8,27.5,80.8,27,80.8,27C80.8,26.9,80.8,26.9,80.8,27 M80.8,25.5l0,0.3 c0,0.4,0,0.9,0,1.2l0-0.3C80.8,26.3,80.8,25.8,80.8,25.5"
}), /*#__PURE__*/React.createElement("path", {
  className: "sty10",
  d: "M80.6,25.5c0,0.2,0,0.5,0,0.5C80.6,26.1,80.5,25.5,80.6,25.5C80.5,25.5,80.5,25.5,80.6,25.5 M80.5,24.1 c0,0.2,0.1,0.5,0.1,1.1c0-0.1-0.1-0.2-0.1-0.3c0-0.2,0-0.4-0.1-0.4c0,0,0,0.2,0,0.4c0,0.3,0,0.4,0,0.6v0.1l-0.1-0.3 c0-0.1,0-0.2,0-0.3c-0.1-0.6-0.1-1,0-1C80.5,24,80.5,24,80.5,24.1"
}), /*#__PURE__*/React.createElement("path", {
  className: "sty10",
  d: "M80.1,22.4l0.1,0.3l0.1,1l-0.1,0.1l-0.1-0.6c0,0.4,0,1,0,1.4L80,24.2C80.1,23.7,80.1,23,80.1,22.4"
}), /*#__PURE__*/React.createElement("path", {
  className: "sty10",
  d: "M79.4,22.5C79.5,22.5,79.5,22.6,79.4,22.5c0.2-0.2,0-1.3-0.1-1.2C79.3,21.3,79.3,22.2,79.4,22.5  M79.4,21c0.3,0.7,0.3,2.1,0.1,2c-0.3-0.1-0.5-2.1-0.3-2.2C79.3,20.8,79.4,20.9,79.4,21"
}), /*#__PURE__*/React.createElement("path", {
  className: "sty10",
  d: "M80.8,29.4v-0.3l0-0.2v0.3L80.8,29.4 M80.7,27.9l0,0.2v0.6l0,0.2v-0.6l0,0.2v0.6v0.2v0.2v-0.2v0.3v0.2 v0.2V30v0.6v-0.2v-0.6l0-0.2v0.6l0-0.2v-0.6l0-0.2v-0.2l0,0.2v-0.3l0-0.2v-0.2l0,0.2L80.7,27.9"
}), /*#__PURE__*/React.createElement("path", {
  className: "sty10",
  d: "M80.3,27.6C80.3,27.6,80.4,27.6,80.3,27.6c0.1,0,0-0.5,0-0.5C80.2,27,80.3,27.4,80.3,27.6 M80.3,26.8 c0.1,0.4,0.1,1.2,0.1,1.1c-0.1,0-0.2-1.2-0.1-1.3C80.3,26.7,80.3,26.7,80.3,26.8 M80.6,27.7C80.6,27.7,80.6,27.8,80.6,27.7 L80.6,27.7c0.1,0,0-0.5,0-0.5C80.5,27.2,80.5,27.5,80.6,27.7 M80.6,26.9c0.1,0.4,0.1,1.1,0,1.1c-0.1-0.1-0.2-1.2-0.1-1.3 C80.5,26.8,80.5,26.8,80.6,26.9 M80.4,26.1c0.1,1.6,0.1,1.7,0.2,2.6l0,0C80.4,27,80.4,27,80.4,26.1L80.4,26.1"
}), /*#__PURE__*/React.createElement("path", {
  className: "sty10",
  d: "M79.8,24.3c0.1,0.8,0.2,1.8,0,2.3l0,0c0-0.1-0.1-0.3-0.1-0.4C79.9,25.7,79.8,24.6,79.8,24.3L79.8,24.3"
}), /*#__PURE__*/React.createElement("path", {
  className: "sty10",
  d: "M79.3,23.3c0,0.1,0.1,0.3,0.1,0.4c-0.2,0.5-0.1,1.4,0,1.9l-0.1,0C79.2,24.6,79.1,23.8,79.3,23.3 L79.3,23.3"
}), /*#__PURE__*/React.createElement("path", {
  className: "sty10",
  d: "M80.8,32.3C80.8,32.3,80.8,32.4,80.8,32.3c0,0.1,0-0.2,0-0.5v-0.1C80.8,31.9,80.8,32,80.8,32.3  M80.8,31.2c0,0.2,0,0.4,0,0.7v0c0-0.2,0-0.4,0-0.5c0,0,0,0,0,0.1c0.1,0.5,0.1,1.2,0,1.2c0,0,0-0.4,0-0.7l0,0v0.2l0-0.3 c0-1,0-1,0-1C80.8,31,80.8,31,80.8,31.2"
}), /*#__PURE__*/React.createElement("path", {
  className: "sty10",
  d: "M80.5,30.6c0,0.1,0,0.1,0,0.1l0,0c0-0.1,0-0.8-0.1-0.8C80.4,29.9,80.4,30.3,80.5,30.6 M80.6,29.2 l0.1,0.3c0,0.5,0,1.3,0,1.9c0,0,0,0.1,0,0.1l-0.1-0.3V31l0,0l0,0c-0.1-0.1-0.2-1.4-0.1-1.6c0,0,0,0,0,0 c0.1,0.1,0.1,0.3,0.1,0.6l0,0L80.6,29.2"
}), /*#__PURE__*/React.createElement("path", {
  className: "sty10",
  d: "M80,28c0.2,0.6,0.2,1.6,0.1,1.5c-0.1,0-0.2-0.3-0.2-0.7c0,0,0.1-0.1,0.1-0.1c0,0.3,0.1,0.3,0.1,0.3 c0.1-0.1,0-0.7-0.1-0.8l0,0c0-0.1-0.1-0.3-0.1-0.4C80,27.8,80,27.9,80,28"
}), /*#__PURE__*/React.createElement("path", {
  className: "sty10",
  d: "M79.5,27.7C79.5,27.8,79.6,27.8,79.5,27.7c0.1-0.1,0-0.3,0-0.4c0,0-0.1,0.1-0.1,0.1 C79.4,27.5,79.4,27.6,79.5,27.7 M79.4,26.8c0,0,0.1,0,0-0.2c0-0.2-0.1-0.3-0.1-0.3C79.4,26.3,79.3,26.3,79.4,26.8 M79.4,26.1 c0.2,0.4,0.3,1,0.1,1.1c0,0.2,0.1,0.5,0.1,0.7c0,0.1,0,0.3-0.1,0.3c0,0-0.2-0.1-0.3-0.8l-0.1,0.1L79,27.1l0.2-0.1l-0.1-0.8 l0.2,0.3l0.1,0.4c0,0,0.1-0.1,0.1-0.1c-0.2-0.7-0.1-1,0-0.9C79.4,25.9,79.4,26,79.4,26.1"
}), /*#__PURE__*/React.createElement("polyline", {
  className: "sty10",
  points: "80.5,21.9 80.6,22.4 80.6,22.8 80.5,22.2 80.5,21.9  "
}), /*#__PURE__*/React.createElement("path", {
  className: "sty10",
  d: "M80.2,21l0.1-0.2c0-0.1-0.1-0.2-0.1-0.3l0,0.1l0-0.4c0-0.1-0.1-0.2-0.1-0.3l0.1,0.8L79.9,21l0.1,0.3 l0.1-0.2l0.1,0.6l0.1,0.3L80.2,21"
}), /*#__PURE__*/React.createElement("path", {
  className: "sty10",
  d: "M79.3,18.6c0-0.1-0.1-0.1-0.1-0.2c0.1,0.5,0.1,1.2,0.2,1.6l0.1,0.1C79.4,19.7,79.5,19.1,79.3,18.6"
}), /*#__PURE__*/React.createElement("polyline", {
  className: "sty10",
  points: "80.8,32.8 80.8,33.1 80.8,33.6 80.8,34.1 80.8,34.4 80.8,33.9 80.8,34.5 80.8,34.3 80.8,33.7  80.7,33.3 80.7,33 80.8,33.4 80.8,32.8  "
}), /*#__PURE__*/React.createElement("path", {
  className: "sty10",
  d: "M80.8,37c0,0.2,0,0.5,0,0.5C80.8,37.6,80.8,37,80.8,37C80.8,37,80.8,37,80.8,37 M80.8,35.6l0,0.3 c0,0.4,0,0.9,0,1.2l0-0.3C80.8,36.4,80.8,35.9,80.8,35.6"
}), /*#__PURE__*/React.createElement("path", {
  className: "sty10",
  d: "M80.6,35.6c0,0.2,0,0.5,0,0.5C80.6,36.1,80.5,35.6,80.6,35.6C80.5,35.6,80.5,35.6,80.6,35.6 M80.5,34.2 c0,0.2,0.1,0.5,0.1,1.1c0-0.1-0.1-0.2-0.1-0.3c0-0.2,0-0.4-0.1-0.4c0,0,0,0.2,0,0.4c0,0.3,0,0.4,0,0.6v0.1l-0.1-0.3 c0-0.1,0-0.2,0-0.3c-0.1-0.6-0.1-1,0-1C80.5,34,80.5,34,80.5,34.2"
}), /*#__PURE__*/React.createElement("path", {
  className: "sty10",
  d: "M80.1,32.5l0.1,0.3l0.1,1l-0.1,0.1l-0.1-0.6c0,0.4,0,1,0,1.4L80,34.3C80.1,33.7,80.1,33,80.1,32.5"
}), /*#__PURE__*/React.createElement("path", {
  className: "sty10",
  d: "M79.4,32.5C79.5,32.6,79.5,32.6,79.4,32.5c0.2-0.2,0-1.3-0.1-1.2C79.3,31.4,79.3,32.3,79.4,32.5  M79.4,31c0.3,0.7,0.3,2.1,0.1,2C79.2,33,79,31,79.3,30.9C79.3,30.9,79.4,31,79.4,31"
}), /*#__PURE__*/React.createElement("path", {
  className: "sty10",
  d: "M80.8,39.5v-0.3l0-0.2v0.3L80.8,39.5 M80.7,37.9l0,0.2v0.6l0,0.2v-0.6l0,0.2v0.6v0.2v0.2v-0.2v0.3V40 v0.2V40v0.6v-0.2v-0.6l0-0.2v0.6l0-0.2v-0.6l0-0.2V39l0,0.2v-0.3l0-0.2v-0.2l0,0.2L80.7,37.9"
}), /*#__PURE__*/React.createElement("path", {
  className: "sty10",
  d: "M80.3,37.6C80.3,37.7,80.4,37.7,80.3,37.6c0.1,0,0-0.5,0-0.5C80.2,37.1,80.3,37.4,80.3,37.6 M80.3,36.9 c0.1,0.4,0.1,1.2,0.1,1.1c-0.1,0-0.2-1.2-0.1-1.3C80.3,36.7,80.3,36.8,80.3,36.9 M80.6,37.8C80.6,37.8,80.6,37.8,80.6,37.8 L80.6,37.8c0.1,0,0-0.5,0-0.5C80.5,37.2,80.5,37.6,80.6,37.8 M80.6,37c0.1,0.4,0.1,1.1,0,1.1c-0.1-0.1-0.2-1.2-0.1-1.3 C80.5,36.9,80.5,36.9,80.6,37 M80.4,36.1c0.1,1.6,0.1,1.7,0.2,2.6l0,0C80.4,37.1,80.4,37,80.4,36.1L80.4,36.1"
}), /*#__PURE__*/React.createElement("path", {
  className: "sty10",
  d: "M79.8,34.4c0.1,0.8,0.2,1.8,0,2.3l0,0c0-0.1-0.1-0.3-0.1-0.4C79.9,35.8,79.8,34.7,79.8,34.4L79.8,34.4"
}), /*#__PURE__*/React.createElement("path", {
  className: "sty10",
  d: "M79.3,33.3c0,0.1,0.1,0.3,0.1,0.4c-0.2,0.5-0.1,1.4,0,1.9l-0.1,0C79.2,34.7,79.1,33.8,79.3,33.3 L79.3,33.3"
}), /*#__PURE__*/React.createElement("path", {
  className: "sty10",
  d: "M80.8,41.8c0,0,0,0.1,0,0.1c0-0.1,0-0.4,0-0.5c0,0,0,0,0,0.1c0,0.1,0,0.3,0,0.5c0-0.2,0-0.5-0.1-0.7 v-0.1c0-0.2,0-0.2,0-0.2s0,0,0,0.3C80.8,41.4,80.8,41.5,80.8,41.8"
}), /*#__PURE__*/React.createElement("path", {
  className: "sty10",
  d: "M80.6,40.4c0-0.3-0.1-0.5-0.1-0.5c0,0,0,0,0,0.1C80.5,40.1,80.5,40.3,80.6,40.4 C80.6,40.4,80.6,40.4,80.6,40.4 M80.6,39.5c0,0.4,0,0.9,0,1.2c-0.1-0.3-0.1-0.7-0.2-1l0,0c0-0.2,0-0.2,0-0.2c0,0,0,0,0.1,0.2 c0,0.1,0,0.3,0.1,0.4v-0.8L80.6,39.5"
}), /*#__PURE__*/React.createElement("path", {
  className: "sty10",
  d: "M80.2,39.1c0-0.2,0-0.6-0.2-1c-0.1-0.1-0.1-0.2-0.1-0.2c0,0.1,0.1,0.3,0.1,0.4l0,0 c0.1,0,0.1,0.3,0.1,0.5C80.2,38.9,80.2,39,80.2,39.1C80.2,39.1,80.2,39.1,80.2,39.1"
}), /*#__PURE__*/React.createElement("path", {
  className: "sty10",
  d: "M79.5,37.4c0,0,0-0.1,0-0.1l0,0C79.5,37.4,79.5,37.4,79.5,37.4L79.5,37.4 M79.4,36.9c0,0,0.1,0,0-0.2 c0-0.2-0.1-0.3-0.1-0.3C79.4,36.4,79.3,36.4,79.4,36.9 M79.2,36.6l0.1,0.3c-0.1-0.1-0.1-0.2-0.2-0.3l-0.1-0.3L79.2,36.6  M79.7,37.8C79.7,37.8,79.7,37.8,79.7,37.8c-0.1-0.2-0.2-0.5-0.4-0.8l0.1-0.1c-0.2-0.6-0.1-0.9-0.1-0.9c0.1,0,0.1,0.1,0.2,0.2 c0.2,0.4,0.2,0.9,0.1,1C79.6,37.3,79.7,37.5,79.7,37.8"
}), /*#__PURE__*/React.createElement("polyline", {
  className: "sty10",
  points: "80.5,32 80.6,32.5 80.6,32.8 80.5,32.3 80.5,32  "
}), /*#__PURE__*/React.createElement("polyline", {
  className: "sty10",
  points: "79.9,29.8 80,30.2 80.1,30.7 80.1,30.5 80.3,30.8 80.2,31.1 80.3,32.1 80.2,31.8 80.1,31.1  80,31.4 79.9,31 80,30.7 79.9,29.8  "
}), /*#__PURE__*/React.createElement("path", {
  className: "sty10",
  d: "M79.3,28.2c0.1,0.6,0.2,1.4,0.2,2l-0.1-0.1c-0.1-0.6-0.2-1.4-0.2-2L79.3,28.2"
}), /*#__PURE__*/React.createElement("path", {
  className: "sty10",
  d: "M78.9,18l-0.2-0.4v-0.2c0-0.1-0.1-0.1-0.1-0.2v0.2L78.2,17v0.3l0.3,0.4v0.5l0.1,0.2v-0.5l0.2,0.4V18"
}), /*#__PURE__*/React.createElement("path", {
  className: "sty10",
  d: "M78.7,21c0.1,0.2,0.1,0.5,0,0.5c-0.1,0-0.2-0.5-0.1-0.6C78.7,21,78.7,21,78.7,21 M78.6,19.6l0.2,0.3 c0,0.4,0,0.9,0,1.2l-0.2-0.3C78.6,20.4,78.6,19.9,78.6,19.6"
}), /*#__PURE__*/React.createElement("path", {
  className: "sty10",
  d: "M77.8,19.8c0.1,0.2,0.2,0.5,0.1,0.5C77.7,20.2,77.6,19.8,77.8,19.8C77.8,19.7,77.8,19.8,77.8,19.8  M77.8,18.4c0.2,0.3,0.3,0.6,0.3,1c-0.1-0.1-0.2-0.2-0.2-0.3c0-0.3-0.2-0.5-0.2-0.3c0,0.1,0,0.2,0.1,0.4 c0.1,0.3,0.1,0.3,0.1,0.5v0.1l-0.2-0.3c0-0.3-0.2-0.7-0.2-1c0-0.4,0.2-0.2,0.2-0.2C77.8,18.3,77.8,18.3,77.8,18.4"
}), /*#__PURE__*/React.createElement("path", {
  className: "sty10",
  d: "M76.5,16.9l0.2,0.2L77,18l-0.1,0.1l-0.2-0.5c0,0.4,0,1,0,1.4l-0.2-0.2C76.5,18.2,76.5,17.4,76.5,16.9"
}), /*#__PURE__*/React.createElement("path", {
  className: "sty10",
  d: "M75.2,17.2c0.3,0.2,0.2-0.7,0.2-0.7c-0.1-0.4-0.2-0.5-0.3-0.4C75,16.1,75,17,75.2,17.2 M75.2,15.7 c0.7,0.6,0.5,2,0.2,2c-0.2,0-0.5-0.3-0.6-0.8c-0.1-0.5-0.1-1.1,0-1.3C75,15.5,75.1,15.5,75.2,15.7"
}), /*#__PURE__*/React.createElement("path", {
  className: "sty10",
  d: "M78.7,23.5l0-0.3L78.6,23l0,0.3L78.7,23.5 M78.4,22l0.1,0.2l0,0.5l0.1,0.2l0-0.5l0.1,0.2l0,0.5l0.1,0.2 v0.2l-0.1-0.1l0,0.3l0.1,0.2v0.2L78.8,24l0,0.5l-0.1-0.2l0-0.5l-0.1-0.2l0,0.5L78.5,24l0-0.5l-0.1-0.2V23l0.1,0.1l0-0.3 l-0.1-0.2v-0.2l0.1,0.1L78.4,22"
}), /*#__PURE__*/React.createElement("path", {
  className: "sty10",
  d: "M77.1,21.9c0.1,0.1,0.1,0,0.1-0.1c0-0.2-0.2-0.5-0.2-0.5C76.9,21.5,77,21.8,77.1,21.9 M77.1,21.2 c0.3,0.4,0.4,1.2,0.1,1.1c-0.3-0.1-0.6-1.1-0.3-1.2C77,21,77.1,21.1,77.1,21.2 M77.8,21.9c0.1,0.1,0.1,0,0.1,0 c0-0.2-0.1-0.5-0.2-0.5C77.7,21.4,77.7,21.8,77.8,21.9 M77.8,21.2c0.3,0.4,0.3,1.2,0.1,1.1c-0.3-0.1-0.5-1.1-0.3-1.2 C77.7,21,77.8,21.1,77.8,21.2 M77.3,20.4c0.4,1.6,0.4,1.6,0.5,2.5l-0.1,0c-0.4-1.6-0.4-1.6-0.6-2.5L77.3,20.4"
}), /*#__PURE__*/React.createElement("path", {
  className: "sty10",
  d: "M76,18.9c0.2,0.9,0.4,1.7,0,2.3l0,0c-0.1-0.1-0.1-0.2-0.2-0.3c0.3-0.4,0.3-1,0-2H76"
}), /*#__PURE__*/React.createElement("path", {
  className: "sty10",
  d: "M75.1,18c0.1,0.1,0.1,0.2,0.2,0.3c-0.3,0.4-0.3,1,0,2h-0.2C74.8,19.3,74.6,18.6,75.1,18L75.1,18"
}), /*#__PURE__*/React.createElement("path", {
  className: "sty10",
  d: "M78.7,26.4C78.8,26.5,78.8,26.4,78.7,26.4c0.1,0,0.1-0.2-0.1-0.4l0-0.1C78.6,25.9,78.6,26.2,78.7,26.4  M78.7,25.3c0.1,0.2,0.2,0.4,0.2,0.6c0,0-0.1,0-0.1,0.1c-0.1-0.3-0.2-0.5-0.2-0.4c0,0.1,0,0.1,0,0.1c0.2,0.4,0.3,0.7,0.3,1 c0,0.3-0.3,0-0.4-0.4l0,0v0.2l-0.2-0.2c0-0.8,0-0.8,0-0.9c0-0.1,0-0.2,0.1-0.1C78.6,25.1,78.6,25.2,78.7,25.3"
}), /*#__PURE__*/React.createElement("path", {
  className: "sty10",
  d: "M77.7,24.8c0.1,0.1,0.1,0.1,0.2,0c0-0.3-0.2-0.7-0.3-0.7C77.5,24.2,77.5,24.6,77.7,24.8 M77.8,23.4 l0.2,0.3c0,0.5,0,1.3,0,1.9c0,0,0,0.1,0,0.1l-0.2-0.2v-0.2c-0.2,0.2-0.6-0.7-0.5-1.2c0-0.2,0.1-0.4,0.3-0.2 c0.1,0.1,0.2,0.2,0.2,0.4l0,0V23.4"
}), /*#__PURE__*/React.createElement("path", {
  className: "sty10",
  d: "M76.5,22.5c0.5,0.5,0.5,1.5,0.2,1.4c-0.1,0-0.4-0.2-0.5-0.6c0,0,0.1-0.1,0.2-0.1 c0.1,0.3,0.2,0.3,0.3,0.2c0.1-0.2-0.1-0.7-0.3-0.7c0,0,0,0,0,0c0-0.1-0.1-0.3-0.2-0.4C76.3,22.3,76.4,22.4,76.5,22.5"
}), /*#__PURE__*/React.createElement("path", {
  className: "sty10",
  d: "M75.3,22.4c0.1,0.1,0.2,0,0.2-0.1c0-0.1-0.1-0.2-0.1-0.3c-0.1,0-0.1,0.1-0.2,0.1 C75.2,22.2,75.2,22.3,75.3,22.4 M75.3,21.5c0,0,0.1-0.1,0.1-0.2c0-0.2-0.1-0.2-0.2-0.3c-0.1,0-0.1,0.1,0,0.3 C75.2,21.4,75.3,21.5,75.3,21.5 M75.3,20.8c0.3,0.3,0.5,0.9,0.2,1.1c0.3,0.5,0.3,1.1,0.1,1c0,0-0.3-0.1-0.6-0.7l-0.1,0.1 L74.5,22l0.3-0.2l-0.3-0.7l0.3,0.2l0.1,0.3c0,0,0.1-0.1,0.2-0.1c-0.3-0.5-0.3-1-0.1-0.9C75.1,20.7,75.2,20.7,75.3,20.8"
}), /*#__PURE__*/React.createElement("polyline", {
  className: "sty10",
  points: "77.5,16.2 77.9,16.7 77.9,17 77.5,16.5 77.5,16.2  "
}), /*#__PURE__*/React.createElement("path", {
  className: "sty10",
  d: "M76.7,15.5l0.2-0.3c-0.1-0.1-0.2-0.2-0.3-0.3l-0.1,0.1l-0.1-0.3c-0.1-0.1-0.2-0.2-0.3-0.3l0.2,0.7 l-0.3,0.3l0.3,0.3l0.2-0.2l0.2,0.6l0.3,0.3L76.7,15.5"
}), /*#__PURE__*/React.createElement("path", {
  className: "sty10",
  d: "M75.1,13.4c-0.1-0.1-0.1-0.1-0.2-0.2c0.1,0.5,0.2,1.1,0.3,1.6l0.2,0.1C75.3,14.4,75.3,13.8,75.1,13.4"
}), /*#__PURE__*/React.createElement("polyline", {
  className: "sty10",
  points: "78.5,26.9 78.7,27.2 78.7,27.7 78.9,28.1 78.9,28.4 78.7,28 78.7,28.6 78.5,28.4 78.5,27.8  78.2,27.4 78.2,27.1 78.5,27.5 78.5,26.9  "
}), /*#__PURE__*/React.createElement("path", {
  className: "sty10",
  d: "M78.7,31.1c0.1,0.2,0.1,0.5,0,0.5c-0.1,0-0.2-0.5-0.1-0.6C78.7,31,78.7,31.1,78.7,31.1 M78.6,29.6 l0.2,0.3c0,0.4,0,0.9,0,1.2l-0.2-0.3C78.6,30.5,78.6,30,78.6,29.6"
}), /*#__PURE__*/React.createElement("path", {
  className: "sty10",
  d: "M77.8,29.9c0.1,0.2,0.2,0.5,0.1,0.5C77.7,30.3,77.6,29.9,77.8,29.9C77.8,29.8,77.8,29.8,77.8,29.9  M77.8,28.4c0.2,0.3,0.3,0.6,0.3,1c-0.1-0.1-0.2-0.2-0.2-0.3c0-0.3-0.2-0.5-0.2-0.3c0,0.1,0,0.2,0.1,0.4 c0.1,0.3,0.1,0.3,0.1,0.5v0.1l-0.2-0.3c0-0.3-0.2-0.7-0.2-1c0-0.4,0.2-0.2,0.2-0.2C77.8,28.4,77.8,28.4,77.8,28.4"
}), /*#__PURE__*/React.createElement("path", {
  className: "sty10",
  d: "M76.5,27l0.2,0.2l0.3,0.9l-0.1,0.1l-0.2-0.5c0,0.4,0,1,0,1.4l-0.2-0.2C76.5,28.2,76.5,27.5,76.5,27"
}), /*#__PURE__*/React.createElement("path", {
  className: "sty10",
  d: "M75.2,27.3c0.3,0.2,0.2-0.7,0.2-0.7c-0.1-0.4-0.2-0.5-0.3-0.4C75,26.2,75,27,75.2,27.3 M75.2,25.7 c0.7,0.6,0.5,2,0.2,2c-0.2,0-0.5-0.3-0.6-0.8c-0.1-0.5-0.1-1.1,0-1.3C75,25.6,75.1,25.6,75.2,25.7"
}), /*#__PURE__*/React.createElement("path", {
  className: "sty10",
  d: "M78.7,33.6l0-0.3l-0.1-0.2l0,0.3L78.7,33.6 M78.4,32.1l0.1,0.2l0,0.5l0.1,0.2l0-0.5l0.1,0.2l0,0.5 l0.1,0.2v0.2l-0.1-0.1l0,0.3l0.1,0.2v0.2L78.8,34l0,0.5l-0.1-0.2l0-0.5l-0.1-0.2l0,0.5L78.5,34l0-0.5l-0.1-0.2v-0.2l0.1,0.1 l0-0.3l-0.1-0.2v-0.2l0.1,0.1L78.4,32.1"
}), /*#__PURE__*/React.createElement("path", {
  className: "sty10",
  d: "M77.1,32c0.1,0.1,0.1,0,0.1-0.1c0-0.2-0.2-0.5-0.2-0.5C76.9,31.5,77,31.9,77.1,32 M77.1,31.2 c0.3,0.4,0.4,1.2,0.1,1.1c-0.3-0.1-0.6-1.1-0.3-1.2C77,31.1,77.1,31.2,77.1,31.2 M77.8,32c0.1,0.1,0.1,0,0.1,0 c0-0.2-0.1-0.5-0.2-0.5C77.7,31.5,77.7,31.9,77.8,32 M77.8,31.2c0.3,0.4,0.3,1.2,0.1,1.1c-0.3-0.1-0.5-1.1-0.3-1.2 C77.7,31.1,77.8,31.2,77.8,31.2 M77.3,30.5c0.4,1.6,0.4,1.6,0.5,2.5l-0.1,0c-0.4-1.6-0.4-1.6-0.6-2.5L77.3,30.5"
}), /*#__PURE__*/React.createElement("path", {
  className: "sty10",
  d: "M76,28.9c0.2,0.9,0.4,1.7,0,2.3l0,0c-0.1-0.1-0.1-0.2-0.2-0.3c0.3-0.4,0.3-1,0-2H76"
}), /*#__PURE__*/React.createElement("path", {
  className: "sty10",
  d: "M75.1,28.1c0.1,0.1,0.1,0.2,0.2,0.3c-0.3,0.4-0.3,1,0,2h-0.2C74.8,29.4,74.6,28.7,75.1,28.1L75.1,28.1"
}), /*#__PURE__*/React.createElement("path", {
  className: "sty10",
  d: "M78.9,35.8c0,0,0,0.1,0,0.1c0,0-0.1,0-0.1,0.1c-0.1-0.4-0.2-0.4-0.2-0.4c0,0.1,0,0.1,0,0.1 c0.1,0.2,0.2,0.4,0.2,0.4c-0.1-0.2-0.3-0.4-0.4-0.7v-0.1c0-0.2,0-0.4,0.2-0.2c0,0,0.1,0.1,0.1,0.1 C78.7,35.5,78.8,35.6,78.9,35.8"
}), /*#__PURE__*/React.createElement("path", {
  className: "sty10",
  d: "M77.8,34.7c0-0.3-0.2-0.5-0.3-0.4c0,0,0,0,0,0.1C77.6,34.4,77.7,34.6,77.8,34.7 C77.8,34.7,77.8,34.7,77.8,34.7 M78,33.7c0,0.4,0,0.9,0,1.2c-0.2-0.3-0.5-0.6-0.7-0.9l0,0c0.1-0.4,0.2-0.3,0.3-0.1 c0.1,0.2,0.2,0.3,0.2,0.4l0,0v-0.8L78,33.7"
}), /*#__PURE__*/React.createElement("path", {
  className: "sty10",
  d: "M76.9,33.5c0-0.2-0.1-0.6-0.4-1c-0.1-0.1-0.2-0.1-0.3-0.1c0,0.1,0.1,0.3,0.2,0.4 c0.1-0.1,0.3,0.2,0.3,0.4C76.7,33.4,76.8,33.5,76.9,33.5C76.9,33.6,76.9,33.5,76.9,33.5"
}), /*#__PURE__*/React.createElement("path", {
  className: "sty10",
  d: "M75.4,32.1c0,0,0-0.1,0-0.1L75.4,32.1C75.4,32.1,75.4,32.1,75.4,32.1L75.4,32.1 M75.3,31.6 c0,0,0.1-0.1,0.1-0.2c0-0.2-0.1-0.2-0.2-0.3c-0.1,0-0.1,0.1,0,0.3C75.2,31.5,75.3,31.5,75.3,31.6 M74.8,31.4l0.1,0.3 c-0.1-0.1-0.2-0.2-0.3-0.3l-0.1-0.3L74.8,31.4 M75.7,32.4L75.7,32.4c-0.2-0.2-0.5-0.4-0.8-0.7l0.1-0.1 c-0.4-0.6-0.2-0.9-0.1-0.9c0.1,0,0.2,0.1,0.3,0.2c0.3,0.3,0.4,0.8,0.2,1C75.6,32,75.7,32.2,75.7,32.4"
}), /*#__PURE__*/React.createElement("polyline", {
  className: "sty10",
  points: "77.5,26.3 77.9,26.7 77.9,27 77.5,26.6 77.5,26.3  "
}), /*#__PURE__*/React.createElement("polyline", {
  className: "sty10",
  points: "76.2,24.4 76.4,24.6 76.6,25.1 76.7,24.9 77,25.2 76.7,25.5 77,26.5 76.8,26.2 76.6,25.6  76.4,25.8 76.1,25.6 76.4,25.2 76.2,24.4  "
}), /*#__PURE__*/React.createElement("path", {
  className: "sty10",
  d: "M74.9,23c0.1,0.6,0.3,1.4,0.4,2l-0.2-0.1c-0.1-0.6-0.3-1.4-0.4-2L74.9,23"
}), /*#__PURE__*/React.createElement("path", {
  className: "sty10",
  d: "M74.2,12.9l-0.4-0.3v-0.2c-0.1-0.1-0.2-0.1-0.2-0.2v0.2l-0.4-0.3v0.3l0.4,0.3v0.5l0.2,0.2v-0.5l0.4,0.3 V12.9"
}), /*#__PURE__*/React.createElement("path", {
  className: "sty10",
  d: "M73.9,16c0.2,0.2,0.2,0.5,0.1,0.5c-0.2,0-0.3-0.4-0.2-0.5C73.8,16,73.9,16,73.9,16 M73.8,14.5l0.3,0.2 c0,0.4,0,0.9,0,1.2l-0.3-0.2C73.8,15.4,73.8,14.9,73.8,14.5"
}), /*#__PURE__*/React.createElement("path", {
  className: "sty10",
  d: "M72.5,15c0.2,0.1,0.2,0.5,0.1,0.5c-0.2,0-0.4-0.3-0.3-0.5C72.4,14.9,72.4,14.9,72.5,15 M72.5,13.6 c0.3,0.2,0.5,0.5,0.5,0.9c-0.1-0.1-0.2-0.1-0.3-0.2c0-0.3-0.3-0.4-0.3-0.4c-0.1,0.1,0,0.2,0.1,0.4c0.1,0.3,0.2,0.3,0.2,0.5 v0.1l-0.3-0.2c0-0.1,0-0.2-0.1-0.3c-0.1-0.2-0.3-0.5-0.3-0.7C72,13.4,72.3,13.4,72.5,13.6"
}), /*#__PURE__*/React.createElement("path", {
  className: "sty10",
  d: "M70.5,12.5l0.3,0.2l0.5,0.8l-0.2,0.1L70.8,13c0,0.4,0,1,0,1.4l-0.3-0.2C70.5,13.7,70.5,13,70.5,12.5"
}), /*#__PURE__*/React.createElement("path", {
  className: "sty10",
  d: "M68.7,13c0.4,0.1,0.3-0.8,0.2-1c-0.1-0.2-0.3-0.3-0.4-0.1C68.5,12.1,68.4,12.9,68.7,13 M68.7,11.5 c0.9,0.4,0.7,1.8,0.4,1.9c-0.2,0.1-0.6,0-0.9-0.5C68,12.6,68,12,68.2,11.7C68.3,11.6,68.4,11.4,68.7,11.5"
}), /*#__PURE__*/React.createElement("path", {
  className: "sty10",
  d: "M73.9,18.5l0-0.3L73.7,18l0,0.3L73.9,18.5 M73.4,17l0.2,0.1l0.1,0.5l0.2,0.1l-0.1-0.5l0.2,0.1l0.1,0.5 l0.2,0.1v0.2l-0.2-0.1l0,0.3l0.2,0.1v0.2l-0.2-0.1l0.1,0.5L74,19.2L74,18.7l-0.2-0.1l0.1,0.5l-0.2-0.1l-0.1-0.5l-0.2-0.1V18 l0.2,0.1l0-0.3l-0.2-0.1v-0.2l0.2,0.2L73.4,17"
}), /*#__PURE__*/React.createElement("path", {
  className: "sty10",
  d: "M71.4,17.3c0.2,0.1,0.2-0.1,0.2-0.2c-0.1-0.2-0.3-0.4-0.4-0.2C71.2,17,71.3,17.2,71.4,17.3 M71.4,16.6 c0.5,0.3,0.5,1,0.2,1.1c-0.4,0.1-0.8-0.7-0.6-1C71.1,16.5,71.3,16.5,71.4,16.6 M72.5,17.1c0.2,0.1,0.2-0.1,0.2-0.2 c-0.1-0.2-0.3-0.4-0.3-0.2C72.3,16.8,72.4,17,72.5,17.1 M72.5,16.4c0.4,0.3,0.5,1,0.2,1.1c-0.3,0.1-0.8-0.7-0.6-1 C72.2,16.3,72.4,16.3,72.5,16.4 M71.7,15.8c0.5,1.5,0.6,1.5,0.9,2.4h-0.2c-0.5-1.5-0.6-1.5-0.9-2.4H71.7"
}), /*#__PURE__*/React.createElement("path", {
  className: "sty10",
  d: "M69.8,14.5c0.3,0.8,0.6,1.6,0,2.3l0,0c-0.1-0.1-0.2-0.2-0.2-0.3c0.4-0.5,0.4-1.1,0-2L69.8,14.5"
}), /*#__PURE__*/React.createElement("path", {
  className: "sty10",
  d: "M68.5,13.9c0.1,0.1,0.2,0.2,0.2,0.3c-0.4,0.5-0.4,1.1,0,2l-0.2,0c-0.3-0.9-0.3-0.9-0.3-1.3 C68.2,14.3,68.4,14,68.5,13.9L68.5,13.9"
}), /*#__PURE__*/React.createElement("path", {
  className: "sty10",
  d: "M73.9,21.3c0.1,0.1,0.1,0,0.1-0.1c0-0.2-0.2-0.3-0.3-0.4l-0.1-0.1C73.7,20.9,73.7,21.1,73.9,21.3  M73.9,20.2c0.2,0.2,0.3,0.4,0.4,0.5c0,0-0.1,0.1-0.1,0.1c-0.2-0.3-0.4-0.4-0.4-0.3c0,0,0,0,0,0.1c0.9,0.7,0.6,1.1,0.5,1.1 c-0.1,0-0.4-0.1-0.5-0.5l0,0v0.2l-0.3-0.2c0-0.9,0-0.9,0-1C73.5,20,73.7,20.1,73.9,20.2"
}), /*#__PURE__*/React.createElement("path", {
  className: "sty10",
  d: "M72.3,20.1c0.3,0.2,0.3-0.2,0.2-0.3c-0.1-0.3-0.4-0.5-0.4-0.3C72,19.6,72,19.9,72.3,20.1 M72.5,18.6 l0.3,0.2c0,0.5,0,1.3,0,1.9c0,0,0,0.1,0,0.1l-0.3-0.2v-0.2c-0.5,0.3-1-0.7-0.8-1.2c0.1-0.4,0.6-0.1,0.8,0.2v0l0,0L72.5,18.6"
}), /*#__PURE__*/React.createElement("path", {
  className: "sty10",
  d: "M70.5,18.1c0.7,0.4,0.8,1.3,0.4,1.4c-0.2,0.1-0.6-0.1-0.8-0.4c0.1,0,0.2-0.1,0.2-0.1 c0.1,0.2,0.4,0.3,0.4,0.1c0.1-0.3-0.2-0.7-0.4-0.6h0c-0.1-0.1-0.2-0.3-0.2-0.4C70.2,17.9,70.4,18,70.5,18.1"
}), /*#__PURE__*/React.createElement("path", {
  className: "sty10",
  d: "M68.9,18.2c0.2,0.1,0.3-0.1,0.2-0.2c0-0.1-0.1-0.1-0.2-0.2c-0.1,0.1-0.2,0.1-0.3,0.2 C68.7,18.1,68.7,18.2,68.9,18.2 M68.8,17.4c0.1-0.1,0.1-0.1,0.1-0.2c0-0.1-0.1-0.2-0.2-0.2c-0.1,0-0.2,0.1-0.1,0.2 C68.7,17.2,68.8,17.3,68.8,17.4 M68.8,16.6c0.5,0.2,0.7,0.8,0.3,1c0.5,0.4,0.4,1,0.1,1c0,0-0.5,0-0.8-0.5l-0.1,0.1l-0.5-0.2 l0.4-0.2l-0.4-0.7l0.4,0.2l0.2,0.3c0.1,0,0.2-0.1,0.2-0.1c-0.5-0.5-0.4-0.9,0-0.9C68.6,16.6,68.7,16.6,68.8,16.6"
}), /*#__PURE__*/React.createElement("polyline", {
  className: "sty10",
  points: "72,11.5 72.5,11.8 72.5,12.1 72,11.8 72,11.5  "
}), /*#__PURE__*/React.createElement("path", {
  className: "sty10",
  d: "M70.9,10.9l0.3-0.3c-0.1-0.1-0.3-0.1-0.4-0.2l-0.1,0.2l-0.1-0.3c-0.1-0.1-0.2-0.1-0.4-0.2l0.3,0.7 L70,11.2l0.4,0.2l0.2-0.3l0.2,0.5l0.4,0.2L70.9,10.9"
}), /*#__PURE__*/React.createElement("path", {
  className: "sty10",
  d: "M68.5,9.3c-0.1,0-0.2-0.1-0.2-0.1c0.1,0.4,0.3,1.1,0.5,1.5l0.2,0C68.8,10.3,68.6,9.7,68.5,9.3"
}), /*#__PURE__*/React.createElement("polyline", {
  className: "sty10",
  points: "73.6,22 73.8,22.1 73.8,22.7 74.2,23 74.2,23.3 73.8,23 73.8,23.5 73.6,23.3 73.6,22.8  73.2,22.5 73.2,22.2 73.6,22.5 73.6,22  "
}), /*#__PURE__*/React.createElement("path", {
  className: "sty10",
  d: "M73.9,26.1c0.2,0.2,0.2,0.5,0.1,0.5c-0.2,0-0.3-0.4-0.2-0.5C73.8,26,73.9,26,73.9,26.1 M73.8,24.6 l0.3,0.2c0,0.4,0,0.9,0,1.2l-0.3-0.2C73.8,25.4,73.8,25,73.8,24.6"
}), /*#__PURE__*/React.createElement("path", {
  className: "sty10",
  d: "M72.5,25.1c0.2,0.1,0.2,0.5,0.1,0.5c-0.2,0-0.4-0.3-0.3-0.5C72.4,25,72.4,25,72.5,25.1 M72.5,23.6 c0.3,0.2,0.5,0.5,0.5,0.9c-0.1-0.1-0.2-0.1-0.3-0.2c0-0.3-0.3-0.4-0.3-0.4c-0.1,0.1,0,0.2,0.1,0.4c0.1,0.3,0.2,0.3,0.2,0.5V25 l-0.3-0.2c0-0.1,0-0.2-0.1-0.3C72.1,24.3,72,24,72,23.8C72,23.5,72.3,23.5,72.5,23.6"
}), /*#__PURE__*/React.createElement("path", {
  className: "sty10",
  d: "M70.5,22.5l0.3,0.2l0.5,0.8l-0.2,0.1l-0.3-0.5c0,0.4,0,1,0,1.4l-0.3-0.2C70.5,23.8,70.5,23.1,70.5,22.5"
}), /*#__PURE__*/React.createElement("path", {
  className: "sty10",
  d: "M68.7,23.1c0.4,0.1,0.3-0.8,0.2-1c-0.1-0.2-0.3-0.3-0.4-0.1C68.5,22.2,68.4,23,68.7,23.1 M68.7,21.6 c0.9,0.4,0.7,1.8,0.4,1.9c-0.2,0.1-0.6,0-0.9-0.5c-0.2-0.3-0.2-0.9-0.1-1.2C68.3,21.6,68.4,21.4,68.7,21.6"
}), /*#__PURE__*/React.createElement("path", {
  className: "sty10",
  d: "M73.9,28.5l0-0.3L73.7,28l0,0.3L73.9,28.5 M73.4,27.1l0.2,0.1l0.1,0.5l0.2,0.1l-0.1-0.5l0.2,0.1l0.1,0.5 l0.2,0.1v0.2l-0.2-0.1l0,0.3l0.2,0.1V29l-0.2-0.1l0.1,0.5L74,29.3L74,28.8l-0.2-0.1l0.1,0.5L73.6,29l-0.1-0.5l-0.2-0.1v-0.2 l0.2,0.1l0-0.3l-0.2-0.1v-0.2l0.2,0.1V27.1"
}), /*#__PURE__*/React.createElement("path", {
  className: "sty10",
  d: "M71.4,27.4c0.2,0.1,0.2-0.1,0.2-0.2c-0.1-0.2-0.3-0.4-0.4-0.2C71.2,27,71.3,27.3,71.4,27.4 M71.4,26.6 c0.5,0.3,0.5,1,0.2,1.1c-0.4,0.1-0.8-0.7-0.6-1C71.1,26.6,71.3,26.5,71.4,26.6 M72.5,27.2c0.2,0.1,0.2-0.1,0.2-0.2 c-0.1-0.2-0.3-0.4-0.3-0.2C72.3,26.8,72.4,27.1,72.5,27.2 M72.5,26.5c0.4,0.3,0.5,1,0.2,1.1c-0.3,0.1-0.8-0.7-0.6-1 C72.2,26.4,72.4,26.4,72.5,26.5 M71.7,25.8c0.5,1.5,0.6,1.5,0.9,2.4h-0.2c-0.5-1.5-0.6-1.5-0.9-2.4H71.7"
}), /*#__PURE__*/React.createElement("path", {
  className: "sty10",
  d: "M69.8,24.6c0.3,0.8,0.6,1.6,0,2.3l0,0c-0.1-0.1-0.2-0.2-0.2-0.3c0.4-0.5,0.4-1.1,0-2L69.8,24.6"
}), /*#__PURE__*/React.createElement("path", {
  className: "sty10",
  d: "M68.5,24c0.1,0.1,0.2,0.2,0.2,0.3c-0.4,0.5-0.4,1.1,0,2l-0.2,0c-0.3-0.9-0.3-0.9-0.3-1.3 C68.2,24.4,68.4,24.1,68.5,24L68.5,24"
}), /*#__PURE__*/React.createElement("path", {
  className: "sty10",
  d: "M74.2,30.7C74.2,30.8,74.3,30.8,74.2,30.7c0,0.1-0.1,0.1-0.1,0.2c-0.2-0.4-0.4-0.4-0.4-0.3 c0,0,0,0.1,0,0.1c0.2,0.1,0.3,0.2,0.4,0.4c-0.2-0.2-0.4-0.3-0.7-0.5v-0.1c0-0.3,0.1-0.4,0.5-0.1C74,30.4,74.1,30.5,74.2,30.7"
}), /*#__PURE__*/React.createElement("path", {
  className: "sty10",
  d: "M72.5,29.9c-0.1-0.3-0.4-0.5-0.4-0.3v0C72.2,29.7,72.3,29.8,72.5,29.9C72.5,29.9,72.5,29.9,72.5,29.9  M72.8,28.9c0,0.4,0,0.9,0,1.2c-0.3-0.2-0.7-0.5-1.1-0.7l0,0c0.1-0.7,0.7-0.1,0.7,0c0,0,0,0.1,0.1,0.1v-0.8L72.8,28.9"
}), /*#__PURE__*/React.createElement("path", {
  className: "sty10",
  d: "M71.1,29c0-0.1-0.1-0.5-0.6-0.8c-0.2-0.1-0.3-0.1-0.4,0c0.1,0.1,0.2,0.3,0.2,0.4 c0.1-0.1,0.4,0.1,0.4,0.3C70.9,28.9,71,29,71.1,29C71.1,29,71.1,29,71.1,29"
}), /*#__PURE__*/React.createElement("path", {
  className: "sty10",
  d: "M69,27.9C68.9,27.9,68.9,27.9,69,27.9l-0.1,0C68.9,27.9,68.9,27.9,69,27.9L69,27.9 M68.8,27.4 c0.1-0.1,0.1-0.1,0.1-0.2c0-0.1-0.1-0.2-0.2-0.2c-0.1,0-0.2,0.1-0.1,0.2C68.7,27.3,68.8,27.4,68.8,27.4 M68.2,27.4l0.1,0.3 c-0.1-0.1-0.3-0.1-0.4-0.2l-0.2-0.3L68.2,27.4 M69.4,28.1L69.4,28.1c-0.3-0.1-0.7-0.3-1-0.5l0.2-0.1c-0.5-0.5-0.3-0.9-0.1-0.9 c0.1,0,0.3,0.1,0.4,0.1c0.4,0.3,0.6,0.7,0.2,1C69.2,27.8,69.4,27.9,69.4,28.1"
}), /*#__PURE__*/React.createElement("polyline", {
  className: "sty10",
  points: "72,21.6 72.5,21.9 72.5,22.2 72,21.9 72,21.6  "
}), /*#__PURE__*/React.createElement("polyline", {
  className: "sty10",
  points: "70,20 70.5,20.2 70.6,20.7 70.8,20.4 71.2,20.7 70.9,21 71.3,21.9 70.9,21.7 70.6,21.1  70.4,21.4 70,21.2 70.4,20.8 70,20  "
}), /*#__PURE__*/React.createElement("path", {
  className: "sty10",
  d: "M68.4,18.9c0.2,0.5,0.4,1.3,0.6,1.9l-0.2,0c-0.2-0.5-0.4-1.3-0.6-1.9L68.4,18.9"
}), /*#__PURE__*/React.createElement("path", {
  className: "sty10",
  d: "M67.4,9l-0.5-0.2V8.6c-0.1,0-0.2-0.1-0.3-0.1v0.2L66,8.5v0.3L66.5,9v0.5l0.3,0.1V9.1l0.5,0.2V9"
}), /*#__PURE__*/React.createElement("path", {
  className: "sty10",
  d: "M67,12.1c0.2,0.1,0.3,0.4,0.1,0.5c-0.2,0.1-0.4-0.2-0.4-0.4C66.8,12.1,66.9,12.1,67,12.1 M66.8,10.7 l0.4,0.1c0,0.4,0,0.9,0,1.2l-0.4-0.1C66.8,11.6,66.8,11.1,66.8,10.7"
}), /*#__PURE__*/React.createElement("path", {
  className: "sty10",
  d: "M65.1,11.5c0.2,0.1,0.3,0.4,0.2,0.5c-0.2,0.1-0.5-0.2-0.4-0.4C64.9,11.5,65,11.5,65.1,11.5 M65.1,10.1 c0.4,0.1,0.6,0.4,0.7,0.8c-0.1,0-0.3-0.1-0.4-0.1c0-0.3-0.3-0.4-0.4-0.3c-0.1,0.1,0,0.2,0.2,0.4c0.2,0.2,0.2,0.3,0.2,0.4v0.1 l-0.4-0.1c0-0.1,0-0.2-0.1-0.3c-0.2-0.2-0.4-0.4-0.3-0.7C64.5,10,64.8,10,65.1,10.1"
}), /*#__PURE__*/React.createElement("path", {
  className: "sty10",
  d: "M62.6,9.4L63,9.5l0.7,0.7l-0.2,0.2L63,9.9c0,0.4,0,1,0,1.4l-0.4-0.1C62.6,10.7,62.6,9.9,62.6,9.4"
}), /*#__PURE__*/React.createElement("path", {
  className: "sty10",
  d: "M60.5,10.4c0.5,0.1,0.3-0.9,0.2-1c-0.1-0.1-0.5-0.3-0.5,0.2C60.2,9.6,60.1,10.3,60.5,10.4 M60.5,8.9 c0.1,0,0.6,0.1,0.7,0.7c0.1,0.4,0.1,1-0.3,1.2c-0.3,0.1-0.8,0-1-0.2c-0.4-0.5-0.2-1.2-0.2-1.2C59.9,8.8,60.2,8.8,60.5,8.9"
}), /*#__PURE__*/React.createElement("path", {
  className: "sty10",
  d: "M67,14.6l0-0.3l-0.2-0.1l0,0.3L67,14.6 M66.3,13.3l0.2,0.1l0.1,0.5l0.2,0.1l-0.1-0.5l0.2,0.1l0.1,0.5 l0.2,0.1v0.2l-0.2-0.1l0,0.3l0.2,0.1v0.2L67.2,15l0.1,0.5l-0.2-0.1L67,14.9l-0.2-0.1l0.1,0.5l-0.2-0.1l-0.1-0.5l-0.2-0.1v-0.2 l0.2,0.1l0-0.3l-0.2-0.1v-0.2l0.2,0.1L66.3,13.3"
}), /*#__PURE__*/React.createElement("path", {
  className: "sty10",
  d: "M63.8,14c0.2,0.1,0.3-0.2,0.2-0.3c-0.1-0.2-0.4-0.2-0.5,0C63.5,13.8,63.6,14,63.8,14 M63.8,13.3 c0.5,0.2,0.7,0.8,0.3,1c-0.4,0.2-1-0.3-0.9-0.8C63.3,13.3,63.6,13.2,63.8,13.3 M65.2,13.6c0.2,0.1,0.3-0.1,0.2-0.3 c-0.1-0.2-0.4-0.3-0.4-0.1C64.9,13.4,65,13.6,65.2,13.6 M65.2,12.9c0.5,0.2,0.7,0.9,0.3,1c-0.4,0.2-1-0.4-0.8-0.8 C64.7,12.9,64.9,12.8,65.2,12.9 M64,12.5c0.7,1.4,0.7,1.4,1.1,2.2l-0.2,0c-0.7-1.4-0.7-1.4-1.1-2.2L64,12.5"
}), /*#__PURE__*/React.createElement("path", {
  className: "sty10",
  d: "M61.8,11.6c0.1,0.2,0.2,0.4,0.3,0.6c0,0.1,0.1,0.3,0.1,0.6c0,0.5-0.3,0.9-0.4,1l0,0 c-0.1-0.1-0.2-0.2-0.3-0.2c0.5-0.6,0.5-1.1,0-2L61.8,11.6"
}), /*#__PURE__*/React.createElement("path", {
  className: "sty10",
  d: "M60.2,11.3c0.1,0.1,0.2,0.1,0.3,0.2c-0.5,0.6-0.5,1.2,0,2l-0.3,0.1c-0.4-0.8-0.4-0.8-0.4-1.2 C59.8,11.8,60,11.5,60.2,11.3L60.2,11.3"
}), /*#__PURE__*/React.createElement("path", {
  className: "sty10",
  d: "M66.9,17.5c0.1,0.1,0.2,0,0.2-0.1c-0.1-0.1-0.3-0.2-0.4-0.3l-0.1,0c0,0.1,0,0.2,0.1,0.2 C66.8,17.4,66.9,17.5,66.9,17.5 M66.9,16.4c0.3,0.1,0.4,0.3,0.5,0.4c-0.1,0-0.1,0.1-0.2,0.1c-0.2-0.3-0.5-0.3-0.5-0.2v0 c0.4,0.1,0.6,0.3,0.8,0.5c0.1,0.1,0.1,0.4,0,0.5c-0.2,0.1-0.5-0.1-0.7-0.4l0,0v0.2l-0.3-0.1c0-0.9,0-0.9,0.1-1 C66.5,16.3,66.7,16.3,66.9,16.4"
}), /*#__PURE__*/React.createElement("path", {
  className: "sty10",
  d: "M64.8,16.6c0.4,0.1,0.3-0.3,0.3-0.4c-0.1-0.2-0.5-0.3-0.6-0.1C64.4,16.3,64.5,16.5,64.8,16.6 M65.1,15.1 l0.4,0.1c0,0.5,0,1.3,0,1.9c0,0,0,0.1,0,0.1L65.1,17v-0.1c-0.5,0.3-1.2-0.4-1-1c0.1-0.5,0.8-0.3,1,0l0,0L65.1,15.1"
}), /*#__PURE__*/React.createElement("path", {
  className: "sty10",
  d: "M62.6,15c0.9,0.2,0.9,1.1,0.5,1.3c-0.2,0.1-0.8,0.1-1-0.2c0.1-0.1,0.2-0.1,0.3-0.2 c0.2,0.2,0.5,0.2,0.5,0c0-0.3-0.4-0.5-0.5-0.4l0,0c-0.1-0.1-0.2-0.2-0.3-0.3C62.2,15,62.5,15,62.6,15"
}), /*#__PURE__*/React.createElement("path", {
  className: "sty10",
  d: "M60.6,15.5c0.3,0,0.3-0.2,0.2-0.3c0-0.1-0.1-0.1-0.2-0.2c-0.1,0.1-0.2,0.2-0.4,0.3 C60.4,15.4,60.5,15.5,60.6,15.5 M60.6,14.7c0.1,0,0.2-0.1,0.2-0.2c0-0.1-0.1-0.2-0.2-0.2c-0.2,0-0.3,0.1-0.2,0.2 C60.4,14.5,60.5,14.7,60.6,14.7 M60.5,14c0.6,0.1,0.9,0.6,0.4,1c0.5,0.3,0.5,0.8,0.2,1c0,0-0.6,0.2-1.1-0.3l-0.2,0.1l-0.6-0.1 l0.5-0.3l-0.4-0.6l0.5,0.1L60,15c0.1-0.1,0.2-0.1,0.3-0.2c-0.5-0.4-0.4-0.8-0.1-0.9C60.3,14,60.4,13.9,60.5,14"
}), /*#__PURE__*/React.createElement("polyline", {
  className: "sty10",
  points: "64.5,8.1 65.2,8.3 65.2,8.6 64.5,8.4 64.5,8.1  "
}), /*#__PURE__*/React.createElement("path", {
  className: "sty10",
  d: "M63.1,7.8l0.4-0.4c-0.2,0-0.3-0.1-0.5-0.1l-0.2,0.2l-0.2-0.3c-0.1,0-0.3-0.1-0.5-0.1l0.4,0.6L62,8.2 l0.5,0.1L62.8,8l0.3,0.5l0.5,0.1L63.1,7.8"
}), /*#__PURE__*/React.createElement("path", {
  className: "sty10",
  d: "M60.2,6.7c-0.1,0-0.2,0-0.3-0.1C60,7,60.3,7.5,60.5,8l0.3,0C60.6,7.6,60.4,7.1,60.2,6.7"
}), /*#__PURE__*/React.createElement("polyline", {
  className: "sty10",
  points: "66.5,18.2 66.8,18.3 66.8,18.9 67.4,19.1 67.4,19.4 66.8,19.2 66.8,19.7 66.5,19.6 66.5,19  66,18.9 66,18.5 66.5,18.7 66.5,18.2  "
}), /*#__PURE__*/React.createElement("path", {
  className: "sty10",
  d: "M67,22.2c0.2,0.1,0.3,0.4,0.1,0.5c-0.2,0.1-0.4-0.2-0.4-0.4C66.8,22.2,66.9,22.2,67,22.2 M66.8,20.8 l0.4,0.1c0,0.4,0,0.9,0,1.2L66.8,22C66.8,21.7,66.8,21.2,66.8,20.8"
}), /*#__PURE__*/React.createElement("path", {
  className: "sty10",
  d: "M65.1,21.6c0.2,0.1,0.3,0.4,0.2,0.5c-0.2,0.1-0.5-0.2-0.4-0.4C64.9,21.6,65,21.5,65.1,21.6 M65.1,20.1 c0.4,0.1,0.6,0.4,0.7,0.8c-0.1,0-0.3-0.1-0.4-0.1c0-0.3-0.3-0.4-0.4-0.3c-0.1,0.1,0,0.2,0.2,0.4c0.2,0.2,0.2,0.3,0.2,0.4v0.1 l-0.4-0.1c0-0.1,0-0.2-0.1-0.3c-0.2-0.2-0.4-0.4-0.3-0.7C64.5,20.1,64.8,20.1,65.1,20.1"
}), /*#__PURE__*/React.createElement("path", {
  className: "sty10",
  d: "M62.6,19.5l0.4,0.1l0.7,0.7l-0.2,0.2L63,20c0,0.4,0,1,0,1.4l-0.4-0.1C62.6,20.7,62.6,20,62.6,19.5"
}), /*#__PURE__*/React.createElement("path", {
  className: "sty10",
  d: "M60.5,20.5c0.5,0.1,0.3-0.9,0.2-1c-0.1-0.1-0.5-0.3-0.5,0.2C60.2,19.7,60.1,20.4,60.5,20.5 M60.5,18.9 c0.1,0,0.6,0.1,0.7,0.7c0.1,0.4,0.1,1-0.3,1.2c-0.3,0.1-0.8,0-1-0.2c-0.4-0.5-0.2-1.2-0.2-1.2C59.9,18.9,60.2,18.9,60.5,18.9"
}), /*#__PURE__*/React.createElement("path", {
  className: "sty10",
  d: "M67,24.7l0-0.3l-0.2-0.1l0,0.3L67,24.7 M66.3,23.4l0.2,0.1l0.1,0.5l0.2,0.1l-0.1-0.5l0.2,0.1l0.1,0.5 l0.2,0.1v0.2l-0.2-0.1l0,0.3l0.2,0.1v0.2L67.2,25l0.1,0.5l-0.2-0.1L67,24.9l-0.2-0.1l0.1,0.5l-0.2-0.1l-0.1-0.5l-0.2-0.1v-0.2 l0.2,0.1l0-0.3l-0.2-0.1v-0.2l0.2,0.1L66.3,23.4"
}), /*#__PURE__*/React.createElement("path", {
  className: "sty10",
  d: "M63.8,24.1c0.2,0.1,0.3-0.2,0.2-0.3c-0.1-0.2-0.4-0.2-0.5,0C63.5,23.9,63.6,24.1,63.8,24.1 M63.8,23.4 c0.5,0.2,0.7,0.8,0.3,1c-0.4,0.2-1-0.3-0.9-0.8C63.3,23.4,63.6,23.3,63.8,23.4 M65.2,23.7c0.2,0.1,0.3-0.1,0.2-0.3 c-0.1-0.2-0.4-0.3-0.4-0.1C64.9,23.4,65,23.6,65.2,23.7 M65.2,22.9c0.5,0.2,0.7,0.9,0.3,1c-0.4,0.2-1-0.4-0.8-0.8 C64.7,22.9,64.9,22.9,65.2,22.9 M64,22.5c0.7,1.4,0.7,1.4,1.1,2.2l-0.2,0c-0.7-1.4-0.7-1.4-1.1-2.2L64,22.5"
}), /*#__PURE__*/React.createElement("path", {
  className: "sty10",
  d: "M61.8,21.7c0.1,0.2,0.2,0.4,0.3,0.6c0,0.1,0.1,0.3,0.1,0.6c0,0.5-0.3,0.9-0.4,1l0,0 c-0.1-0.1-0.2-0.2-0.3-0.2c0.5-0.6,0.5-1.1,0-2L61.8,21.7"
}), /*#__PURE__*/React.createElement("path", {
  className: "sty10",
  d: "M60.2,21.4c0.1,0.1,0.2,0.1,0.3,0.2c-0.5,0.6-0.5,1.2,0,2l-0.3,0.1c-0.4-0.8-0.4-0.8-0.4-1.2 C59.8,21.9,60,21.5,60.2,21.4L60.2,21.4"
}), /*#__PURE__*/React.createElement("path", {
  className: "sty10",
  d: "M67.4,26.8C67.4,26.9,67.4,26.9,67.4,26.8c0,0.1-0.1,0.2-0.1,0.2c-0.2-0.3-0.5-0.3-0.5-0.2v0 c0.2,0.1,0.4,0.2,0.6,0.3c-0.3-0.1-0.6-0.2-0.9-0.3v-0.1c0-0.3,0.2-0.4,0.7-0.2C67.1,26.6,67.2,26.6,67.4,26.8"
}), /*#__PURE__*/React.createElement("path", {
  className: "sty10",
  d: "M65.1,26.4c-0.1-0.3-0.5-0.4-0.6-0.2v0C64.7,26.3,64.9,26.3,65.1,26.4C65.1,26.4,65.1,26.4,65.1,26.4  M65.5,25.3c0,0.4,0,0.9,0,1.2c-0.4-0.2-0.9-0.3-1.4-0.4l0,0c0.1-0.2,0.2-0.4,0.3-0.4c0.3,0,0.5,0.1,0.7,0.3l0,0v-0.8 L65.5,25.3"
}), /*#__PURE__*/React.createElement("path", {
  className: "sty10",
  d: "M63.3,25.8c0-0.1-0.1-0.5-0.8-0.7c-0.2,0-0.3,0-0.5,0c0.1,0.1,0.2,0.2,0.3,0.3c0.2-0.1,0.5,0,0.5,0.2 C63,25.7,63.1,25.8,63.3,25.8C63.3,25.8,63.3,25.8,63.3,25.8"
}), /*#__PURE__*/React.createElement("path", {
  className: "sty10",
  d: "M60.8,25.2C60.7,25.2,60.7,25.2,60.8,25.2l-0.1,0C60.7,25.2,60.7,25.2,60.8,25.2L60.8,25.2 M60.6,24.7 c0.1,0,0.2-0.1,0.2-0.2c0-0.1-0.1-0.2-0.2-0.2c-0.2,0-0.3,0.1-0.2,0.2C60.4,24.6,60.5,24.7,60.6,24.7 M59.8,24.8l0.2,0.2 c-0.2,0-0.3-0.1-0.5-0.1l-0.2-0.2L59.8,24.8 M61.3,25.3L61.3,25.3c-0.4-0.1-0.8-0.2-1.2-0.2l0.2-0.2c-0.6-0.4-0.4-0.8-0.1-0.9 c0.2,0,0.3,0,0.4,0c0.5,0.2,0.7,0.6,0.3,0.9C61,25.1,61.2,25.1,61.3,25.3"
}), /*#__PURE__*/React.createElement("polyline", {
  className: "sty10",
  points: "64.5,18.2 65.2,18.4 65.2,18.7 64.5,18.5 64.5,18.2  "
}), /*#__PURE__*/React.createElement("polyline", {
  className: "sty10",
  points: "62.1,17.1 62.6,17.2 62.8,17.6 63,17.3 63.5,17.4 63.1,17.9 63.6,18.7 63.1,18.6 62.8,18.1  62.5,18.4 62,18.3 62.5,17.7 62.1,17.1  "
}), /*#__PURE__*/React.createElement("path", {
  className: "sty10",
  d: "M60,16.3c0.2,0.5,0.5,1.2,0.7,1.7l-0.3,0c-0.2-0.5-0.5-1.2-0.7-1.7L60,16.3"
}), /*#__PURE__*/React.createElement("path", {
  className: "sty10",
  d: "M58.9,6.7l-0.6-0.1V6.3c-0.1,0-0.2,0-0.4-0.1v0.2l-0.7-0.1v0.3l0.7,0.1v0.5l0.4,0.1V6.9L58.9,7V6.7"
}), /*#__PURE__*/React.createElement("path", {
  className: "sty10",
  d: "M58.4,9.9c0.3,0.1,0.3,0.3,0.2,0.4c-0.2,0.1-0.5,0-0.5-0.3C58.1,9.9,58.2,9.9,58.4,9.9 M58.2,8.5 l0.4,0.1c0,0.4,0,0.9,0,1.2l-0.4-0.1C58.2,9.4,58.2,8.9,58.2,8.5"
}), /*#__PURE__*/React.createElement("path", {
  className: "sty10",
  d: "M56.2,9.6c0.3,0,0.4,0.3,0.2,0.4c-0.2,0.1-0.5,0-0.5-0.2C56,9.7,56.1,9.6,56.2,9.6 M56.2,8.2 c0.4,0.1,0.7,0.3,0.8,0.6c-0.1,0-0.3,0-0.5,0c0-0.3-0.4-0.3-0.5-0.2c-0.1,0.1,0,0.2,0.2,0.4c0.2,0.2,0.3,0.2,0.3,0.4v0.1 l-0.4,0c0-0.1,0-0.2-0.1-0.3c-0.2-0.2-0.4-0.3-0.4-0.6C55.6,8.3,55.9,8.2,56.2,8.2"
}), /*#__PURE__*/React.createElement("path", {
  className: "sty10",
  d: "M53.4,8.1l0.4,0l0.7,0.5l-0.3,0.2l-0.4-0.3c0,0.4,0,1,0,1.4l-0.4,0C53.4,9.3,53.4,8.6,53.4,8.1"
}), /*#__PURE__*/React.createElement("path", {
  className: "sty10",
  d: "M58.4,12.4l0-0.3l-0.3,0l0,0.3L58.4,12.4 M57.6,11.2l0.3,0l0.1,0.5l0.3,0l-0.1-0.5l0.3,0l0.1,0.5l0.3,0 v0.2l-0.2,0l0,0.3l0.3,0v0.2l-0.2,0l0.1,0.5l-0.3,0l-0.1-0.5l-0.3,0l0.1,0.5l-0.3,0l-0.1-0.5l-0.3,0v-0.2l0.2,0l0-0.3l-0.3,0 v-0.2l0.2,0L57.6,11.2"
}), /*#__PURE__*/React.createElement("path", {
  className: "sty10",
  d: "M54.7,12.5c0.3,0,0.4-0.2,0.2-0.4c-0.2-0.2-0.5-0.1-0.5,0.1C54.4,12.4,54.5,12.5,54.7,12.5 M54.7,11.7 c0.6,0.1,0.8,0.6,0.4,0.9c-0.4,0.3-1.1,0-1.1-0.5C54.1,11.9,54.4,11.7,54.7,11.7 M56.3,11.7c0.3,0,0.3-0.2,0.2-0.4 c-0.2-0.2-0.5-0.1-0.5,0.1C56,11.6,56.1,11.7,56.3,11.7 M56.3,11c0.6,0.1,0.8,0.7,0.4,0.9c-0.4,0.3-1.1,0-1-0.5 C55.7,11.1,56,11,56.3,11 M55,10.8c0.8,1.2,0.8,1.3,1.3,2L56,12.9c-0.8-1.2-0.8-1.3-1.3-2L55,10.8"
}), /*#__PURE__*/React.createElement("path", {
  className: "sty10",
  d: "M58.4,15.2c0.2,0,0.2-0.1,0.2-0.2c-0.1-0.1-0.3-0.1-0.4-0.2H58c0,0.1,0,0.2,0.1,0.2 C58.2,15.2,58.3,15.2,58.4,15.2 M58.3,14.2c0.3,0.1,0.5,0.2,0.7,0.3c-0.1,0-0.2,0.1-0.2,0.2c-0.3-0.3-0.7-0.3-0.7,0 c0.2,0,0.7,0.1,0.8,0.3c0.2,0.2,0.2,0.5,0,0.5c-0.2,0.1-0.7,0.1-0.9-0.2l0,0v0.2l-0.4-0.1c0-0.9,0-0.9,0.1-1 C57.8,14.1,58.1,14.1,58.3,14.2"
}), /*#__PURE__*/React.createElement("path", {
  className: "sty10",
  d: "M55.9,14.8c0.4,0,0.4-0.3,0.3-0.5c-0.2-0.2-0.6-0.2-0.7,0.1C55.5,14.6,55.6,14.8,55.9,14.8 M56.2,13.2 l0.4,0c0,0.5,0,1.3,0,1.9c0,0,0,0.1,0,0.1l-0.4,0V15c-0.6,0.4-1.3-0.1-1.2-0.7s0.9-0.6,1.2-0.3l0,0V13.2"
}), /*#__PURE__*/React.createElement("path", {
  className: "sty10",
  d: "M53.3,13.7c0.9,0.1,1,0.8,0.7,1.1c-0.3,0.2-0.9,0.3-1.2,0c0.1-0.1,0.2-0.2,0.3-0.2 c0.2,0.2,0.6,0.1,0.6-0.2s-0.4-0.4-0.6-0.2l0,0c-0.1-0.1-0.2-0.2-0.3-0.3C53,13.7,53.2,13.7,53.3,13.7"
}), /*#__PURE__*/React.createElement("polyline", {
  className: "sty10",
  points: "55.6,6.4 56.3,6.4 56.3,6.8 55.6,6.7 55.6,6.4  "
}), /*#__PURE__*/React.createElement("path", {
  className: "sty10",
  d: "M53.9,6.4l0.4-0.5c-0.2,0-0.4,0-0.5,0l-0.2,0.2l-0.2-0.2c-0.2,0-0.3,0-0.5,0l0.4,0.5l-0.6,0.7h0.5 l0.3-0.4l0.4,0.4l0.5,0L53.9,6.4"
}), /*#__PURE__*/React.createElement("polyline", {
  className: "sty10",
  points: "57.9,16 58.2,16.1 58.2,16.6 58.9,16.7 58.9,17.1 58.2,17 58.2,17.5 57.9,17.4 57.9,16.9  57.2,16.8 57.2,16.5 57.9,16.6 57.9,16  "
}), /*#__PURE__*/React.createElement("path", {
  className: "sty10",
  d: "M58.4,20c0.3,0.1,0.3,0.3,0.2,0.4c-0.2,0.1-0.5,0-0.5-0.3C58.1,20,58.2,19.9,58.4,20 M58.2,18.6l0.4,0.1 c0,0.4,0,0.9,0,1.2l-0.4-0.1C58.2,19.4,58.2,18.9,58.2,18.6"
}), /*#__PURE__*/React.createElement("path", {
  className: "sty10",
  d: "M56.2,19.7c0.3,0,0.4,0.3,0.2,0.4c-0.2,0.1-0.5,0-0.5-0.2C56,19.8,56.1,19.7,56.2,19.7 M56.2,18.3 c0.4,0.1,0.7,0.3,0.8,0.6c-0.1,0-0.3,0-0.5,0c0-0.3-0.4-0.3-0.5-0.2c-0.1,0.1,0,0.2,0.2,0.4c0.2,0.2,0.3,0.2,0.3,0.4v0.1 l-0.4,0c0-0.1,0-0.2-0.1-0.3c-0.2-0.2-0.4-0.3-0.4-0.6C55.6,18.4,55.9,18.3,56.2,18.3"
}), /*#__PURE__*/React.createElement("path", {
  className: "sty10",
  d: "M53.4,18.2l0.4,0l0.7,0.5L54.2,19l-0.4-0.3c0,0.4,0,1,0,1.4l-0.4,0C53.4,19.4,53.4,18.7,53.4,18.2"
}), /*#__PURE__*/React.createElement("path", {
  className: "sty10",
  d: "M58.4,22.4l0-0.3l-0.3,0l0,0.3L58.4,22.4 M57.6,21.2l0.3,0l0.1,0.5l0.3,0l-0.1-0.5l0.3,0l0.1,0.5l0.3,0 v0.2l-0.2,0l0,0.3l0.3,0v0.2l-0.2,0l0.1,0.5l-0.3,0l-0.1-0.5l-0.3,0l0.1,0.5l-0.3,0l-0.1-0.5l-0.3,0v-0.2l0.2,0l0-0.3l-0.3,0 v-0.2l0.2,0L57.6,21.2"
}), /*#__PURE__*/React.createElement("path", {
  className: "sty10",
  d: "M54.7,22.5c0.3,0,0.4-0.2,0.2-0.4c-0.2-0.2-0.5-0.1-0.5,0.1C54.4,22.4,54.5,22.5,54.7,22.5 M54.7,21.8 c0.6,0.1,0.8,0.6,0.4,0.9c-0.4,0.3-1.1,0-1.1-0.5C54.1,22,54.4,21.8,54.7,21.8 M56.3,21.8c0.3,0,0.3-0.2,0.2-0.4 c-0.2-0.2-0.5-0.1-0.5,0.1C56,21.7,56.1,21.8,56.3,21.8 M56.3,21.1c0.6,0.1,0.8,0.7,0.4,0.9c-0.4,0.3-1.1,0-1-0.5 C55.7,21.2,56,21,56.3,21.1 M55,20.9c0.8,1.2,0.8,1.3,1.3,2L56,23c-0.8-1.2-0.8-1.3-1.3-2L55,20.9"
}), /*#__PURE__*/React.createElement("path", {
  className: "sty10",
  d: "M58.8,24.5C58.9,24.5,58.9,24.5,58.8,24.5c0,0.1-0.1,0.2-0.2,0.2c-0.3-0.3-0.6-0.3-0.7,0 c0.2,0,0.5,0.1,0.7,0.2c-0.3-0.1-0.7-0.1-1.1-0.2v-0.1c0-0.3,0.2-0.5,0.8-0.4C58.5,24.3,58.7,24.3,58.8,24.5"
}), /*#__PURE__*/React.createElement("path", {
  className: "sty10",
  d: "M56.2,24.5c-0.1-0.3-0.6-0.3-0.7-0.1v0C55.8,24.5,56,24.5,56.2,24.5L56.2,24.5 M56.7,23.4 c0,0.4,0,0.9,0,1.2c-0.5-0.1-1.1-0.1-1.6-0.1v0c0.1-0.2,0.2-0.4,0.4-0.4c0.3-0.1,0.6,0,0.8,0.2l0,0v-0.8L56.7,23.4"
}), /*#__PURE__*/React.createElement("path", {
  className: "sty10",
  d: "M54.1,24.3c0-0.1-0.2-0.5-0.8-0.5c-0.2,0-0.4,0-0.5,0.1c0.1,0.1,0.2,0.2,0.3,0.3 c0.2-0.2,0.5-0.1,0.6,0.1C53.8,24.3,54,24.3,54.1,24.3C54.2,24.4,54.1,24.3,54.1,24.3"
}), /*#__PURE__*/React.createElement("polyline", {
  className: "sty10",
  points: "55.6,16.5 56.3,16.5 56.3,16.8 55.6,16.8 55.6,16.5  "
}), /*#__PURE__*/React.createElement("polyline", {
  className: "sty10",
  points: "52.7,15.9 53.3,15.9 53.5,16.2 53.8,15.9 54.4,15.9 53.9,16.5 54.5,17.2 53.9,17.2 53.6,16.7  53.2,17.1 52.7,17.1 53.3,16.4 52.7,15.9  "
})));

var _ref13 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  className: "sty11",
  d: "M57.3,43.7c0.2,0,0.3-0.1,0.3-0.2v-0.4H57v0.4C57,43.6,57.1,43.7,57.3,43.7z"
}), /*#__PURE__*/React.createElement("path", {
  className: "sty12",
  d: "M57.3,42.9c-0.2,0-0.3,0.1-0.3,0.2s0.1,0.2,0.3,0.2c0.2,0,0.3-0.1,0.3-0.2C57.5,43,57.4,42.9,57.3,42.9 z"
}));

var _ref14 = /*#__PURE__*/React.createElement("path", {
  className: "sty13",
  d: "M57.3,43.3c0.1,0,0.3-0.1,0.3-0.2v-5.6H57v5.6C57,43.2,57.1,43.3,57.3,43.3z"
});

var _ref15 = /*#__PURE__*/React.createElement("path", {
  className: "sty14",
  d: "M57.3,37.3c-0.1,0-0.3,0.1-0.3,0.2s0.1,0.2,0.3,0.2c0.1,0,0.3-0.1,0.3-0.2 C57.5,37.3,57.4,37.3,57.3,37.3z"
});

var _ref16 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  className: "sty11",
  d: "M66.9,38.3c0.2,0,0.3-0.1,0.3-0.2v-0.4h-0.6V38C66.6,38.2,66.7,38.3,66.9,38.3z"
}), /*#__PURE__*/React.createElement("path", {
  className: "sty12",
  d: "M66.8,37.5c-0.2,0-0.3,0.1-0.3,0.2c0,0.1,0.1,0.2,0.3,0.2s0.3-0.1,0.3-0.2C67.2,37.6,67,37.5,66.8,37.5 z"
})), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  className: "sty15",
  d: "M66.9,37.8c0.1,0,0.3-0.1,0.3-0.2V32h-0.5v5.6C66.6,37.7,66.7,37.8,66.9,37.8z"
}), /*#__PURE__*/React.createElement("path", {
  className: "sty14",
  d: "M66.8,31.9c-0.1,0-0.3,0.1-0.3,0.2c0,0.1,0.1,0.2,0.3,0.2c0.1,0,0.3-0.1,0.3-0.2 C67.1,31.9,67,31.9,66.8,31.9z"
})));

var _ref17 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  className: "sty11",
  d: "M52.7,41.1c0.2,0,0.3-0.1,0.3-0.2v-0.4h-0.6v0.4C52.4,41,52.5,41.1,52.7,41.1z"
}), /*#__PURE__*/React.createElement("path", {
  className: "sty12",
  d: "M52.7,40.3c-0.2,0-0.3,0.1-0.3,0.2c0,0.1,0.1,0.2,0.3,0.2c0.2,0,0.3-0.1,0.3-0.2 C53,40.4,52.8,40.3,52.7,40.3z"
}));

var _ref18 = /*#__PURE__*/React.createElement("path", {
  className: "sty16",
  d: "M52.7,40.6c0.1,0,0.3-0.1,0.3-0.2v-5.6h-0.5v5.6C52.4,40.6,52.5,40.6,52.7,40.6z"
});

var _ref19 = /*#__PURE__*/React.createElement("path", {
  className: "sty14",
  d: "M52.7,34.7c-0.1,0-0.3,0.1-0.3,0.2s0.1,0.2,0.3,0.2c0.1,0,0.3-0.1,0.3-0.2S52.8,34.7,52.7,34.7z"
});

var _ref20 = /*#__PURE__*/React.createElement("path", {
  className: "sty17",
  d: "M67.6,32L67.6,32v-0.4L67,32l-3.8-2.2c-0.5-0.3-1.2-0.3-1.8,0L52.6,35c-0.1-0.2-0.1-0.3-0.1-0.3 c0,0-0.4-0.1-0.4-0.1v0.4c0,0.2,0.1,0.4,0.3,0.5l4,2.3c0.6,0.4,1.4,0.4,2,0l8.8-5.1C67.5,32.5,67.6,32.2,67.6,32z"
});

var _ref21 = /*#__PURE__*/React.createElement("path", {
  className: "sty18",
  d: "M52.4,33.9l9.1-5.3c0.5-0.3,1.2-0.3,1.8,0l4,2.3c0.5,0.3,0.5,1,0,1.3l-8.8,5.1c-0.6,0.4-1.4,0.4-2,0 l-4-2.3C51.9,34.7,51.9,34.1,52.4,33.9z"
});

var _ref22 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  className: "sty19",
  d: "M63.4,32.4L63.4,32.4l-2.6-1.5L57.1,33l-0.6,0v0.1l3.1,1.8l2.1-1.2c0,0,0.3,0,0.5-0.3l1.8-1v-0.1 L63.4,32.4z"
}), /*#__PURE__*/React.createElement("path", {
  className: "sty20",
  d: "M56.4,33l3.1,1.8l2.1-1.2c0,0,0.3,0,0.5-0.3l1.8-1l-3.1-1.8L56.4,33z"
}));

var _ref23 = /*#__PURE__*/React.createElement("path", {
  className: "sty21",
  d: "M61.8,33.2"
});

var _ref24 = /*#__PURE__*/React.createElement("path", {
  className: "sty22",
  d: "M63.5,32.1l-0.1,0l0,0l-2.6-1.5l-1.7,1l2.8,1.5c0,0,0.1-0.1,0.3,0.1l1.7-1v-0.2 C63.8,32.1,63.5,32.1,63.5,32.1z"
});

var _ref25 = /*#__PURE__*/React.createElement("path", {
  className: "sty23",
  d: "M61.8,33.2c0.1-0.6,1.5-0.8,2-1.1l-3.1-1.8c-0.5,0.4-1.9,0.6-2,1.1L61.8,33.2z"
});

var _ref26 = /*#__PURE__*/React.createElement("path", {
  className: "sty22",
  d: "M61.7,33.2l-0.7-0.1L61,33.2l-2.3-1.3l-1.7,1v-0.1l-0.2-0.1h-0.1V33l3,1.8l2-1.2c0.1-0.3,0.2-0.3,0.2-0.3 L61.7,33.2z"
});

var _ref27 = /*#__PURE__*/React.createElement("path", {
  className: "sty24",
  d: "M61.8,33.2c-0.7-0.3-1.4,1-2.2,1.3l-3-1.8c0,0,1.3-1.6,2.1-1.3L61.8,33.2z"
});

var _ref28 = /*#__PURE__*/React.createElement("path", {
  className: "sty25",
  d: "M63.4,31.5c0,0-0.2-0.2-0.3-0.2c-0.1,0-0.3,0-0.4,0c-0.1-0.1-0.1-0.1-0.2-0.1c0-0.1,0-0.2,0.2-0.1 c0.1,0.1,0.2,0,0.2,0c0-0.1-0.2-0.2-0.4-0.3c-0.1,0-0.1-0.2-0.1-0.2c0.1-0.1,0.3-0.2,0.4-0.2c0.3,0.1,0.5,0.3,0.5,0.3l0.2,0.3 v0.4C63.6,31.5,63.4,31.5,63.4,31.5z"
});

var _ref29 = /*#__PURE__*/React.createElement("path", {
  className: "sty26",
  d: "M59.9,34.5c0,0-0.2-0.2-0.3-0.3s-0.4,0-0.5-0.1c-0.1-0.1-0.4-0.3-0.4-0.5c0-0.1,0.2-0.8,0.4-0.7 c0.2,0.1,0.3,0.1,0.4,0.2c0-0.1,0.1-0.1,0.2,0c0.1,0.1,0.1,0.2,0.2,0.4c0.1,0.2,0.3,0.5,0.3,0.5L59.9,34.5z"
});

var _ref30 = /*#__PURE__*/React.createElement("path", {
  className: "sty27",
  d: "M65.5,33.1c0,0-2-1.2-2.2-1.3c-0.2-0.2-0.1-0.7,0.5-0.7c0.5,0.1,2.3,1.4,2.3,1.4L65.5,33.1z"
});

var _ref31 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  className: "sty11",
  d: "M67.5,43c0.1,0,0.2-0.1,0.2-0.1v-0.3h-0.4v0.3C67.2,43,67.3,43,67.5,43z"
}), /*#__PURE__*/React.createElement("path", {
  className: "sty12",
  d: "M67.5,42.5c-0.1,0-0.2,0.1-0.2,0.1c0,0.1,0.1,0.1,0.2,0.1c0.1,0,0.2-0.1,0.2-0.1 C67.7,42.5,67.6,42.5,67.5,42.5z"
}));

var _ref32 = /*#__PURE__*/React.createElement("path", {
  className: "sty28",
  d: "M67.5,42.7c0.1,0,0.2-0.1,0.2-0.1V39h-0.4v3.6C67.3,42.7,67.4,42.7,67.5,42.7z"
});

var _ref33 = /*#__PURE__*/React.createElement("path", {
  className: "sty14",
  d: "M67.5,38.9c-0.1,0-0.2,0.1-0.2,0.1s0.1,0.1,0.2,0.1c0.1,0,0.2-0.1,0.2-0.1 C67.6,38.9,67.6,38.9,67.5,38.9z"
});

var _ref34 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  className: "sty11",
  d: "M64.7,41.4c0.1,0,0.2-0.1,0.2-0.1V41h-0.4v0.3C64.5,41.4,64.6,41.4,64.7,41.4z"
}), /*#__PURE__*/React.createElement("path", {
  className: "sty12",
  d: "M64.7,40.8c-0.1,0-0.2,0.1-0.2,0.1c0,0.1,0.1,0.1,0.2,0.1c0.1,0,0.2-0.1,0.2-0.1S64.8,40.8,64.7,40.8z"
}));

var _ref35 = /*#__PURE__*/React.createElement("path", {
  className: "sty29",
  d: "M64.7,41.1c0.1,0,0.2-0.1,0.2-0.1v-3.4h-0.4V41C64.5,41.1,64.6,41.1,64.7,41.1z"
});

var _ref36 = /*#__PURE__*/React.createElement("path", {
  className: "sty14",
  d: "M64.7,37.4c-0.1,0-0.2,0.1-0.2,0.1c0,0.1,0.1,0.1,0.2,0.1c0.1,0,0.2-0.1,0.2-0.1 C64.9,37.5,64.8,37.4,64.7,37.4z"
});

var _ref37 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  className: "sty11",
  d: "M65,44.4c0.1,0,0.2-0.1,0.2-0.1V44h-0.4v0.3C64.8,44.3,64.9,44.4,65,44.4z"
}), /*#__PURE__*/React.createElement("path", {
  className: "sty12",
  d: "M65,43.8c-0.1,0-0.2,0.1-0.2,0.1s0.1,0.1,0.2,0.1c0.1,0,0.2-0.1,0.2-0.1S65.1,43.8,65,43.8z"
}));

var _ref38 = /*#__PURE__*/React.createElement("path", {
  className: "sty30",
  d: "M65,44.1c0.1,0,0.2-0.1,0.2-0.1v-4.1h-0.4v4.1C64.8,44,64.9,44.1,65,44.1z"
});

var _ref39 = /*#__PURE__*/React.createElement("path", {
  className: "sty14",
  d: "M65,39.8c-0.1,0-0.2,0.1-0.2,0.1c0,0.1,0.1,0.1,0.2,0.1c0.1,0,0.2-0.1,0.2-0.1 C65.2,39.8,65.1,39.8,65,39.8z"
});

var _ref40 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  className: "sty11",
  d: "M62.3,42.8c0.1,0,0.2-0.1,0.2-0.1v-0.3H62v0.3C62,42.7,62.1,42.8,62.3,42.8z"
}), /*#__PURE__*/React.createElement("path", {
  className: "sty12",
  d: "M62.3,42.2c-0.1,0-0.2,0.1-0.2,0.1s0.1,0.1,0.2,0.1c0.1,0,0.2-0.1,0.2-0.1S62.4,42.2,62.3,42.2z"
}));

var _ref41 = /*#__PURE__*/React.createElement("path", {
  className: "sty31",
  d: "M62.3,42.5c0.1,0,0.2-0.1,0.2-0.1v-3.4h-0.4v3.4C62.1,42.4,62.2,42.5,62.3,42.5z"
});

var _ref42 = /*#__PURE__*/React.createElement("path", {
  className: "sty14",
  d: "M62.3,38.8c-0.1,0-0.2,0.1-0.2,0.1c0,0.1,0.1,0.1,0.2,0.1s0.2-0.1,0.2-0.1 C62.5,38.9,62.4,38.8,62.3,38.8z"
});

var _ref43 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  className: "sty32",
  d: "M64.3,40.8L62,39.5c-0.3-0.2-0.3-0.7,0-0.8l2.1-1.2c0.3-0.2,0.8-0.2,1.1,0l2.4,1.4c0.4,0.2,0.4,0.8,0,1 l-1.8,1C65.4,41.1,64.8,41.1,64.3,40.8z"
}), /*#__PURE__*/React.createElement("path", {
  className: "sty26",
  d: "M64.3,40.5L62,39.2c-0.3-0.2-0.3-0.7,0-0.8l2.1-1.2c0.3-0.2,0.8-0.2,1.1,0l2.4,1.4c0.4,0.2,0.4,0.8,0,1 l-1.8,1C65.4,40.8,64.8,40.8,64.3,40.5z"
}));

var _ref44 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  className: "sty33",
  d: "M61.7,42.1c0,0,0.3,0.5,0,0.8c-0.3,0.4-1.9-0.8-2.1-0.9c-0.2-0.2,0-0.9,1.2-0.4 C60.9,41.5,61.7,42.1,61.7,42.1z"
}), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  className: "sty26",
  d: "M64.8,32.9c0,0.3,1.2,0.1,1.2-0.2c0-0.4-0.2-1.2,0-1.9c0.2-0.7-1.4,1-1.4,1S64.8,32.1,64.8,32.9z"
}), /*#__PURE__*/React.createElement("path", {
  className: "sty26",
  d: "M63.7,29.9c0,0,0,1.1,0,1.4c0,0.3,0.3,1,1,0.8c0.7-0.2,0.8-0.7,1.2-0.9c0.4-0.2,0.4-0.6,0.4-0.9 c0-0.3-0.4-1.2-1.3-1.2C64.2,29,63.7,29.5,63.7,29.9z"
})), /*#__PURE__*/React.createElement("path", {
  className: "sty34",
  d: "M62.2,37c0-0.6,0.4-1.1,1.2-0.9c0.7,0.2,1.6,0.8,1.6,0.8l-0.6,1L63.6,38L62.2,37z"
}), /*#__PURE__*/React.createElement("path", {
  className: "sty35",
  d: "M64.3,37.8c0,0-1.8-0.8-2.2-1c-0.4-0.1-1.4-0.1-1.4,0.8s0,4.2,0,4.4c0,0.5,1.1,0.4,1.1,0.1 c0-0.4,0-2.9,0-3.1c0-0.2,0-0.5,0-0.5s1.9,1.2,2.9,1.4c1,0.3,2.9-0.2,2.5-2C66.7,36.1,64.3,37.8,64.3,37.8z"
}), /*#__PURE__*/React.createElement("path", {
  className: "sty36",
  d: "M64.8,32.6c0.2,0.2,1.2,0,1.2-0.3c0.5-0.2,1,0.3,1.1,0.9c0.1,1,0,3.1,0.1,4.6c-0.2,0.5-1.1,0.9-1.7,0.9 c-0.7,0-1.3-0.4-1.3-0.6c0-0.2,0.1-2.3-0.1-2.8c-0.2-0.6-0.3-1.9,0-2.2C64.4,32.7,64.8,32.6,64.8,32.6z"
}), /*#__PURE__*/React.createElement("path", {
  className: "sty27",
  d: "M64.6,33.2c-0.1-0.2-0.5-0.4-0.9-0.1s-1.9,1.4-2.1,1.3c-0.2,0-1.2-0.6-1.3-0.7c-0.2-0.1-0.7,0.3-0.6,0.8 c0.1,0.4,1.7,1,2.2,1c0.4,0.1,1.6-0.8,2.2-1.1C64.6,34.2,64.7,33.6,64.6,33.2z"
}), /*#__PURE__*/React.createElement("path", {
  className: "sty37",
  d: "M64.2,30.9c-0.1-0.1,0.1-0.3,0-0.5c-0.1-0.2-0.4-0.4-0.4-0.6s0.2-0.5,0.5-0.7c0.3-0.1,1-0.2,1.6,0.1 c0.2,0.1,0.5,0.4,0.5,1.2c0,0.6,0,0.6-0.2,1.1c-0.2,0.4-0.6,0.6-0.6,1c-0.1-0.4-0.8-0.3-0.9-0.5c-0.2-0.3-0.4-0.9-0.4-0.9 L64.2,30.9z"
}), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  className: "sty38",
  d: "M64.1,31.2c0,0,0,0.2,0.1,0.2c0.1,0,0.1-0.1,0.3-0.4c0.2-0.3-0.1-0.5-0.3-0.3"
}), /*#__PURE__*/React.createElement("path", {
  className: "sty26",
  d: "M64.1,31.2c0,0,0,0.2,0.1,0.2c0.1,0,0.1-0.1,0.3-0.4c0.2-0.3-0.1-0.5-0.3-0.3"
})), /*#__PURE__*/React.createElement("path", {
  className: "sty39",
  d: "M64.8,32.5C64.8,32.5,64.8,32.6,64.8,32.5c0,0.1,0.2,0.4,0.9,0.2c0.3-0.1,0.3-0.4,0.2-0.5 c0,0,0,0.2-0.3,0.3C65.4,32.6,65.2,32.7,64.8,32.5z"
}));

var _ref45 = /*#__PURE__*/React.createElement("path", {
  className: "sty40",
  d: "M65.6,35l2.4-1.4c0.2-0.1,0.5,0,0.5,0.3v3.2c0,0.3-0.2,0.7-0.5,0.9l-2.3,1.3c-0.3,0.1-0.6,0-0.6-0.3 v-3.2C65.1,35.5,65.3,35.1,65.6,35z"
});

var _ref46 = /*#__PURE__*/React.createElement("path", {
  className: "sty41",
  d: "M65.8,35.1l2.4-1.4c0.2-0.1,0.5,0,0.5,0.3v3.2c0,0.3-0.2,0.7-0.5,0.9l-2.3,1.3c-0.3,0.1-0.6,0-0.6-0.3 v-3.2C65.3,35.6,65.5,35.3,65.8,35.1z"
});

var _ref47 = /*#__PURE__*/React.createElement("path", {
  className: "sty42",
  d: "M67.9,35.9c-0.2-0.1-0.4-0.1-0.6,0L67.1,36c-0.5,0.3-0.8,0.8-0.8,1.4v3.2c0,0.1-0.1,0.2-0.2,0.3 c-0.1,0.1-0.2,0.1-0.4,0l0,0l0,0c-0.1,0-0.2,0.1-0.4,0.1l0.3,0.2c0.1,0.1,0.2,0.1,0.3,0.1s0.2,0,0.3-0.1 c0.2-0.1,0.3-0.3,0.3-0.5v-3.2c0-0.5,0.3-0.9,0.7-1.2l0.2-0.1c0.1-0.1,0.2-0.1,0.3,0c0.1,0.1,0.2,0.2,0.2,0.3v3.2 c0,0.1-0.1,0.2-0.2,0.3c-0.1,0.1-0.2,0.1-0.4,0l0,0l-0.3,0.2l0.2,0.1c0.2,0.1,0.4,0.1,0.7,0c0.2-0.1,0.3-0.3,0.3-0.5v-3.2 C68.3,36.2,68.2,36,67.9,35.9z"
});

var _ref48 = /*#__PURE__*/React.createElement("polygon", {
  className: "sty43",
  points: "31.7,22.4 47,13.6 47,26.8 31.7,35.7  "
});

var _ref49 = /*#__PURE__*/React.createElement("polygon", {
  className: "sty44",
  points: "32,22.5 46.7,14.1 46.7,26.7 32,35.2  "
});

var _ref50 = /*#__PURE__*/React.createElement("polygon", {
  className: "sty45",
  points: "31.7,35.7 31.3,35.5 31.3,22.2 31.7,22.4  "
});

var _ref51 = /*#__PURE__*/React.createElement("polygon", {
  className: "sty46",
  points: "31.3,22.2 46.7,13.4 47,13.6 31.7,22.4  "
});

var _ref52 = /*#__PURE__*/React.createElement("polygon", {
  className: "sty47",
  points: "46.7,26.7 32,35.2 32,35.1 46.6,26.6  "
});

var _ref53 = /*#__PURE__*/React.createElement("polygon", {
  className: "sty48",
  points: "46.7,26.7 46.7,14.1 46.6,14.1 46.6,26.6  "
});

var _ref54 = /*#__PURE__*/React.createElement("path", {
  className: "sty49",
  d: "M30.6,24.9c0,0.3-0.3,0.7-0.6,0.7c-0.3,0-0.6-0.3-0.6-0.7c0-0.3,0.3-0.7,0.6-0.7 C30.3,24.3,30.6,24.6,30.6,24.9z"
});

var _ref55 = /*#__PURE__*/React.createElement("path", {
  className: "sty50",
  d: "M29.7,25.1c0,0.2,0.1,0.3,0.2,0.4c0,0,0.1,0,0.1,0c0.3,0,0.6-0.3,0.6-0.7c0-0.2-0.1-0.3-0.2-0.4 c0,0-0.1,0-0.1,0C30,24.5,29.7,24.7,29.7,25.1z"
});

var _ref56 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  className: "sty43",
  d: "M38.4,27.7c-0.2,0.1-0.3,0.1-0.5,0.1c-0.9,0.3-0.7,0.3-0.7,0.3l-0.3-0.2c0,0-0.1,0,0.4-0.3 c0,0,0.5-0.2,0.6-0.3c0.2,0.1,0.3-0.2,0.4-0.3c0,0,0.2,0,0.2,0.1c0,0,0,0.4,0,0.4C38.6,27.6,38.5,27.7,38.4,27.7z"
}));

var _ref57 = /*#__PURE__*/React.createElement("path", {
  className: "sty51",
  d: "M34.7,29.2L34.7,29.2c-0.3,0-2.8-0.8-3.1-0.9c-0.3-0.1-0.6-0.2-0.5-0.5c0-0.2,0.4-0.5,0.9-0.5 c0.5,0,2.6,1.1,2.7,1.1c0,0,2.4-1,2.6-0.9l0.3,0.6L34.7,29.2z"
});

var _ref58 = /*#__PURE__*/React.createElement("path", {
  className: "sty52",
  d: "M37.5,28C37.5,28,37.4,28,37.5,28c-0.1-0.1-0.1-0.3-0.1-0.3l0.1-0.1l-0.1,0c0,0,0-0.1,0-0.2 c0,0,0-0.1,0-0.1c0.1,0,0.1,0,0.2,0c0,0,0,0,0,0c0.1,0.1,0.1,0.4,0.2,0.6c0,0,0,0.1,0,0.1L37.5,28z"
});

var _ref59 = /*#__PURE__*/React.createElement("path", {
  className: "sty43",
  d: "M32.8,43.2c0-0.1-0.3-0.5-0.4-1c0-0.1,0-0.2,0-0.3c-0.1,0.1-0.5,0.1-0.7,0c0,0.1,0,0.2,0,0.2v0.1l0.1,0.3 l0.4,0.7c0,0,0.2,0,0.2,0C32.4,43.4,32.8,43.4,32.8,43.2z"
});

var _ref60 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  className: "sty53",
  d: "M31.7,43.1L31.7,43.1C31.7,43.1,31.6,43,31.7,43.1l-0.1-0.6h0.1L31.7,43.1C31.7,43,31.7,43.1,31.7,43.1z"
}), /*#__PURE__*/React.createElement("path", {
  className: "sty54",
  d: "M31.8,41.9c0,0-0.2,0-0.2,0.4c0,0.4,0.2,0.3,0.3,0.5c0.1,0.2,0.2,0.5,0.5,0.7c0.3,0.1,0.5,0.2,0.8,0.2 c0.1,0,0-0.2,0-0.2c0,0-0.2-0.3-0.3-0.4h0c0,0-0.1,0.2-0.3,0.2c-0.1,0-0.3,0.1-0.7-1.2L31.8,41.9z"
}), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  className: "sty53",
  d: "M32.8,43C32.8,43,32.8,43,32.8,43C32.8,43.1,32.8,43.1,32.8,43C32.8,43.1,32.8,43,32.8,43z"
}), /*#__PURE__*/React.createElement("path", {
  className: "sty53",
  d: "M32.4,43.4c-0.3-0.1-0.4-0.4-0.5-0.7c-0.1-0.2-0.3-0.1-0.3-0.5c0-0.2,0-0.3,0.1-0.3 c-0.1,0-0.1,0.1-0.1,0.4c0,0.4,0.2,0.3,0.3,0.5C31.9,43,32,43.4,32.4,43.4c0.2,0.2,0.5,0.3,0.7,0.2c0,0,0,0,0-0.1 C32.9,43.6,32.7,43.5,32.4,43.4z"
})));

var _ref61 = /*#__PURE__*/React.createElement("path", {
  className: "sty43",
  d: "M30.5,42.6c-0.1,0.9-0.2,1.1,0,1.3c0.1,0.2,0.5,0.3,0.6,0.1c0-0.1,0-0.4,0-0.6c0-0.4-0.1-0.3-0.1-1 C31,42.1,30.5,42.6,30.5,42.6z"
});

var _ref62 = /*#__PURE__*/React.createElement("path", {
  className: "sty54",
  d: "M30.5,42.6c0,0-0.1,0.8,0,1.1c0.1,0.3,0.4,0.3,0.5,0.1c0.1-0.1,0-0.3,0-0.5c0-0.1,0.1,0.3,0.1,0.5 c0,0.1,0,0.2,0,0.2L31,44.6c0,0.1-0.1,0.1-0.2,0.1h-0.1c-0.1,0-0.1,0-0.1-0.1l-0.2-0.4c-0.1-0.2-0.1-0.3-0.1-0.5 c0-0.3,0.1-0.1,0-0.4C30.2,43,30.4,42.6,30.5,42.6z"
});

var _ref63 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  className: "sty53",
  d: "M30.9,44.6L30.9,44.6c-0.1,0-0.2,0-0.2-0.1l-0.2-0.4c-0.1-0.2-0.1-0.3-0.1-0.5c0-0.3,0.1-0.1,0-0.4 c-0.1-0.1,0-0.4,0.1-0.5c-0.1,0.1-0.2,0.4-0.1,0.6c0.1,0.4,0,0.2,0,0.4c0,0.2,0,0.3,0.1,0.5l0.2,0.4c0,0.1,0.1,0.1,0.1,0.1 L30.9,44.6c0,0,0.1,0,0.1-0.1C31,44.6,31,44.6,30.9,44.6z"
}));

var _ref64 = /*#__PURE__*/React.createElement("path", {
  className: "sty55",
  d: "M31.7,41.9c0,0.2,0.7,0.3,0.7,0c0-1.2,0.3-3.7,0.3-3.8c1-3.6,0.1-5.9,0.1-5.9c-0.2-0.1-1.1-0.1-1.1-0.1 s-0.5,0.9-0.4,2c0,1.1,0.3,3.7,0.3,3.7C31.4,38.8,31.9,40.6,31.7,41.9z"
});

var _ref65 = /*#__PURE__*/React.createElement("path", {
  className: "sty56",
  d: "M32.8,32.2c-0.2-0.1-1.1-0.1-1.1-0.1s0,0-0.1,0.1c0.3,0,0.8,0.1,0.9,0.1c0,0,0.9,2.3-0.1,5.9 c0.1,0.2-0.3,2.6-0.3,3.8c0,0,0,0,0,0c0.1,0,0.3-0.1,0.3-0.1c0-1.2,0.3-3.7,0.3-3.8C33.6,34.5,32.8,32.2,32.8,32.2z"
});

var _ref66 = /*#__PURE__*/React.createElement("path", {
  className: "sty57",
  d: "M30.2,32.6c-0.3,0.2-0.5,0.8-0.5,1.4c0.1,1,1.1,3,0.9,3.9c-0.5,1.5,0.1,3.4-0.1,4.7 c0.1,0.4,0.6,0.4,0.6,0.1c0,0,0.4-2.6,0.7-4.8c0.1-2.5,0.5-2.7,0.1-5.1C31.8,32.4,30.2,32.6,30.2,32.6z"
});

var _ref67 = /*#__PURE__*/React.createElement("path", {
  className: "sty56",
  d: "M31.8,32.8c0-0.2-0.3-0.2-0.6-0.2c0.1,0,0.2,0.1,0.2,0.2c0.4,2.5,0,2.7-0.1,5.3c-0.3,2.2-0.7,4.9-0.7,4.9 v0c0.2,0.1,0.3,0,0.3-0.2c0,0,0.4-2.6,0.7-4.8C31.8,35.5,32.2,35.3,31.8,32.8z"
});

var _ref68 = /*#__PURE__*/React.createElement("path", {
  className: "sty58",
  d: "M31,27.4c-0.1,0-0.5,0.3-0.9,0.4c-0.3,0.2-0.4,0.5-0.4,0.9c0,0.7,0.2,1.3,0.6,2c0.2,0.4,0.2,1.1-0.2,1.8 c0.3,0.4,1.1,0.5,1.5,0.4c0.9-0.1,1.3-0.6,1.2-1c0,0-0.2-0.9-0.2-1.4c0-0.4,0.1-0.9,0.1-1.1c0.3-0.1,0.6-0.5,0.2-1.2 c0-0.2,0-1.1-0.7-1.2C31.8,27.3,31.2,27.4,31,27.4C31,27.4,31,27.4,31,27.4z"
});

var _ref69 = /*#__PURE__*/React.createElement("path", {
  className: "sty43",
  d: "M30.9,27.7l-0.2,0.1l0.6,0.8c0.2,0.2,0.5,0.3,0.8,0.2l0.1-0.1c0.2-0.1,0.2-0.3,0.1-0.5l-0.4-0.7L30.9,27.7z "
});

var _ref70 = /*#__PURE__*/React.createElement("path", {
  className: "sty43",
  d: "M31.9,27.8l0.1,0.5c0,0.2-0.2,0.3-0.4,0.2l-0.7-0.8l0.3,0.1c0.1-0.1,0.4-0.1,0.4-0.1L31.9,27.8z"
});

var _ref71 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  className: "sty43",
  d: "M31,26.8c0,0,0,0.4-0.1,0.9c0.2,0.3,0.9,0.5,1,0.1c0,0,0-0.3,0.1-0.5C32.1,27.1,31,26.8,31,26.8z"
}), /*#__PURE__*/React.createElement("path", {
  className: "sty59",
  d: "M31,26.8c0,0,0,0.1,0,0.3c0.1,0.1,0.1,0.1,0.1,0.1c0.2,0.3,0.5,0.5,0.8,0.5c0-0.1,0-0.3,0.1-0.5 C32.1,27.1,31,26.8,31,26.8z"
}), /*#__PURE__*/React.createElement("path", {
  className: "sty43",
  d: "M32.3,25.2c0,0,0.2,0.4,0.2,0.9c0,0.1,0.1,0.2,0.1,0.4c0,0.2-0.1,0.6-0.1,0.8c0,0.1-0.1,0.1-0.1,0.1 c-0.4,0.1-1,0.1-1.5-0.5c0,0-0.2-0.3-0.3-0.3c-0.1,0-0.5-0.5-0.5-1c0-0.4,0.2-1.1,1.1-1.1C32,24.6,32.3,25.2,32.3,25.2z"
}), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  className: "sty60",
  d: "M32.6,26.1c0-0.5-0.2-0.9-0.2-0.9S32.2,25,32,24.8c0.1,0.1,0.2,0.2,0.2,0.2s0.4,0.5,0.4,1 c0,0.1,0.1,0.1,0.1,0.4c0,0.2-0.1,0.6-0.1,0.8c0,0.1-0.1,0.1-0.1,0.1c-0.3,0-0.7,0.1-1.1-0.1c0.4,0.3,0.9,0.3,1.2,0.2 c0.1,0,0.1-0.1,0.1-0.1c0-0.2,0.1-0.6,0.1-0.8C32.7,26.3,32.6,26.2,32.6,26.1z"
}), /*#__PURE__*/React.createElement("path", {
  className: "sty61",
  d: "M30.6,26.6C30.6,26.7,30.6,26.7,30.6,26.6C30.6,26.7,30.6,26.6,30.6,26.6z"
})));

var _ref72 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  className: "sty43",
  d: "M30,33.4c0,0,0,1,0.1,1.5c-0.1,0.1-0.5,0.3-0.5,0.2c-0.1-0.9-0.2-1.7-0.2-1.7H30z"
}), /*#__PURE__*/React.createElement("path", {
  className: "sty43",
  d: "M29.6,35.1c0,0,0.1,0.7,0.1,0.8c0.1,0.1,0.2,0.1,0.4,0.2c0.3,0.1,0.4-0.1,0.4-0.1s0-0.3,0-0.4 c0-0.2-0.3-0.2-0.3-0.5c-0.1-0.3-0.5,0-0.5,0V35.1z"
}), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  className: "sty62",
  d: "M30.5,35.8c-0.1,0-0.2,0-0.2-0.1c-0.1-0.1-0.1-0.1-0.1-0.2c0.1,0.1,0.1,0.1,0.1,0.2 C30.4,35.7,30.5,35.7,30.5,35.8z"
})), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  className: "sty62",
  d: "M30.2,35.6c0-0.1,0-0.1,0.1-0.2C30.3,35.4,30.3,35.6,30.2,35.6z"
}))));

var _ref73 = /*#__PURE__*/React.createElement("path", {
  className: "sty63",
  d: "M29.1,31.6c0,0,0-0.1,0-0.1c0-0.3,0.3-2.8,0.4-3.1c0.1-0.3,0.3-0.5,0.6-0.5c0.2,0.1,0.5,0.5,0.4,1 c-0.1,0.5-0.6,2.7-0.6,2.8c0,0,0.2,3,0.1,3.2l-0.5,0.2L29.1,31.6z"
});

var _ref74 = /*#__PURE__*/React.createElement("path", {
  className: "sty64",
  d: "M29.5,35C29.5,35,29.5,35,29.5,35c0.1-0.1,0.2-0.1,0.3-0.1l0.1,0.1l0-0.1c0,0,0.2,0,0.3-0.1 c0,0,0,0,0.1,0c0,0.1,0,0.1,0,0.2c0,0,0,0,0,0c0,0.1-0.5,0.1-0.6,0.2c0,0-0.1,0-0.1,0L29.5,35z"
});

var _ref75 = /*#__PURE__*/React.createElement("path", {
  className: "sty49",
  d: "M31.2,25.6c-0.2,0.2-0.1,0.8-0.3,0.8c0,0,0.1,0.4,0.1,0.7c-0.1-0.3-0.4-0.4-0.7-0.8 c-0.1-0.2-0.3-0.3-0.3-0.6c0-0.2,0.1-0.7,0.3-1c0-0.3,1.1-0.6,1.9,0c0.3,0.3,0.3,0.5,0.3,0.5C32,24.8,31.4,25.2,31.2,25.6z"
});

var _ref76 = /*#__PURE__*/React.createElement("path", {
  className: "sty65",
  d: "M30,25.4c0,0.1,0,0.2,0,0.3c0,0.3,0.2,0.4,0.3,0.6c0.3,0.4,0.6,0.5,0.7,0.8c0-0.3-0.1-0.7-0.1-0.7l-0.1,0.1 C30.6,26.5,30.1,25.8,30,25.4z"
});

var _ref77 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  className: "sty66",
  d: "M30.8,26.4c-0.2-0.2-0.4,0-0.2,0.2c0,0,0.1,0.1,0.1,0.1c0,0,0,0,0,0.1c0,0,0.1,0.1,0.1,0.1 c0,0,0.1,0,0.1,0L30.8,26.4z"
}), /*#__PURE__*/React.createElement("path", {
  className: "sty43",
  d: "M31,26.4c-0.1-0.2-0.3-0.1-0.3,0.1c0,0.1,0.1,0.1,0.1,0.1c0,0.2,0.1,0.3,0.2,0.2"
}));

var _ref78 = /*#__PURE__*/React.createElement("path", {
  className: "sty67",
  d: "M30.9,26.8C30.9,26.9,30.9,26.9,30.9,26.8c-0.1,0.1-0.1,0-0.1,0S30.8,26.8,30.9,26.8 C30.9,26.8,30.9,26.8,30.9,26.8z"
});

var _ref79 = /*#__PURE__*/React.createElement("path", {
  className: "sty43",
  d: "M37.8,27.3c0.1-0.2,0.3-0.1,0.4-0.3s0-0.1,0-0.1s0.2,0,0.1,0.2c-0.1,0.1-0.1,0.1-0.2,0.2 C38.1,27.5,37.8,27.4,37.8,27.3L37.8,27.3z"
});

var _ref80 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  className: "sty11",
  d: "M42.8,52.9c0.2,0,0.3-0.1,0.3-0.2v-0.4h-0.6v0.4C42.5,52.8,42.6,52.9,42.8,52.9z"
}), /*#__PURE__*/React.createElement("path", {
  className: "sty12",
  d: "M42.8,52.1c-0.2,0-0.3,0.1-0.3,0.2s0.1,0.2,0.3,0.2c0.2,0,0.3-0.1,0.3-0.2C43.1,52.2,43,52.1,42.8,52.1 z"
}));

var _ref81 = /*#__PURE__*/React.createElement("path", {
  className: "sty68",
  d: "M42.8,52.5c0.1,0,0.3-0.1,0.3-0.2v-5.6h-0.5v5.6C42.5,52.4,42.6,52.5,42.8,52.5z"
});

var _ref82 = /*#__PURE__*/React.createElement("path", {
  className: "sty14",
  d: "M42.8,46.5c-0.1,0-0.3,0.1-0.3,0.2c0,0.1,0.1,0.2,0.3,0.2c0.1,0,0.3-0.1,0.3-0.2 C43.1,46.6,42.9,46.5,42.8,46.5z"
});

var _ref83 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  className: "sty11",
  d: "M52.4,47.5c0.2,0,0.3-0.1,0.3-0.2v-0.4h-0.6v0.4C52.1,47.4,52.2,47.5,52.4,47.5z"
}), /*#__PURE__*/React.createElement("path", {
  className: "sty12",
  d: "M52.4,46.7c-0.2,0-0.3,0.1-0.3,0.2s0.1,0.2,0.3,0.2c0.2,0,0.3-0.1,0.3-0.2S52.6,46.7,52.4,46.7z"
})), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  className: "sty15",
  d: "M52.4,47c0.1,0,0.3-0.1,0.3-0.2v-5.6h-0.5v5.6C52.1,47,52.3,47,52.4,47z"
}), /*#__PURE__*/React.createElement("path", {
  className: "sty14",
  d: "M52.4,41.1c-0.1,0-0.3,0.1-0.3,0.2s0.1,0.2,0.3,0.2c0.1,0,0.3-0.1,0.3-0.2 C52.6,41.1,52.5,41.1,52.4,41.1z"
})));

var _ref84 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  className: "sty11",
  d: "M38.2,50.3c0.2,0,0.3-0.1,0.3-0.2v-0.4h-0.6V50C37.9,50.2,38,50.3,38.2,50.3z"
}), /*#__PURE__*/React.createElement("path", {
  className: "sty12",
  d: "M38.2,49.5c-0.2,0-0.3,0.1-0.3,0.2s0.1,0.2,0.3,0.2c0.2,0,0.3-0.1,0.3-0.2 C38.5,49.6,38.4,49.5,38.2,49.5z"
})), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  className: "sty15",
  d: "M38.2,49.8c0.1,0,0.3-0.1,0.3-0.2V44H38v5.6C37.9,49.8,38,49.8,38.2,49.8z"
}), /*#__PURE__*/React.createElement("path", {
  className: "sty14",
  d: "M38.2,43.9c-0.1,0-0.3,0.1-0.3,0.2s0.1,0.2,0.3,0.2c0.1,0,0.3-0.1,0.3-0.2S38.4,43.9,38.2,43.9z"
})));

var _ref85 = /*#__PURE__*/React.createElement("path", {
  className: "sty69",
  d: "M53.1,41.2L53.1,41.2v-0.4l-0.6,0.4L48.8,39c-0.5-0.3-1.2-0.3-1.8,0l-8.9,5.2C38.1,44,38,43.8,38,43.8 c0,0-0.4-0.1-0.4-0.1v0.4c0,0.2,0.1,0.4,0.3,0.5l4,2.3c0.6,0.4,1.4,0.4,2,0l8.8-5.1C53,41.7,53.1,41.4,53.1,41.2z"
});

var _ref86 = /*#__PURE__*/React.createElement("path", {
  className: "sty70",
  d: "M37.9,43.1l9.1-5.3c0.5-0.3,1.2-0.3,1.8,0l4,2.3c0.5,0.3,0.5,1,0,1.3l-8.8,5.1c-0.6,0.4-1.4,0.4-2,0 l-4-2.3C37.5,43.9,37.5,43.4,37.9,43.1z"
});

var _ref87 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  className: "sty19",
  d: "M49,41.6L49,41.6l-2.6-1.5l-3.8,2.2l-0.6,0v0.1l3.1,1.8l2.1-1.2c0,0,0.3,0,0.5-0.3l1.8-1v-0.1L49,41.6z"
}), /*#__PURE__*/React.createElement("path", {
  className: "sty20",
  d: "M42,42.2l3.1,1.8l2.1-1.2c0,0,0.3,0,0.5-0.3l1.8-1l-3.1-1.8L42,42.2z"
}));

var _ref88 = /*#__PURE__*/React.createElement("path", {
  className: "sty21",
  d: "M47.3,42.4"
});

var _ref89 = /*#__PURE__*/React.createElement("path", {
  className: "sty22",
  d: "M49,41.4l-0.1,0l0,0l-2.6-1.5l-1.7,1l2.8,1.5c0,0,0.1-0.1,0.3,0.1l1.7-1v-0.2L49,41.4L49,41.4z"
});

var _ref90 = /*#__PURE__*/React.createElement("path", {
  className: "sty71",
  d: "M47.3,42.4c0.1-0.6,1.5-0.8,2-1.1l-3.1-1.8c-0.5,0.4-1.9,0.6-2,1.1L47.3,42.4z"
});

var _ref91 = /*#__PURE__*/React.createElement("path", {
  className: "sty22",
  d: "M47.2,42.4l-0.7-0.1l-0.1,0.1l-2.3-1.3l-1.7,1V42l-0.2-0.1h-0.1v0.2l3,1.8l2-1.2c0.1-0.3,0.2-0.3,0.2-0.3 L47.2,42.4z"
});

var _ref92 = /*#__PURE__*/React.createElement("path", {
  className: "sty72",
  d: "M47.3,42.4c-0.7-0.3-1.4,1-2.2,1.3l-3-1.8c0,0,1.3-1.6,2.1-1.3L47.3,42.4z"
});

var _ref93 = /*#__PURE__*/React.createElement("path", {
  className: "sty26",
  d: "M49.2,40.3L48.9,40c0,0-0.2-0.3-0.5-0.3c-0.2,0-0.3,0.1-0.4,0.2c-0.1,0.1,0,0.2,0.1,0.2 c0.2,0.1,0.4,0.2,0.4,0.3c0,0-0.1,0-0.2,0c-0.1-0.1-0.2,0-0.2,0.1c0,0,0.1,0.1,0.2,0.1c0.1,0.1,0.3,0,0.4,0 c0.1,0,0.3,0.2,0.3,0.2c0.2,0.1,1,0.8,1.5,1.1c0.5,0.3,1.4,0.5,1.5,0.3c0.1-0.2-2.5-1.8-2.5-1.8L49.2,40.3z"
});

var _ref94 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  className: "sty11",
  d: "M53,52.2c0.1,0,0.2-0.1,0.2-0.1v-0.3h-0.4v0.3C52.8,52.2,52.9,52.2,53,52.2z"
}), /*#__PURE__*/React.createElement("path", {
  className: "sty12",
  d: "M53,51.7c-0.1,0-0.2,0.1-0.2,0.1c0,0.1,0.1,0.1,0.2,0.1s0.2-0.1,0.2-0.1C53.2,51.8,53.1,51.7,53,51.7z"
}));

var _ref95 = /*#__PURE__*/React.createElement("path", {
  className: "sty73",
  d: "M53,51.9c0.1,0,0.2-0.1,0.2-0.1v-3.6h-0.4v3.6C52.8,51.9,52.9,51.9,53,51.9z"
});

var _ref96 = /*#__PURE__*/React.createElement("path", {
  className: "sty14",
  d: "M53,48.1c-0.1,0-0.2,0.1-0.2,0.1c0,0.1,0.1,0.1,0.2,0.1s0.2-0.1,0.2-0.1C53.1,48.1,53.1,48.1,53,48.1z"
});

var _ref97 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  className: "sty11",
  d: "M50.2,50.6c0.1,0,0.2-0.1,0.2-0.1v-0.3H50v0.3C50,50.6,50.1,50.6,50.2,50.6z"
}), /*#__PURE__*/React.createElement("path", {
  className: "sty12",
  d: "M50.2,50.1c-0.1,0-0.2,0.1-0.2,0.1s0.1,0.1,0.2,0.1s0.2-0.1,0.2-0.1C50.4,50.1,50.3,50.1,50.2,50.1z"
}));

var _ref98 = /*#__PURE__*/React.createElement("path", {
  className: "sty74",
  d: "M50.2,50.3c0.1,0,0.2-0.1,0.2-0.1v-3.4H50v3.4C50.1,50.3,50.1,50.3,50.2,50.3z"
});

var _ref99 = /*#__PURE__*/React.createElement("path", {
  className: "sty14",
  d: "M50.2,46.7c-0.1,0-0.2,0.1-0.2,0.1c0,0.1,0.1,0.1,0.2,0.1c0.1,0,0.2-0.1,0.2-0.1 C50.4,46.7,50.3,46.7,50.2,46.7z"
});

var _ref100 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  className: "sty11",
  d: "M50.5,53.6c0.1,0,0.2-0.1,0.2-0.1v-0.3h-0.4v0.3C50.3,53.6,50.4,53.6,50.5,53.6z"
}), /*#__PURE__*/React.createElement("path", {
  className: "sty12",
  d: "M50.5,53.1c-0.1,0-0.2,0.1-0.2,0.1s0.1,0.1,0.2,0.1s0.2-0.1,0.2-0.1C50.7,53.1,50.6,53.1,50.5,53.1z"
}));

var _ref101 = /*#__PURE__*/React.createElement("path", {
  className: "sty75",
  d: "M50.5,53.3c0.1,0,0.2-0.1,0.2-0.1v-4.1h-0.4v4.1C50.3,53.2,50.4,53.3,50.5,53.3z"
});

var _ref102 = /*#__PURE__*/React.createElement("path", {
  className: "sty14",
  d: "M50.5,49c-0.1,0-0.2,0.1-0.2,0.1c0,0.1,0.1,0.1,0.2,0.1s0.2-0.1,0.2-0.1C50.7,49,50.6,49,50.5,49z"
});

var _ref103 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  className: "sty11",
  d: "M47.8,52c0.1,0,0.2-0.1,0.2-0.1v-0.3h-0.4v0.3C47.6,51.9,47.7,52,47.8,52z"
}), /*#__PURE__*/React.createElement("path", {
  className: "sty12",
  d: "M47.8,51.4c-0.1,0-0.2,0.1-0.2,0.1c0,0.1,0.1,0.1,0.2,0.1s0.2-0.1,0.2-0.1C48,51.5,47.9,51.4,47.8,51.4 z"
}));

var _ref104 = /*#__PURE__*/React.createElement("path", {
  className: "sty76",
  d: "M47.8,51.7c0.1,0,0.2-0.1,0.2-0.1v-3.4h-0.4v3.4C47.6,51.6,47.7,51.7,47.8,51.7z"
});

var _ref105 = /*#__PURE__*/React.createElement("path", {
  className: "sty14",
  d: "M47.8,48c-0.1,0-0.2,0.1-0.2,0.1c0,0.1,0.1,0.1,0.2,0.1c0.1,0,0.2-0.1,0.2-0.1C48,48.1,47.9,48,47.8,48 z"
});

var _ref106 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  className: "sty32",
  d: "M49.8,50l-2.3-1.3c-0.3-0.2-0.3-0.7,0-0.8l2.1-1.2c0.3-0.2,0.8-0.2,1.1,0l2.4,1.4c0.4,0.2,0.4,0.8,0,1 l-1.8,1C50.9,50.3,50.3,50.3,49.8,50z"
}), /*#__PURE__*/React.createElement("path", {
  className: "sty26",
  d: "M49.8,49.8l-2.3-1.3c-0.3-0.2-0.3-0.7,0-0.8l2.1-1.2c0.3-0.2,0.8-0.2,1.1,0l2.4,1.4c0.4,0.2,0.4,0.8,0,1 l-1.8,1C50.9,50,50.3,50,49.8,49.8z"
}));

var _ref107 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  className: "sty33",
  d: "M47.2,51.3c0,0,0.3,0.5,0,0.8c-0.3,0.4-1.9-0.8-2.1-0.9c-0.2-0.2,0-0.9,1.2-0.4 C46.4,50.8,47.2,51.3,47.2,51.3z"
}), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  className: "sty26",
  d: "M50.4,42.1c0,0.3,1.2,0.1,1.2-0.2c0-0.4-0.2-1.2,0-1.9c0.2-0.7-1.4,1-1.4,1S50.4,41.3,50.4,42.1z"
}), /*#__PURE__*/React.createElement("path", {
  className: "sty26",
  d: "M49.2,39.1c0,0,0,1.1,0,1.4c0,0.3,0.3,1,1,0.8c0.7-0.2,0.8-0.7,1.2-0.9c0.4-0.2,0.4-0.6,0.4-0.9 c0-0.3-0.4-1.2-1.3-1.2S49.2,38.7,49.2,39.1z"
})), /*#__PURE__*/React.createElement("path", {
  className: "sty34",
  d: "M47.7,46.2c0-0.6,0.4-1.1,1.2-0.9s1.6,0.8,1.6,0.8l-0.6,1l-0.8,0.2L47.7,46.2z"
}), /*#__PURE__*/React.createElement("path", {
  className: "sty35",
  d: "M49.8,47c0,0-1.8-0.8-2.2-1c-0.4-0.1-1.4-0.1-1.4,0.8s0,4.2,0,4.4c0,0.5,1.1,0.4,1.1,0.1 c0-0.4,0-2.9,0-3.1s0-0.5,0-0.5s1.9,1.2,2.9,1.4c1,0.3,2.9-0.2,2.5-2C52.2,45.4,49.8,47,49.8,47z"
}), /*#__PURE__*/React.createElement("path", {
  className: "sty36",
  d: "M50.4,41.8c0.2,0.2,1.2,0,1.2-0.3c0.5-0.2,1,0.3,1.1,0.9c0.1,1,0,3.1,0.1,4.6c-0.2,0.5-1.1,0.9-1.7,0.9 c-0.7,0-1.3-0.4-1.3-0.6c0-0.2,0.1-2.3-0.1-2.8c-0.2-0.6-0.3-1.9,0-2.2C50,41.9,50.4,41.8,50.4,41.8z"
}), /*#__PURE__*/React.createElement("path", {
  className: "sty26",
  d: "M47.3,43.7c0.1,0,1.2-0.8,1.5-1c0.3-0.2,0.6-0.1,0.7,0.1c0.1,0.3,0.1,0.7-0.4,0.9 c-0.4,0.2-1.3,0.8-1.6,0.8c-0.3,0-1.8-1.1-1.8-1.1s-0.2-0.1-0.3-0.2c-0.1,0-0.3,0-0.5-0.1c-0.1-0.1-0.4-0.3-0.4-0.4 c0-0.1,0.2-0.7,0.4-0.6c0.2,0.1,0.3,0.1,0.4,0.2c0-0.1,0.1-0.1,0.2,0c0.1,0.1,0.1,0.2,0.2,0.3c0.1,0.2,0.2,0.3,0.2,0.3 S47.1,43.7,47.3,43.7z"
}), /*#__PURE__*/React.createElement("path", {
  className: "sty39",
  d: "M50.4,41.8C50.4,41.8,50.3,41.8,50.4,41.8c0,0.1,0.2,0.4,0.9,0.2c0.3-0.1,0.3-0.4,0.2-0.5 c0,0,0,0.2-0.3,0.3C51,41.9,50.7,41.9,50.4,41.8z"
}), /*#__PURE__*/React.createElement("path", {
  className: "sty77",
  d: "M49.2,38.8c0,0,0.2,0.8,0.7,1c0.1,0,0.1,0.1,0.2,0.2c0.1,0.1,0.1,0.8,0.2,0.9c0,0-0.1,0.2,0.1,0.3 c0,0,0.1,0.1,0.3,0.1c0,0,0.3,0,0.5-0.2c0,0,0.1,0,0.3-0.1c0.1-0.1,0.2-0.1,0.2-0.3c0-0.2,0.1-0.2,0.2-0.3 c0.1-0.1,0-0.4,0.1-0.5c0.1,0,0.2-0.1,0.2-0.3c0-0.2-0.2-0.4-0.2-0.5c0-0.1,0-0.2-0.1-0.4c-0.1-0.2-0.2-0.1-0.2-0.3 c0-0.2-0.1-0.3-0.2-0.3s-0.2,0-0.3,0C50.8,38,50.8,38,50.6,38c-0.2,0-0.3,0.1-0.4,0.1s-0.3,0-0.4,0.1 c-0.1,0.1-0.1,0.1-0.3,0.1C49.3,38.3,49.1,38.5,49.2,38.8z"
}), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  className: "sty38",
  d: "M49.6,40.5c0,0,0,0.2,0.1,0.2c0.1,0,0.1-0.1,0.3-0.4c0.2-0.3-0.1-0.5-0.3-0.3"
}), /*#__PURE__*/React.createElement("path", {
  className: "sty26",
  d: "M49.6,40.4c0,0,0,0.2,0.1,0.2c0.1,0,0.1-0.1,0.3-0.4c0.2-0.3-0.1-0.5-0.3-0.3"
})));

var _ref108 = /*#__PURE__*/React.createElement("path", {
  className: "sty78",
  d: "M51.1,44.2l2.4-1.4c0.2-0.1,0.5,0,0.5,0.3v3.2c0,0.3-0.2,0.7-0.5,0.9l-2.3,1.3c-0.3,0.1-0.6,0-0.6-0.3 V45C50.6,44.7,50.8,44.4,51.1,44.2z"
});

var _ref109 = /*#__PURE__*/React.createElement("path", {
  className: "sty79",
  d: "M51.3,44.3l2.4-1.4c0.2-0.1,0.5,0,0.5,0.3v3.2c0,0.3-0.2,0.7-0.5,0.9l-2.3,1.3c-0.3,0.1-0.6,0-0.6-0.3 v-3.2C50.8,44.8,51,44.5,51.3,44.3z"
});

var _ref110 = /*#__PURE__*/React.createElement("path", {
  className: "sty80",
  d: "M53.5,45.1c-0.2-0.1-0.4-0.1-0.6,0l-0.2,0.1c-0.5,0.3-0.8,0.8-0.8,1.4v3.2c0,0.1-0.1,0.2-0.2,0.3 c-0.1,0.1-0.2,0.1-0.4,0l0,0l0,0c-0.1,0-0.2,0.1-0.4,0.1l0.3,0.2c0.1,0.1,0.2,0.1,0.3,0.1c0.1,0,0.2,0,0.3-0.1 c0.2-0.1,0.3-0.3,0.3-0.5v-3.2c0-0.5,0.3-0.9,0.7-1.2l0.2-0.1c0.1-0.1,0.2-0.1,0.3,0s0.2,0.2,0.2,0.3v3.2 c0,0.1-0.1,0.2-0.2,0.3s-0.2,0.1-0.4,0l0,0l-0.3,0.2l0.2,0.1c0.2,0.1,0.4,0.1,0.7,0c0.2-0.1,0.3-0.3,0.3-0.5v-3.2 C53.8,45.4,53.7,45.2,53.5,45.1z"
});

var _ref111 = /*#__PURE__*/React.createElement("path", {
  className: "sty27",
  d: "M48.1,43.1c0,0-0.3,1.1,0.2,1.3c0,0,1.3-0.7,1.5-0.9c0.2-0.2,0.4-0.7,0.2-1.1s-0.5-0.3-0.9-0.1 C48.8,42.6,48.1,43.1,48.1,43.1z"
});

var _ref112 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  className: "sty11",
  d: "M63.8,56.3c0.2,0,0.3-0.1,0.3-0.2v-0.4h-0.6v0.4C63.5,56.2,63.7,56.3,63.8,56.3z"
}), /*#__PURE__*/React.createElement("path", {
  className: "sty12",
  d: "M63.8,55.5c-0.2,0-0.3,0.1-0.3,0.2c0,0.1,0.1,0.2,0.3,0.2s0.3-0.1,0.3-0.2C64.1,55.6,64,55.5,63.8,55.5 z"
}));

var _ref113 = /*#__PURE__*/React.createElement("path", {
  className: "sty81",
  d: "M63.8,55.9c0.1,0,0.3-0.1,0.3-0.2V50h-0.5v5.6C63.6,55.8,63.7,55.9,63.8,55.9z"
});

var _ref114 = /*#__PURE__*/React.createElement("path", {
  className: "sty14",
  d: "M63.8,49.9c-0.1,0-0.3,0.1-0.3,0.2c0,0.1,0.1,0.2,0.3,0.2c0.1,0,0.3-0.1,0.3-0.2 C64.1,50,64,49.9,63.8,49.9z"
});

var _ref115 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  className: "sty11",
  d: "M73.4,50.9c0.2,0,0.3-0.1,0.3-0.2v-0.4h-0.6v0.4C73.1,50.8,73.3,50.9,73.4,50.9z"
}), /*#__PURE__*/React.createElement("path", {
  className: "sty12",
  d: "M73.4,50.1c-0.2,0-0.3,0.1-0.3,0.2s0.1,0.2,0.3,0.2c0.2,0,0.3-0.1,0.3-0.2 C73.7,50.2,73.6,50.1,73.4,50.1z"
})), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  className: "sty15",
  d: "M73.4,50.4c0.1,0,0.3-0.1,0.3-0.2v-5.6h-0.5v5.6C73.2,50.4,73.3,50.4,73.4,50.4z"
}), /*#__PURE__*/React.createElement("path", {
  className: "sty14",
  d: "M73.4,44.5c-0.1,0-0.3,0.1-0.3,0.2s0.1,0.2,0.3,0.2c0.1,0,0.3-0.1,0.3-0.2S73.6,44.5,73.4,44.5z"
})));

var _ref116 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  className: "sty11",
  d: "M59.3,53.7c0.2,0,0.3-0.1,0.3-0.2v-0.4H59v0.4C59,53.6,59.1,53.7,59.3,53.7z"
}), /*#__PURE__*/React.createElement("path", {
  className: "sty12",
  d: "M59.3,52.9c-0.2,0-0.3,0.1-0.3,0.2s0.1,0.2,0.3,0.2c0.2,0,0.3-0.1,0.3-0.2C59.6,53,59.4,52.9,59.3,52.9 z"
}));

var _ref117 = /*#__PURE__*/React.createElement("path", {
  className: "sty82",
  d: "M59.3,53.2c0.1,0,0.3-0.1,0.3-0.2v-5.6H59v5.6C59,53.2,59.1,53.3,59.3,53.2z"
});

var _ref118 = /*#__PURE__*/React.createElement("path", {
  className: "sty14",
  d: "M59.3,47.3c-0.1,0-0.3,0.1-0.3,0.2s0.1,0.2,0.3,0.2c0.1,0,0.3-0.1,0.3-0.2 C59.5,47.4,59.4,47.3,59.3,47.3z"
});

var _ref119 = /*#__PURE__*/React.createElement("path", {
  className: "sty83",
  d: "M74.2,44.6L74.2,44.6v-0.4l-0.6,0.4l-3.8-2.2c-0.5-0.3-1.2-0.3-1.8,0l-8.9,5.2c-0.1-0.2-0.1-0.3-0.1-0.3 c0,0-0.4-0.1-0.4-0.1v0.4c0,0.2,0.1,0.4,0.3,0.5l4,2.3c0.6,0.4,1.4,0.4,2,0l8.8-5.1C74.1,45.1,74.2,44.8,74.2,44.6z"
});

var _ref120 = /*#__PURE__*/React.createElement("path", {
  className: "sty84",
  d: "M59,46.5l9.1-5.3c0.5-0.3,1.2-0.3,1.8,0l4,2.3c0.5,0.3,0.5,1,0,1.3L65,49.9c-0.6,0.4-1.4,0.4-2,0l-4-2.3 C58.5,47.4,58.5,46.8,59,46.5z"
});

var _ref121 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  className: "sty19",
  d: "M70,45L70,45l-2.6-1.5l-3.8,2.2l-0.6,0v0.1l3.1,1.8l2.1-1.2c0,0,0.3,0,0.5-0.3l1.8-1v-0.1L70,45z"
}), /*#__PURE__*/React.createElement("path", {
  className: "sty20",
  d: "M63,45.6l3.1,1.8l2.1-1.2c0,0,0.3,0,0.5-0.3l1.8-1l-3.1-1.8L63,45.6z"
}));

var _ref122 = /*#__PURE__*/React.createElement("path", {
  className: "sty21",
  d: "M68.4,45.8"
});

var _ref123 = /*#__PURE__*/React.createElement("path", {
  className: "sty22",
  d: "M70.1,44.8l-0.1,0l0,0l-2.6-1.5l-1.7,1l2.8,1.5c0,0,0.1-0.1,0.3,0.1l1.7-1v-0.2H70.1z"
});

var _ref124 = /*#__PURE__*/React.createElement("path", {
  className: "sty85",
  d: "M68.4,45.8c0.1-0.6,1.5-0.8,2-1.1L67.2,43c-0.5,0.4-1.9,0.6-2,1.1L68.4,45.8z"
});

var _ref125 = /*#__PURE__*/React.createElement("path", {
  className: "sty22",
  d: "M68.3,45.8l-0.7,0l-0.1,0.1l-2.3-1.3l-1.7,1v-0.1l-0.2-0.1h-0.1v0.2l3,1.8l2-1.2c0.1-0.3,0.2-0.3,0.2-0.3 L68.3,45.8z"
});

var _ref126 = /*#__PURE__*/React.createElement("path", {
  className: "sty86",
  d: "M68.4,45.8c-0.7-0.3-1.4,1-2.2,1.3l-3-1.8c0,0,1.3-1.6,2.1-1.3L68.4,45.8z"
});

var _ref127 = /*#__PURE__*/React.createElement("path", {
  className: "sty25",
  d: "M69.9,44.1c0,0-0.2-0.2-0.3-0.2c-0.1,0-0.3,0-0.4,0c-0.1-0.1-0.1-0.1-0.2-0.1c0-0.1,0-0.2,0.2-0.1 s0.2,0,0.2,0c0-0.1-0.2-0.2-0.4-0.3c-0.1,0-0.1-0.2-0.1-0.2c0.1-0.1,0.3-0.2,0.4-0.2c0.3,0.1,0.5,0.3,0.5,0.3l0.2,0.3v0.4 C70.2,44.1,69.9,44.1,69.9,44.1z"
});

var _ref128 = /*#__PURE__*/React.createElement("path", {
  className: "sty26",
  d: "M66.5,47.1c0,0-0.2-0.2-0.3-0.3c-0.1-0.1-0.4,0-0.5-0.1c-0.1-0.1-0.4-0.3-0.4-0.5c0-0.1,0.2-0.8,0.4-0.7 c0.2,0.1,0.3,0.1,0.4,0.2c0-0.1,0.1-0.1,0.2,0c0.1,0.1,0.1,0.2,0.2,0.4c0.1,0.2,0.3,0.5,0.3,0.5L66.5,47.1z"
});

var _ref129 = /*#__PURE__*/React.createElement("path", {
  className: "sty27",
  d: "M72.1,45.7c0,0-2-1.2-2.2-1.3c-0.2-0.2-0.1-0.7,0.5-0.7c0.5,0.1,2.3,1.4,2.3,1.4L72.1,45.7z"
});

var _ref130 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  className: "sty33",
  d: "M69.1,53.2c-0.1-0.1-0.6-0.1-0.9-0.2c-0.2-0.1-0.6,0.2-0.3,0.4c0.2,0.2,0.7,0.7,1.1,0.8 c0.2,0.1,0.4,0,0.5,0c0.3-0.2,0-0.6,0-0.6L69.1,53.2z"
}), /*#__PURE__*/React.createElement("path", {
  className: "sty26",
  d: "M71.4,49.1c-0.5-0.2-1-0.4-1.2-0.5c-0.4-0.1-1.4-0.1-1.4,0.8s0.1,4.1,0.1,4.2c0,0.3,0.6,0.4,0.6,0 S70,51,70,50.8c0-0.2,0-0.7,0-0.7s0.5,0.3,1.1,0.7L71.4,49.1z"
}));

var _ref131 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  className: "sty11",
  d: "M74,55.6c0.1,0,0.2-0.1,0.2-0.1v-0.3h-0.4v0.3C73.8,55.6,73.9,55.6,74,55.6z"
}), /*#__PURE__*/React.createElement("path", {
  className: "sty12",
  d: "M74,55.1c-0.1,0-0.2,0.1-0.2,0.1s0.1,0.1,0.2,0.1c0.1,0,0.2-0.1,0.2-0.1S74.2,55.1,74,55.1z"
}));

var _ref132 = /*#__PURE__*/React.createElement("path", {
  className: "sty87",
  d: "M74,55.3c0.1,0,0.2-0.1,0.2-0.1v-3.6h-0.4v3.6C73.9,55.3,73.9,55.3,74,55.3z"
});

var _ref133 = /*#__PURE__*/React.createElement("path", {
  className: "sty14",
  d: "M74,51.5c-0.1,0-0.2,0.1-0.2,0.1s0.1,0.1,0.2,0.1c0.1,0,0.2-0.1,0.2-0.1S74.1,51.5,74,51.5z"
});

var _ref134 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  className: "sty11",
  d: "M71.3,54c0.1,0,0.2-0.1,0.2-0.1v-0.3H71v0.3C71.1,54,71.2,54,71.3,54z"
}), /*#__PURE__*/React.createElement("path", {
  className: "sty12",
  d: "M71.3,53.5c-0.1,0-0.2,0.1-0.2,0.1c0,0.1,0.1,0.1,0.2,0.1c0.1,0,0.2-0.1,0.2-0.1 C71.5,53.5,71.4,53.5,71.3,53.5z"
}));

var _ref135 = /*#__PURE__*/React.createElement("path", {
  className: "sty88",
  d: "M71.3,53.7c0.1,0,0.2-0.1,0.2-0.1v-3.4h-0.4v3.4C71.1,53.7,71.2,53.7,71.3,53.7z"
});

var _ref136 = /*#__PURE__*/React.createElement("path", {
  className: "sty14",
  d: "M71.3,50c-0.1,0-0.2,0.1-0.2,0.1c0,0.1,0.1,0.1,0.2,0.1c0.1,0,0.2-0.1,0.2-0.1 C71.5,50.1,71.4,50,71.3,50z"
});

var _ref137 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  className: "sty11",
  d: "M71.6,57c0.1,0,0.2-0.1,0.2-0.1v-0.3h-0.4v0.3C71.4,57,71.5,57,71.6,57z"
}), /*#__PURE__*/React.createElement("path", {
  className: "sty12",
  d: "M71.6,56.5c-0.1,0-0.2,0.1-0.2,0.1s0.1,0.1,0.2,0.1c0.1,0,0.2-0.1,0.2-0.1 C71.8,56.5,71.7,56.5,71.6,56.5z"
}));

var _ref138 = /*#__PURE__*/React.createElement("path", {
  className: "sty89",
  d: "M71.6,56.7c0.1,0,0.2-0.1,0.2-0.1v-4.1h-0.4v4.1C71.4,56.6,71.5,56.7,71.6,56.7z"
});

var _ref139 = /*#__PURE__*/React.createElement("path", {
  className: "sty14",
  d: "M71.6,52.4c-0.1,0-0.2,0.1-0.2,0.1c0,0.1,0.1,0.1,0.2,0.1c0.1,0,0.2-0.1,0.2-0.1S71.7,52.4,71.6,52.4z"
});

var _ref140 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  className: "sty11",
  d: "M68.8,55.4c0.1,0,0.2-0.1,0.2-0.1V55h-0.4v0.3C68.6,55.3,68.7,55.4,68.8,55.4z"
}), /*#__PURE__*/React.createElement("path", {
  className: "sty12",
  d: "M68.8,54.9c-0.1,0-0.2,0.1-0.2,0.1c0,0.1,0.1,0.1,0.2,0.1S69,55.1,69,55C69,54.9,69,54.8,68.8,54.9z"
}));

var _ref141 = /*#__PURE__*/React.createElement("path", {
  className: "sty90",
  d: "M68.8,55.1c0.1,0,0.2-0.1,0.2-0.1v-3.4h-0.4v3.4C68.7,55,68.7,55.1,68.8,55.1z"
});

var _ref142 = /*#__PURE__*/React.createElement("path", {
  className: "sty14",
  d: "M68.8,51.4c-0.1,0-0.2,0.1-0.2,0.1c0,0.1,0.1,0.1,0.2,0.1c0.1,0,0.2-0.1,0.2-0.1 C69,51.5,68.9,51.4,68.8,51.4z"
});

var _ref143 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  className: "sty32",
  d: "M70.9,53.4l-2.3-1.3c-0.3-0.2-0.3-0.7,0-0.8l2.1-1.2c0.3-0.2,0.8-0.2,1.1,0l2.4,1.4c0.4,0.2,0.4,0.8,0,1 l-1.8,1C72,53.7,71.4,53.7,70.9,53.4z"
}), /*#__PURE__*/React.createElement("path", {
  className: "sty26",
  d: "M70.9,53.2l-2.3-1.3c-0.3-0.2-0.3-0.7,0-0.8l2.1-1.2c0.3-0.2,0.8-0.2,1.1,0l2.4,1.4c0.4,0.2,0.4,0.8,0,1 l-1.8,1C72,53.4,71.4,53.4,70.9,53.2z"
}));

var _ref144 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  className: "sty33",
  d: "M67.5,54c-0.1-0.1-0.6-0.1-0.9-0.2c-0.2-0.1-0.6,0.2-0.3,0.4c0.2,0.2,0.7,0.7,1.1,0.8 c0.2,0.1,0.4,0,0.5,0c0.3-0.2,0-0.6,0-0.6L67.5,54z"
}), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  className: "sty26",
  d: "M71.4,45.5c0,0.3,1.2,0.1,1.2-0.2c0-0.4-0.2-1.2,0-1.9c0.2-0.7-1.4,1-1.4,1S71.4,44.7,71.4,45.5z"
}), /*#__PURE__*/React.createElement("path", {
  className: "sty26",
  d: "M70.3,42.5c0,0,0,1.1,0,1.4s0.3,0.8,1,0.8c0.7-0.2,0.8-0.7,1.2-0.9c0.4-0.2,0.4-0.6,0.4-0.9 c0-0.3-0.4-1.2-1.3-1.2C70.8,41.6,70.3,42.1,70.3,42.5z"
})), /*#__PURE__*/React.createElement("path", {
  className: "sty26",
  d: "M70.8,50.4c0,0-1.8-0.8-2.2-1c-0.4-0.1-1.4-0.1-1.4,0.8s0.1,4.1,0.1,4.2c0,0.3,0.6,0.4,0.6,0 c0-0.4,0.3-2.5,0.3-2.7c0-0.2,0-0.7,0-0.7s1.9,1.2,2.9,1.4c1,0.3,2.9-0.2,2.5-2C73.3,48.8,70.8,50.4,70.8,50.4z"
}), /*#__PURE__*/React.createElement("path", {
  className: "sty35",
  d: "M73.7,50.5c0,0,0.6,1.6-1.5,2c-0.8,0.1-1.6-0.1-3.8-1.4c-0.4-1.1,1.1-2,2.3-2.1c1.2-0.1,2.9,1.1,2.9,1.1 L73.7,50.5z"
}), /*#__PURE__*/React.createElement("path", {
  className: "sty36",
  d: "M71.4,45.2c0.2,0.2,1.2,0,1.2-0.3c0.5-0.2,1,0.3,1.1,0.9c0.1,1-0.6,2.1,0.1,4.6 c-0.1,0.8-1.1,0.9-1.7,0.9c-0.7,0-1.3-0.4-1.3-0.6c0.5-1.6-0.2-2.2-0.3-2.8c-0.2-0.6-0.1-1.9,0.3-2.3 C71,45.3,71.4,45.2,71.4,45.2z"
}), /*#__PURE__*/React.createElement("path", {
  className: "sty27",
  d: "M71.1,45.8c-0.1-0.2-0.5-0.4-0.9-0.1c-0.4,0.3-1.9,1.4-2.1,1.3c-0.2,0-1.2-0.6-1.3-0.7s-0.7,0.3-0.6,0.8 c0.1,0.4,1.7,1,2.2,1c0.4,0.1,1.6-0.8,2.2-1.1C71.2,46.8,71.3,46.2,71.1,45.8z"
}), /*#__PURE__*/React.createElement("path", {
  className: "sty91",
  d: "M72.8,44c0.2-0.5,0.2-0.4,0.2-1.1c0-0.8-0.3-1.2-0.5-1.3c-0.5-0.4-1.3-0.2-1.6-0.1 c-0.3,0.1-0.6,0.5-0.5,0.7s0.3,0.3,0.4,0.6c0.1,0.2,0,0.5,0,0.5l0.1,0.2c0,0,0.2,0.6,0.4,0.9C71.8,44.7,72.2,45.3,72.8,44z"
}), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  className: "sty38",
  d: "M70.7,43.9c0,0,0,0.2,0.1,0.2c0.1,0,0.1-0.1,0.3-0.4c0.2-0.3-0.1-0.5-0.3-0.3"
}), /*#__PURE__*/React.createElement("path", {
  className: "sty26",
  d: "M70.7,43.8c0,0,0,0.2,0.1,0.2c0.1,0,0.1-0.1,0.3-0.4c0.2-0.3-0.1-0.5-0.3-0.3"
})), /*#__PURE__*/React.createElement("path", {
  className: "sty39",
  d: "M71.4,45.2C71.4,45.2,71.4,45.2,71.4,45.2c0,0.1,0.2,0.4,0.9,0.2c0.3-0.1,0.3-0.4,0.2-0.5 c0,0,0,0.2-0.3,0.3C72,45.3,71.8,45.3,71.4,45.2z"
}), /*#__PURE__*/React.createElement("path", {
  className: "sty35",
  d: "M72.7,44c0,0.2-0.1,0.3-0.3,0.4c-0.2,0-0.3-0.1-0.4-0.3c0-0.2,0.1-0.3,0.3-0.4 C72.5,43.7,72.6,43.8,72.7,44z"
}), /*#__PURE__*/React.createElement("path", {
  className: "sty91",
  d: "M72.3,44.3c-0.3,1,1.3,2.7,1.4,3.4c-0.1-1.7-0.3-3-1-3.6C72.5,44,72.3,44.1,72.3,44.3z"
}));

var _ref145 = /*#__PURE__*/React.createElement("path", {
  className: "sty92",
  d: "M72.1,47.6l2.4-1.4c0.2-0.1,0.5,0,0.5,0.3v3.2c0,0.3-0.2,0.7-0.5,0.9L72.3,52c-0.3,0.1-0.6,0-0.6-0.3 v-3.2C71.7,48.1,71.9,47.8,72.1,47.6z"
});

var _ref146 = /*#__PURE__*/React.createElement("path", {
  className: "sty93",
  d: "M72.4,47.7l2.4-1.4c0.2-0.1,0.5,0,0.5,0.3v3.2c0,0.3-0.2,0.7-0.5,0.9l-2.3,1.3c-0.3,0.1-0.6,0-0.6-0.3 v-3.2C71.9,48.2,72.1,47.9,72.4,47.7z"
});

var _ref147 = /*#__PURE__*/React.createElement("path", {
  className: "sty94",
  d: "M74.5,48.5c-0.2-0.1-0.4-0.1-0.6,0l-0.2,0.1c-0.5,0.3-0.8,0.8-0.8,1.4v3.2c0,0.1-0.1,0.2-0.2,0.3 c-0.1,0.1-0.2,0.1-0.4,0l0,0l0,0c-0.1,0-0.2,0.1-0.4,0.1l0.3,0.2c0.1,0.1,0.2,0.1,0.3,0.1c0.1,0,0.2,0,0.3-0.1 c0.2-0.1,0.3-0.3,0.3-0.5V50c0-0.5,0.3-0.9,0.7-1.2l0.2-0.1c0.1-0.1,0.2-0.1,0.3,0c0.1,0.1,0.2,0.2,0.2,0.3v3.2 c0,0.1-0.1,0.2-0.2,0.3c-0.1,0.1-0.2,0.1-0.4,0l0,0l-0.3,0.2l0.2,0.1c0.2,0.1,0.4,0.1,0.7,0s0.3-0.3,0.3-0.5v-3.2 C74.8,48.8,74.7,48.6,74.5,48.5z"
});

var _ref148 = /*#__PURE__*/React.createElement("path", {
  className: "sty95",
  d: "M39.7,41.5c-10-3-16.9-9.4-16.9-17V43c0,7.5,6.9,14,16.9,17C39.7,59.9,39.7,41.5,39.7,41.5z"
});

var _ref149 = /*#__PURE__*/React.createElement("g", {
  className: "sty9"
}, /*#__PURE__*/React.createElement("path", {
  className: "sty10",
  d: "M22.8,28.6C22.8,28.6,22.8,28.6,22.8,28.6c0,0,0,0.5,0,0.5C22.8,29.1,22.8,28.8,22.8,28.6 M22.8,27.3 c0-0.2,0-0.2,0-0.2C22.8,27.1,22.8,27.1,22.8,27.3c0,0.1,0,0.3,0,0.4c0-0.1,0-0.1,0-0.1c0,0.2,0,0.4,0,0.7v0.1v0.3 c0-0.2,0-0.3,0-0.5C22.8,27.9,22.8,27.5,22.8,27.3"
}), /*#__PURE__*/React.createElement("path", {
  className: "sty10",
  d: "M23,29.1l-0.1-0.3l0,0l0,0.4l0,0c0,0.4,0,1,0,1.4l0.1,0.3C23,30.4,23,29.7,23,29.1"
}), /*#__PURE__*/React.createElement("path", {
  className: "sty10",
  d: "M23.4,32.1c-0.1-0.3-0.1-1.2,0-1.2C23.4,31,23.5,32.1,23.4,32.1C23.4,32.1,23.4,32.1,23.4,32.1  M23.4,30.6c0-0.1-0.1-0.2-0.1-0.2c-0.1,0.1-0.1,1,0,1.3c0.1,0.6,0.2,0.9,0.2,0.9C23.6,32.6,23.6,31.3,23.4,30.6"
}), /*#__PURE__*/React.createElement("path", {
  className: "sty10",
  d: "M22.8,32.6c0-0.2,0-0.5,0-0.5l0,0C22.9,32.1,22.9,32.6,22.8,32.6L22.8,32.6 C22.9,32.7,22.8,32.7,22.8,32.6 M22.8,31.9c0-0.1,0-0.1,0-0.1l0,0c0,0.1,0,1.2,0.1,1.3l0,0C22.9,32.9,22.9,32.2,22.8,31.9  M22.8,30.7c0-0.2,0-0.5,0-0.5C22.8,30.2,22.8,30.7,22.8,30.7C22.8,30.8,22.8,30.8,22.8,30.7 M22.8,30c0-0.1,0-0.1,0-0.1 c0,0.1,0,1.2,0,1.3C22.8,31.1,22.8,30.4,22.8,30 M22.8,30.8c0,0.7-0.1,0.7-0.1,1v0.3c0-0.7,0-0.7,0.1-1V30.8"
}), /*#__PURE__*/React.createElement("path", {
  className: "sty10",
  d: "M23.1,32.2c-0.1,0.5-0.1,1.6,0,2.2l0,0c0,0,0,0,0.1,0c-0.1-1.3-0.1-1.7,0-2L23.1,32.2"
}), /*#__PURE__*/React.createElement("path", {
  className: "sty10",
  d: "M23.4,33.3C23.4,33.3,23.4,33.2,23.4,33.3c0,0.9,0.1,1.5-0.1,1.9l0.1,0.3C23.6,35.1,23.6,34.4,23.4,33.3 L23.4,33.3"
}), /*#__PURE__*/React.createElement("path", {
  className: "sty10",
  d: "M22.8,34.1c0-0.3,0-0.7,0-0.7c0,0,0,0.8,0,0.8C22.8,34.2,22.8,34.2,22.8,34.1 M22.8,32.3V32 c0,0.5,0,1.3,0,1.9c0,0,0,0.1,0,0.1v0.3V34c0,0.2,0,0.5,0,0.7l0,0c0-0.3,0-1.5,0-1.6l0,0l0,0V32.3"
}), /*#__PURE__*/React.createElement("path", {
  className: "sty10",
  d: "M23,34.8c0-0.1,0-0.2-0.1-0.2c-0.1,0.1,0,1.6,0.1,1.7l0,0c0-0.1,0-0.3,0-0.4l0,0c-0.1,0-0.1-0.7-0.1-0.8 c0,0,0,0.2,0.1,0.3C23.1,35.3,23.1,35.3,23,34.8"
}), /*#__PURE__*/React.createElement("path", {
  className: "sty10",
  d: "M23.3,37.1c0-0.2-0.1-0.5,0-0.5l0,0C23.3,36.8,23.4,37,23.3,37.1C23.4,37.2,23.4,37.2,23.3,37.1  M23.3,36.3c-0.1-0.4,0-0.4,0-0.4C23.4,35.9,23.4,36.3,23.3,36.3C23.4,36.3,23.3,36.3,23.3,36.3 M23.3,35.6 c-0.1-0.2-0.1-0.2-0.1-0.2c0,0.1,0,0.3,0,0.8c0,0,0,0,0,0c-0.1,0.2,0.1,1.5,0.2,1.5l0,0l0,0.3l0.1,0.4l-0.1-0.7l0.1-0.2 L23.5,37l0,0.1c0-0.1,0-0.3-0.1-0.4c0.1,0.1,0.1-0.4,0-0.7C23.4,35.9,23.4,35.8,23.3,35.6"
}), /*#__PURE__*/React.createElement("polyline", {
  className: "sty10",
  points: "22.8,25.9 22.8,25.4 22.8,25.7 22.8,26.2 22.8,25.9  "
}), /*#__PURE__*/React.createElement("path", {
  className: "sty10",
  d: "M22.9,27.1l0-0.8c0,0.1,0,0.2,0.1,0.3L22.9,27.1l0.1-0.2c0,0.1,0,0.2,0.1,0.3L23,27.5l0.1,1L23,28.2 l0-0.6l0,0.2l-0.1-0.3L22.9,27.1"
}), /*#__PURE__*/React.createElement("path", {
  className: "sty10",
  d: "M23.4,28.6c0,0.1,0,0.1,0.1,0.2c0,0.3-0.1,0.7-0.1,0.9l-0.1-0.2C23.3,29.2,23.4,28.9,23.4,28.6"
}), /*#__PURE__*/React.createElement("path", {
  className: "sty10",
  d: "M22.8,38.7C22.8,38.7,22.8,38.7,22.8,38.7c0,0,0,0.5,0,0.5C22.8,39.2,22.8,38.9,22.8,38.7 M22.8,37.3 c0-0.2,0-0.2,0-0.2C22.8,37.2,22.8,37.2,22.8,37.3c0,0.1,0,0.3,0,0.4c0-0.1,0-0.1,0-0.1c0,0.2,0,0.4,0,0.7v0.1v0.3 c0-0.2,0-0.3,0-0.5C22.8,38,22.8,37.6,22.8,37.3"
}), /*#__PURE__*/React.createElement("path", {
  className: "sty10",
  d: "M23,39.2l-0.1-0.3l-0.1,0l0,0.4l0,0c0,0.4,0,1,0,1.4L23,41C23,40.5,23,39.7,23,39.2"
}), /*#__PURE__*/React.createElement("path", {
  className: "sty10",
  d: "M23.4,42.2c-0.1-0.3-0.1-1.2,0-1.2C23.4,41,23.5,42.2,23.4,42.2C23.4,42.2,23.4,42.2,23.4,42.2  M23.4,40.6c0-0.1-0.1-0.2-0.1-0.2c-0.1,0.1-0.1,1,0,1.3c0.1,0.6,0.2,0.9,0.2,0.9C23.6,42.6,23.6,41.3,23.4,40.6"
}), /*#__PURE__*/React.createElement("path", {
  className: "sty10",
  d: "M22.8,42.7c0-0.2,0-0.5,0-0.5l0,0C22.9,42.2,22.9,42.7,22.8,42.7L22.8,42.7 C22.9,42.7,22.8,42.7,22.8,42.7 M22.8,41.9c0-0.1,0-0.1,0-0.1l0,0c0,0.1,0,1.2,0.1,1.3l0,0C22.9,43,22.9,42.3,22.8,41.9  M22.8,40.8c0-0.2,0-0.5,0-0.5C22.8,40.3,22.8,40.8,22.8,40.8C22.8,40.8,22.8,40.8,22.8,40.8 M22.8,40.1c0-0.1,0-0.1,0-0.1 c0,0.1,0,1.2,0,1.3C22.8,41.2,22.8,40.5,22.8,40.1 M22.8,40.8c0,0.7-0.1,0.7-0.1,1v0.3c0-0.7,0-0.7,0.1-1V40.8"
}), /*#__PURE__*/React.createElement("path", {
  className: "sty10",
  d: "M23.1,42.3c-0.1,0.5-0.1,1.6,0,2.2l0,0c0,0,0,0,0.1,0c-0.1-1.3-0.1-1.7,0-2L23.1,42.3"
}), /*#__PURE__*/React.createElement("path", {
  className: "sty10",
  d: "M23.4,43.3C23.4,43.3,23.4,43.3,23.4,43.3c0,0.9,0.1,1.5-0.1,1.9l0.1,0.3C23.6,45.2,23.6,44.5,23.4,43.3 L23.4,43.3"
}), /*#__PURE__*/React.createElement("path", {
  className: "sty10",
  d: "M22.8,43.5C22.8,43.5,22.8,43.5,22.8,43.5c0,0,0,0.2,0,0.5C22.8,43.9,22.8,43.7,22.8,43.5L22.8,43.5  M22.7,42c0,0.4,0,0.9,0,1.2s0,0.7,0.1,1.1v0c0-0.8-0.1-1.1-0.1-1.1l0,0v-0.8V42"
}), /*#__PURE__*/React.createElement("path", {
  className: "sty10",
  d: "M22.9,44.8c0-0.2,0-0.2,0-0.2c0,0,0,0.1,0.1,0.2c0.1,0.3,0.1,0.5,0.1,0.5c0,0,0,0,0,0.1 c0-0.1,0-0.3-0.1-0.3l0,0c0,0,0,0,0,0.1C22.9,45.1,22.9,45,22.9,44.8C22.9,44.9,22.9,44.9,22.9,44.8"
}), /*#__PURE__*/React.createElement("path", {
  className: "sty10",
  d: "M23.3,46.7L23.3,46.7L23.3,46.7C23.3,46.8,23.3,46.7,23.3,46.7L23.3,46.7 M23.3,46.4 c-0.1-0.4,0-0.4,0-0.4C23.4,46,23.4,46.4,23.3,46.4C23.4,46.4,23.3,46.4,23.3,46.4 M23.5,47.1l0,0.1c0,0.1,0.1,0.2,0.1,0.3 l0-0.1L23.5,47.1 M23.2,46.3L23.2,46.3c0.1,0.3,0.2,0.5,0.3,0.8l-0.1-0.4c0.1,0.1,0.1-0.4,0-0.7c0-0.2-0.1-0.4-0.1-0.4 c0-0.1,0-0.1-0.1-0.1C23.2,45.5,23.2,45.7,23.2,46.3C23.2,46.3,23.2,46.3,23.2,46.3C23.2,46.3,23.2,46.3,23.2,46.3"
}), /*#__PURE__*/React.createElement("polyline", {
  className: "sty10",
  points: "22.8,36 22.8,35.5 22.8,35.8 22.8,36.3 22.8,36  "
}), /*#__PURE__*/React.createElement("polyline", {
  className: "sty10",
  points: "23.1,37.3 23,37 23,37.2 22.9,36.7 22.9,36.3 22.9,37.2 22.9,37.5 22.9,37.8 23,37.7 23,38.3  23.1,38.6 23,37.6 23.1,37.3  "
}), /*#__PURE__*/React.createElement("path", {
  className: "sty10",
  d: "M23.5,38.4c0,0.3-0.1,0.8-0.2,1.1l0.1,0.2c0-0.3,0.1-0.8,0.2-1.1L23.5,38.4"
}), /*#__PURE__*/React.createElement("path", {
  className: "sty10",
  d: "M23.8,29.7l0.2,0.4v-0.2c0,0.1,0.1,0.2,0.1,0.2v0.2l0.2,0.4V31L24,30.7v0.5L23.9,31v-0.5L23.8,30V29.7"
}), /*#__PURE__*/React.createElement("path", {
  className: "sty10",
  d: "M23.9,33.3C23.9,33.3,23.8,33.3,23.9,33.3c-0.1,0.1,0,0.6,0.1,0.5C24,33.8,24,33.5,23.9,33.3 M24,32.1 l-0.1-0.3c0,0.4,0,0.9,0,1.2l0.1,0.3C24,33,24,32.5,24,32.1"
}), /*#__PURE__*/React.createElement("path", {
  className: "sty10",
  d: "M24.6,34.6c-0.1-0.1-0.1,0-0.1,0c0,0.2,0.1,0.6,0.2,0.5C24.7,35.1,24.7,34.8,24.6,34.6 M24.6,33.3 c-0.1-0.1-0.2-0.3-0.2-0.1c0,0,0,0.1,0,0.1c0,0.1,0.1,0.2,0.2,0.3c0-0.1,0-0.1,0.1-0.1s0.2,0.4,0,0.5c-0.1,0-0.1,0-0.1,0.2v0.1 l0.2,0.3c0-0.1,0-0.2,0.1-0.2c0.1,0,0.1-0.1,0.1-0.3C24.8,33.8,24.7,33.5,24.6,33.3"
}), /*#__PURE__*/React.createElement("path", {
  className: "sty10",
  d: "M25.7,34.9l-0.2-0.2l-0.3,0.1l0.1,0.4l0.2-0.1c0,0.4,0,1,0,1.4l0.2,0.2C25.7,36.2,25.9,35.4,25.7,34.9"
}), /*#__PURE__*/React.createElement("path", {
  className: "sty10",
  d: "M26.7,37.7c-0.2-0.3-0.2-1.2-0.1-1.2c0,0,0.2,0.1,0.2,0.4c0,0.2,0,0.7,0,0.8 C26.8,37.7,26.8,37.7,26.7,37.7 M26.7,36.1c-0.1-0.1-0.4-0.4-0.4,0.5c0,1.1,0.5,1.7,0.7,1.4C27.2,37.9,27.2,36.7,26.7,36.1"
}), /*#__PURE__*/React.createElement("path", {
  className: "sty10",
  d: "M23.9,35.8v-0.3l0.1,0.2v0.3L23.9,35.8 M24.1,35.2L24,35l0,0.4l-0.1-0.2l0-0.4l-0.1-0.2l0,0.4l-0.1-0.2 v0.2l0.1,0.2v0.3l-0.1-0.2v0.2l0.1,0.2l0,0.4l0.1,0.2l0-0.4l0.1,0.2l0,0.4l0.1,0.2l0-0.4l0.1,0.2v-0.2l-0.1-0.2v-0.3l0.1,0.2 v-0.2l-0.1-0.2L24.1,35.2"
}), /*#__PURE__*/React.createElement("path", {
  className: "sty10",
  d: "M25.1,38.5C25,38.3,25,37.9,25.1,38C25.2,38,25.3,38.5,25.1,38.5C25.2,38.5,25.2,38.5,25.1,38.5  M25.1,37.8c-0.2-0.2-0.2-0.1-0.2,0c-0.1,0.4,0.2,1.2,0.4,1.1S25.4,38.1,25.1,37.8 M24.6,36.7c-0.1-0.2-0.1-0.6,0-0.5 C24.7,36.2,24.8,36.8,24.6,36.7C24.6,36.8,24.6,36.8,24.6,36.7 M24.6,36c-0.1-0.2-0.2-0.1-0.2,0c-0.1,0.4,0.2,1.2,0.3,1.1 C24.9,37,24.8,36.3,24.6,36 M25,36.7c-0.3,0.7-0.3,0.7-0.4,1.1l0.1,0.2c0.3-0.7,0.3-0.7,0.5-1.1L25,36.7"
}), /*#__PURE__*/React.createElement("path", {
  className: "sty10",
  d: "M26.1,37.9c-0.1,0.2-0.4,0.7,0,2.3l0,0c0,0,0.1,0,0.1,0c-0.2-1-0.2-1.5,0-2L26.1,37.9"
}), /*#__PURE__*/React.createElement("path", {
  className: "sty10",
  d: "M26.9,38.8c0,0-0.1,0-0.2,0c0.3,1,0.3,1.5,0,2l0.2,0.3C27.1,40.8,27.3,40.2,26.9,38.8L26.9,38.8"
}), /*#__PURE__*/React.createElement("path", {
  className: "sty10",
  d: "M23.9,38.7c-0.1-0.2-0.1-0.3,0-0.3c0,0,0.1,0.1,0.1,0.2l0,0.1C24,38.7,24,38.8,23.9,38.7 C23.9,38.7,23.9,38.7,23.9,38.7 M23.9,37.7c-0.1-0.2-0.1-0.2-0.2-0.2c0,0.1,0,0.2,0.1,0.4c0.1-0.1,0.2,0.2,0.2,0.5 c-0.1-0.2-0.2-0.5-0.3-0.3c-0.1,0.2,0.1,1.1,0.2,1c0,0,0,0,0,0l0,0v0.2l0.1,0.3C24.1,38.3,24.1,38.1,23.9,37.7"
}), /*#__PURE__*/React.createElement("path", {
  className: "sty10",
  d: "M24.7,40.1c-0.2-0.3-0.2-0.7-0.1-0.7c0.1,0,0.3,0.7,0.2,0.8C24.8,40.2,24.7,40.1,24.7,40.1 M24.6,38.3 L24.4,38c0,0.5,0,1.3,0,1.9c0,0,0,0.1,0,0.1l0.1,0.2V40c0.2,0.8,0.4,0.6,0.4,0.6c0.2-0.3-0.1-1.5-0.3-1.5c0,0,0,0,0,0l0,0 L24.6,38.3"
}), /*#__PURE__*/React.createElement("path", {
  className: "sty10",
  d: "M25.7,40.6c-0.2-0.3-0.3-0.1-0.3,0c-0.1,0.6,0.3,1.5,0.6,1.4c0-0.1-0.1-0.3-0.1-0.4 c-0.1,0.1-0.3-0.3-0.2-0.6c0-0.1,0.1-0.1,0.1-0.1s0.1,0.2,0.1,0.2c0,0,0.1-0.1,0.1-0.1C25.9,40.8,25.8,40.6,25.7,40.6"
}), /*#__PURE__*/React.createElement("path", {
  className: "sty10",
  d: "M26.7,42.7c-0.1-0.1-0.1-0.3-0.1-0.3c0-0.2,0-0.1,0.1-0.1c0.1,0.2,0.1,0.4,0.2,0.5 C26.8,42.8,26.7,42.8,26.7,42.7 M26.7,41.9c-0.2-0.5,0-0.4,0-0.4C26.8,41.5,26.9,41.8,26.7,41.9C26.7,41.9,26.7,41.9,26.7,41.9  M26.7,41.2c-0.3-0.3-0.3-0.1-0.3,0.1c0,0.2,0.1,0.4,0.1,0.5c-0.3-0.1-0.3,0.3-0.1,0.7c0.1,0.3,0.4,0.8,0.6,0.6l0.1,0.3 l0.3,0.3l-0.2-0.7l0.2-0.3l-0.3-0.3L27,42.7c0-0.1-0.1-0.3-0.1-0.4c0.3,0,0.2-0.5,0-0.9C26.8,41.3,26.7,41.3,26.7,41.2"
}), /*#__PURE__*/React.createElement("polyline", {
  className: "sty10",
  points: "24.8,31.9 24.5,31.4 24.5,31.7 24.8,32.2 24.8,31.9  "
}), /*#__PURE__*/React.createElement("path", {
  className: "sty10",
  d: "M25.5,33l-0.2-0.7c0.1,0.1,0.1,0.2,0.2,0.3l0.1,0.4l0.1-0.1c0.1,0.1,0.1,0.2,0.2,0.3l-0.2,0.2l0.2,1 L25.7,34l-0.1-0.6l-0.1,0.2l-0.2-0.3L25.5,33"
}), /*#__PURE__*/React.createElement("path", {
  className: "sty10",
  d: "M26.9,34.2c0.1,0.1,0.1,0.1,0.2,0.2c-0.1,0.3-0.2,0.7-0.3,1l-0.1-0.2C26.7,34.8,26.8,34.5,26.9,34.2"
}), /*#__PURE__*/React.createElement("polyline", {
  className: "sty10",
  points: "24.1,39.9 23.9,39.6 23.9,40.2 23.8,39.7 23.8,40.1 23.9,40.5 23.9,41 24.1,41.3 24.1,40.7  24.2,41.1 24.2,40.8 24.1,40.4 24.1,39.9  "
}), /*#__PURE__*/React.createElement("path", {
  className: "sty10",
  d: "M23.9,43.4C23.9,43.3,23.8,43.3,23.9,43.4c-0.1,0.1,0,0.6,0.1,0.5C24,43.9,24,43.6,23.9,43.4 M24,42.2 l-0.1-0.3c0,0.4,0,0.9,0,1.2l0.1,0.3C24,43,24,42.5,24,42.2"
}), /*#__PURE__*/React.createElement("path", {
  className: "sty10",
  d: "M24.6,44.7c-0.1-0.1-0.1,0-0.1,0c0,0.2,0.1,0.6,0.2,0.5C24.7,45.2,24.7,44.9,24.6,44.7 M24.6,43.3 c-0.1-0.1-0.2-0.3-0.2-0.1c0,0,0,0.1,0,0.1c0,0.1,0.1,0.2,0.2,0.3c0-0.1,0-0.1,0.1-0.1c0,0,0.2,0.4,0,0.5c-0.1,0-0.1,0-0.1,0.2 v0.1l0.2,0.3c0-0.1,0-0.2,0.1-0.2c0.1,0,0.1-0.1,0.1-0.3C24.8,43.8,24.7,43.5,24.6,43.3"
}), /*#__PURE__*/React.createElement("path", {
  className: "sty10",
  d: "M25.7,45l-0.2-0.2l-0.3,0.1l0.1,0.4l0.2-0.1c0,0.4,0,1,0,1.4l0.2,0.2C25.7,46.2,25.9,45.5,25.7,45"
}), /*#__PURE__*/React.createElement("path", {
  className: "sty10",
  d: "M26.7,47.7c-0.2-0.3-0.2-1.2-0.1-1.2c0,0,0.2,0.1,0.2,0.4c0,0.2,0,0.7,0,0.8 C26.8,47.8,26.8,47.8,26.7,47.7 M26.7,46.2c-0.1-0.1-0.4-0.4-0.4,0.5c0,1.1,0.5,1.7,0.7,1.4C27.2,48,27.2,46.8,26.7,46.2"
}), /*#__PURE__*/React.createElement("path", {
  className: "sty10",
  d: "M23.9,45.9v-0.3l0.1,0.2V46L23.9,45.9 M24.1,45.3L24,45.1l0,0.4l-0.1-0.2l0-0.4l-0.1-0.2l0,0.4L23.8,45 v0.2l0.1,0.2v0.3l-0.1-0.2v0.2l0.1,0.2l0,0.4l0.1,0.2l0-0.4l0.1,0.2l0,0.4l0.1,0.2l0-0.4l0.1,0.2v-0.2l-0.1-0.2V46l0.1,0.2 v-0.2l-0.1-0.2L24.1,45.3"
}), /*#__PURE__*/React.createElement("path", {
  className: "sty10",
  d: "M25.1,48.6C25,48.4,25,48,25.1,48C25.2,48.1,25.3,48.5,25.1,48.6C25.2,48.6,25.2,48.6,25.1,48.6  M25.1,47.8c-0.2-0.2-0.2-0.1-0.2,0c-0.1,0.4,0.2,1.2,0.4,1.1C25.5,48.8,25.4,48.1,25.1,47.8 M24.6,46.8 c-0.1-0.2-0.1-0.6,0-0.5C24.7,46.3,24.8,46.8,24.6,46.8C24.6,46.9,24.6,46.9,24.6,46.8 M24.6,46.1c-0.1-0.2-0.2-0.1-0.2,0 c-0.1,0.4,0.2,1.2,0.3,1.1C24.9,47.1,24.8,46.4,24.6,46.1 M25,46.8c-0.3,0.7-0.3,0.7-0.4,1.1l0.1,0.2c0.3-0.7,0.3-0.7,0.5-1.1 L25,46.8"
}), /*#__PURE__*/React.createElement("path", {
  className: "sty10",
  d: "M26.1,48c-0.1,0.2-0.4,0.7,0,2.3l0,0c0,0,0.1,0,0.1,0c-0.2-1-0.2-1.5,0-2L26.1,48"
}), /*#__PURE__*/React.createElement("path", {
  className: "sty10",
  d: "M26.9,48.9c0,0-0.1,0-0.2,0c0.3,1,0.3,1.5,0,2l0.2,0.3C27.1,50.8,27.3,50.3,26.9,48.9L26.9,48.9"
}), /*#__PURE__*/React.createElement("path", {
  className: "sty10",
  d: "M23.8,47.5L23.8,47.5c0,0.1,0,0.3,0,0.4c0.1-0.1,0.2,0.2,0.2,0.5c-0.1-0.2-0.1-0.3-0.2-0.3 c0.1,0.2,0.2,0.4,0.3,0.7v-0.1c0-0.3-0.1-0.6-0.2-1C23.9,47.6,23.8,47.5,23.8,47.5"
}), /*#__PURE__*/React.createElement("path", {
  className: "sty10",
  d: "M24.6,49.5c0-0.1,0.1-0.1,0.1,0c0,0.1,0.1,0.2,0.1,0.4C24.8,49.8,24.7,49.7,24.6,49.5L24.6,49.5  M24.4,48.1c0,0.4,0,0.9,0,1.2c0.2,0.3,0.4,0.7,0.6,1v0c-0.1-0.8-0.3-1.1-0.4-1l0,0v-0.8L24.4,48.1"
}), /*#__PURE__*/React.createElement("path", {
  className: "sty10",
  d: "M25.3,50.7c0-0.1,0.1-0.3,0.3,0c0.1,0.1,0.2,0.3,0.2,0.5c0,0-0.1,0.1-0.1,0.1c-0.1-0.2-0.2-0.3-0.2-0.3 c0,0,0,0,0,0.1C25.5,50.9,25.4,50.9,25.3,50.7C25.3,50.7,25.3,50.7,25.3,50.7"
}), /*#__PURE__*/React.createElement("path", {
  className: "sty10",
  d: "M26.6,52.3L26.6,52.3L26.6,52.3C26.6,52.3,26.6,52.3,26.6,52.3L26.6,52.3 M26.7,52c-0.2-0.5,0-0.4,0-0.4 C26.7,51.6,26.9,51.9,26.7,52C26.7,52,26.7,52,26.7,52 M27.1,52.6L27,52.7c0.1,0.1,0.2,0.2,0.3,0.3l0.1-0.1L27.1,52.6  M26.3,51.9C26.3,51.9,26.3,52,26.3,51.9c0.2,0.2,0.4,0.5,0.7,0.7l-0.1-0.3c0.3,0,0.2-0.6-0.1-1c0,0-0.1-0.1-0.1-0.1 c-0.3-0.2-0.3,0-0.2,0.3c0,0.1,0.1,0.2,0.1,0.4C26.4,51.9,26.4,51.8,26.3,51.9"
}), /*#__PURE__*/React.createElement("polyline", {
  className: "sty10",
  points: "24.8,41.9 24.5,41.5 24.5,41.8 24.8,42.3 24.8,41.9  "
}), /*#__PURE__*/React.createElement("polyline", {
  className: "sty10",
  points: "26,43 25.7,42.8 25.6,42.9 25.5,42.5 25.3,42.2 25.5,43 25.2,43.4 25.4,43.7 25.6,43.4 25.8,44  26,44.3 25.7,43.4 26,43  "
}), /*#__PURE__*/React.createElement("path", {
  className: "sty10",
  d: "M27,44c-0.1,0.3-0.2,0.8-0.4,1.2l0.1,0.2c0.1-0.3,0.3-0.8,0.4-1.2L27,44"
}), /*#__PURE__*/React.createElement("path", {
  className: "sty10",
  d: "M27.6,35.1l0.3,0.3v-0.2c0.1,0.1,0.1,0.1,0.2,0.2v0.2l0.4,0.3v0.3L28.2,36v0.5l-0.2-0.2v-0.5l-0.3-0.3 V35.1"
}), /*#__PURE__*/React.createElement("path", {
  className: "sty10",
  d: "M27.9,38.7c-0.1-0.1-0.2,0-0.2,0.1c0,0.2,0.2,0.5,0.3,0.4C28.1,39.1,28,38.8,27.9,38.7 M28,37.4l-0.2-0.2 c0,0.4,0,0.9,0,1.2l0.2,0.2C28,38.3,28,37.8,28,37.4"
}), /*#__PURE__*/React.createElement("path", {
  className: "sty10",
  d: "M29.1,39.8c-0.1-0.1-0.2,0-0.2,0.1c0,0.2,0.2,0.4,0.3,0.3C29.4,40.2,29.3,39.9,29.1,39.8 M29.2,38.4 c-0.4-0.3-0.4,0-0.4,0.2c0.1,0.1,0.2,0.2,0.3,0.3c0-0.2,0.2,0,0.2,0c0.1,0.1,0.2,0.3,0,0.4c-0.1,0.1-0.2,0.1-0.2,0.2v0.1 l0.3,0.2c0-0.1,0-0.2,0.1-0.2c0.1,0,0.3-0.1,0.2-0.4C29.6,38.8,29.4,38.5,29.2,38.4"
}), /*#__PURE__*/React.createElement("path", {
  className: "sty10",
  d: "M31,39.7l-0.3-0.2l-0.5,0.2l0.2,0.4l0.3-0.1c0,0.4,0,1,0,1.4l0.3,0.2C31,41,31,40.3,31,39.7"
}), /*#__PURE__*/React.createElement("path", {
  className: "sty10",
  d: "M32.5,42.2c-0.3-0.2-0.3-1.2-0.1-1.2c0,0,0.2,0,0.3,0.4c0,0.2,0.1,0.7,0,0.8 C32.7,42.3,32.7,42.3,32.5,42.2 M32.5,40.7c-0.9-0.4-0.5,1.2-0.5,1.2c0.2,0.6,0.8,1,1,0.6C33.2,42.2,33.3,41.1,32.5,40.7"
}), /*#__PURE__*/React.createElement("path", {
  className: "sty10",
  d: "M27.9,41.2l0-0.3l0.2,0.2l0,0.3L27.9,41.2 M28.3,40.5l-0.2-0.1l0,0.5l-0.2-0.2l0-0.5L27.8,40l0,0.5 l-0.2-0.1v0.2l0.1,0.1l0,0.3l-0.2-0.1v0.2l0.1,0.1l0,0.5l0.2,0.1l0-0.5l0.2,0.2l0,0.5l0.2,0.1l0-0.5l0.2,0.1v-0.3l-0.1-0.1 l0-0.3l0.2,0.1v-0.2l-0.1-0.1L28.3,40.5"
}), /*#__PURE__*/React.createElement("path", {
  className: "sty10",
  d: "M30.1,43.5c-0.2-0.2-0.2-0.5-0.1-0.5c0.2,0,0.4,0.4,0.3,0.5C30.2,43.5,30.1,43.5,30.1,43.5 M30.1,42.7 c-0.3-0.2-0.4,0-0.4,0.4c0.1,0.5,0.5,0.9,0.7,0.6C30.6,43.5,30.4,42.9,30.1,42.7 M29.1,41.9c-0.2-0.2-0.2-0.5-0.1-0.5 c0.2,0,0.3,0.4,0.2,0.5C29.3,41.9,29.2,41.9,29.1,41.9 M29.1,41.1c-0.3-0.2-0.4,0-0.3,0.3c0.1,0.5,0.5,0.9,0.7,0.7 C29.6,41.9,29.4,41.4,29.1,41.1 M29.9,41.7c-0.5,0.8-0.5,0.8-0.8,1.3l0.1,0.2c0.5-0.8,0.5-0.8,0.8-1.2L29.9,41.7"
}), /*#__PURE__*/React.createElement("path", {
  className: "sty10",
  d: "M31.6,42.6c-0.1,0.2-0.6,0.8,0,2.3l0,0c0.1,0,0.2,0,0.2,0c-0.4-0.9-0.4-1.5,0-2L31.6,42.6"
}), /*#__PURE__*/React.createElement("path", {
  className: "sty10",
  d: "M32.8,43.3c-0.1,0-0.2,0-0.2,0c0.4,0.9,0.4,1.5,0,2l0.2,0.3C33.1,45.2,33.4,44.6,32.8,43.3L32.8,43.3"
}), /*#__PURE__*/React.createElement("path", {
  className: "sty10",
  d: "M27.9,44c-0.1-0.1-0.1-0.3-0.1-0.3c0.1,0,0.2,0.1,0.2,0.1l0.1,0.1c0,0.1,0,0.2,0,0.2 C28,44.1,27.9,44,27.9,44 M27.9,43c-0.2-0.2-0.3-0.2-0.3-0.1c0,0.1,0.1,0.2,0.1,0.3c0.1-0.1,0.4,0.2,0.4,0.4 c-0.2-0.2-0.6-0.5-0.5,0c0,0.4,0.4,0.8,0.5,0.7l0,0l0,0v0.2l0.2,0.2C28.3,43.6,28.3,43.4,27.9,43"
}), /*#__PURE__*/React.createElement("path", {
  className: "sty10",
  d: "M29.4,45.2c-0.3-0.2-0.3-0.7-0.1-0.7c0.2,0,0.5,0.5,0.3,0.7C29.5,45.2,29.5,45.3,29.4,45.2 M29.1,43.4 l-0.3-0.2c0,0.5,0,1.3,0,1.9c0,0,0,0.1,0,0.1l0.2,0.2v-0.2c0.3,0.6,0.6,0.6,0.7,0.3c0.2-0.5-0.4-1.5-0.7-1.3c0,0,0,0,0,0l0,0 L29.1,43.4"
}), /*#__PURE__*/React.createElement("path", {
  className: "sty10",
  d: "M31,45.4c-0.5-0.3-0.6,0.2-0.5,0.5c0.1,0.6,0.6,1,0.9,0.9c-0.1-0.1-0.1-0.3-0.2-0.4 c-0.2,0.1-0.4-0.3-0.4-0.5c0-0.2,0.2-0.1,0.3,0c0,0,0,0.1,0.1,0.1c0.1,0,0.1-0.1,0.2-0.1C31.2,45.6,31.1,45.4,31,45.4"
}), /*#__PURE__*/React.createElement("path", {
  className: "sty10",
  d: "M32.4,47.3c-0.2-0.1-0.3-0.4-0.1-0.5c0,0,0,0,0.1,0c0.1,0.1,0.2,0.3,0.3,0.5 C32.6,47.3,32.5,47.3,32.4,47.3 M32.5,46.4c-0.3-0.4,0-0.4,0-0.4c0.1,0,0.3,0.3,0.1,0.4C32.6,46.4,32.5,46.4,32.5,46.4  M32.5,45.8c-0.5-0.3-0.5,0.2-0.4,0.4c0,0.1,0.1,0.2,0.1,0.3c-0.4-0.1-0.4,0.5-0.1,0.9c0,0,0.4,0.5,0.8,0.3l0.1,0.2l0.4,0.2 l-0.4-0.6l0.3-0.3L33.1,47l-0.2,0.1c-0.1-0.1-0.1-0.2-0.2-0.4c0.4,0,0.4-0.5,0-0.9C32.7,45.8,32.6,45.8,32.5,45.8"
}), /*#__PURE__*/React.createElement("polyline", {
  className: "sty10",
  points: "29.6,36.9 29.1,36.6 29.1,36.9 29.6,37.2 29.6,36.9  "
}), /*#__PURE__*/React.createElement("path", {
  className: "sty10",
  d: "M30.6,37.8l-0.3-0.7c0.1,0.1,0.2,0.2,0.3,0.2l0.1,0.3l0.1-0.2c0.1,0.1,0.2,0.1,0.3,0.2L31,38.1l0.4,0.9 L31,38.8l-0.2-0.5l-0.2,0.2l-0.3-0.2L30.6,37.8"
}), /*#__PURE__*/React.createElement("path", {
  className: "sty10",
  d: "M32.8,38.7c0.1,0,0.1,0.1,0.2,0.1c-0.1,0.3-0.3,0.7-0.4,1l-0.2-0.2C32.5,39.4,32.7,39,32.8,38.7"
}), /*#__PURE__*/React.createElement("polyline", {
  className: "sty10",
  points: "28.2,45.2 28,45 28,45.5 27.6,45.2 27.6,45.5 28,45.8 28,46.4 28.2,46.6 28.2,46 28.6,46.4  28.6,46 28.2,45.7 28.2,45.2  "
}), /*#__PURE__*/React.createElement("path", {
  className: "sty10",
  d: "M27.9,48.7c-0.1-0.1-0.2,0-0.2,0.1c0,0.2,0.2,0.5,0.3,0.4C28.1,49.2,28,48.9,27.9,48.7 M28,47.5l-0.2-0.2 c0,0.4,0,0.9,0,1.2l0.2,0.2C28,48.4,28,47.9,28,47.5"
}), /*#__PURE__*/React.createElement("path", {
  className: "sty10",
  d: "M29.1,49.8C29,49.7,29,49.9,29,50c0,0.2,0.2,0.4,0.3,0.3C29.4,50.2,29.3,49.9,29.1,49.8 M29.2,48.5 c-0.4-0.3-0.4,0-0.4,0.2c0.1,0.1,0.2,0.2,0.3,0.3c0-0.2,0.2,0,0.2,0c0.1,0.1,0.2,0.3,0,0.4c-0.1,0.1-0.2,0.1-0.2,0.2v0.1 l0.3,0.2c0-0.1,0-0.2,0.1-0.2c0.1,0,0.3-0.1,0.2-0.4C29.6,48.9,29.4,48.6,29.2,48.5"
}), /*#__PURE__*/React.createElement("path", {
  className: "sty10",
  d: "M31,49.8l-0.3-0.2l-0.5,0.2l0.2,0.4l0.3-0.1c0,0.4,0,1,0,1.4l0.3,0.2C31,51.1,31,50.4,31,49.8"
}), /*#__PURE__*/React.createElement("path", {
  className: "sty10",
  d: "M32.5,52.3c-0.3-0.2-0.3-1.2-0.1-1.2c0,0,0.2,0,0.3,0.4c0,0.2,0.1,0.7,0,0.8 C32.7,52.3,32.7,52.3,32.5,52.3 M32.5,50.8C31.7,50.3,32,52,32.1,52c0.2,0.6,0.8,1,1,0.6C33.2,52.2,33.3,51.1,32.5,50.8"
}), /*#__PURE__*/React.createElement("path", {
  className: "sty10",
  d: "M27.9,51.2l0-0.3l0.2,0.2l0,0.3L27.9,51.2 M28.3,50.6l-0.2-0.1l0,0.5l-0.2-0.2l0-0.5l-0.2-0.1l0,0.5 l-0.2-0.1v0.2l0.1,0.1l0,0.3L27.5,51v0.2l0.1,0.1l0,0.5l0.2,0l0-0.5l0.2,0.2l0,0.5l0.2,0.1l0-0.5l0.2,0.1v-0.2l-0.1-0.1l0-0.3 l0.2,0.1v-0.2l-0.1-0.1L28.3,50.6"
}), /*#__PURE__*/React.createElement("path", {
  className: "sty10",
  d: "M30.1,53.6C29.9,53.4,29.9,53,30,53c0.2,0,0.4,0.4,0.3,0.5C30.2,53.6,30.1,53.6,30.1,53.6 M30.1,52.8 c-0.3-0.2-0.4,0-0.4,0.4c0.1,0.5,0.5,0.9,0.7,0.6C30.6,53.6,30.4,53,30.1,52.8 M29.1,51.9c-0.2-0.2-0.2-0.5-0.1-0.5 c0.2,0,0.3,0.4,0.2,0.5C29.3,52,29.2,52,29.1,51.9 M29.1,51.2c-0.3-0.2-0.4,0-0.3,0.3c0.1,0.5,0.5,0.9,0.7,0.7 C29.6,52,29.4,51.4,29.1,51.2 M29.9,51.8c-0.5,0.8-0.5,0.8-0.8,1.3l0.1,0.2c0.5-0.8,0.5-0.8,0.8-1.2L29.9,51.8"
}), /*#__PURE__*/React.createElement("path", {
  className: "sty10",
  d: "M31.6,52.7c-0.1,0.2-0.6,0.8,0,2.3l0,0c0.1,0,0.2,0,0.2,0c-0.4-0.9-0.4-1.5,0-2L31.6,52.7"
}), /*#__PURE__*/React.createElement("path", {
  className: "sty10",
  d: "M32.8,53.4c-0.1,0-0.2,0-0.2,0c0.4,0.9,0.4,1.5,0,2l0.2,0.3C33.1,55.3,33.4,54.7,32.8,53.4L32.8,53.4"
}), /*#__PURE__*/React.createElement("path", {
  className: "sty10",
  d: "M27.6,52.9L27.6,52.9c0,0.1,0.1,0.2,0.1,0.3c0.1-0.1,0.3,0.1,0.4,0.4c-0.1-0.1-0.3-0.2-0.4-0.3 c0.2,0.2,0.4,0.4,0.6,0.5v-0.1c0-0.3-0.1-0.6-0.4-0.9C27.8,53,27.7,52.9,27.6,52.9"
}), /*#__PURE__*/React.createElement("path", {
  className: "sty10",
  d: "M29.1,54.7c0.1-0.2,0.3,0,0.4,0.2c0,0.1,0,0.1,0.1,0.2C29.4,54.9,29.3,54.8,29.1,54.7 C29.1,54.7,29.1,54.7,29.1,54.7 M28.9,53.2c0,0.4,0,0.9,0,1.2c0.3,0.3,0.7,0.5,1,0.8v0c-0.1-0.8-0.6-1-0.7-0.9l0,0v-0.8 L28.9,53.2"
}), /*#__PURE__*/React.createElement("path", {
  className: "sty10",
  d: "M30.5,55.6c0-0.2,0.1-0.4,0.5-0.1c0.2,0.1,0.3,0.2,0.4,0.4c-0.1,0-0.1,0.1-0.2,0.1 c-0.1-0.2-0.3-0.3-0.4-0.2c0,0,0,0,0,0C30.7,55.8,30.6,55.7,30.5,55.6C30.5,55.6,30.5,55.6,30.5,55.6"
}), /*#__PURE__*/React.createElement("path", {
  className: "sty10",
  d: "M32.3,56.8C32.3,56.8,32.4,56.8,32.3,56.8l0.1,0.1C32.4,56.9,32.4,56.9,32.3,56.8L32.3,56.8 M32.5,56.5 c-0.3-0.4,0-0.4,0-0.4c0.1,0,0.3,0.3,0.1,0.4C32.6,56.5,32.5,56.5,32.5,56.5 M33.1,57.1l-0.1,0.1c0.1,0.1,0.3,0.1,0.4,0.2 l0.1-0.1L33.1,57.1 M31.9,56.6L31.9,56.6c0.3,0.2,0.6,0.4,0.9,0.5l-0.2-0.3c0.4,0,0.3-0.6,0-0.9c-0.1-0.1-0.2-0.1-0.3-0.2 c-0.6-0.2-0.4,0.4-0.3,0.6c0,0,0,0.1,0.1,0.1C32.1,56.5,32,56.5,31.9,56.6"
}), /*#__PURE__*/React.createElement("polyline", {
  className: "sty10",
  points: "29.6,47 29.1,46.7 29.1,47 29.6,47.3 29.6,47  "
}), /*#__PURE__*/React.createElement("polyline", {
  className: "sty10",
  points: "31.4,47.8 31,47.6 30.8,47.8 30.7,47.3 30.3,47.1 30.6,47.9 30.2,48.3 30.6,48.5 30.8,48.3  31,48.8 31.4,49.1 31,48.2 31.4,47.8  "
}), /*#__PURE__*/React.createElement("path", {
  className: "sty10",
  d: "M32.9,48.4c-0.2,0.4-0.4,0.9-0.5,1.3l0.2,0.2c0.2-0.4,0.4-0.9,0.5-1.3L32.9,48.4"
}), /*#__PURE__*/React.createElement("path", {
  className: "sty10",
  d: "M33.8,39.4l0.5,0.2v-0.2c0.1,0,0.2,0.1,0.3,0.1v0.2l0.5,0.2v0.3l-0.5-0.2v0.5l-0.3-0.1V40l-0.5-0.2V39.4"
}), /*#__PURE__*/React.createElement("path", {
  className: "sty10",
  d: "M34.2,42.9C34,42.9,34,43,34,43.2c0.1,0.2,0.3,0.3,0.4,0.2C34.5,43.3,34.4,43,34.2,42.9 M34.4,41.7 L34,41.5c0,0.4,0,0.9,0,1.2l0.3,0.2C34.4,42.5,34.4,42,34.4,41.7"
}), /*#__PURE__*/React.createElement("path", {
  className: "sty10",
  d: "M35.9,43.7c-0.2-0.1-0.3,0.1-0.2,0.3c0.1,0.2,0.4,0.3,0.4,0.1C36.2,44,36.1,43.8,35.9,43.7 M36,42.4 c-0.5-0.2-0.6,0.1-0.6,0.3c0.1,0.1,0.3,0.1,0.4,0.2c0-0.2,0.3-0.1,0.4,0c0.1,0.2,0,0.3-0.1,0.3c-0.2,0.1-0.2,0.1-0.2,0.3v0.1 l0.4,0.2c0-0.1,0-0.2,0.1-0.2c0.2-0.1,0.3-0.1,0.3-0.4C36.5,42.7,36.2,42.5,36,42.4"
}), /*#__PURE__*/React.createElement("path", {
  className: "sty10",
  d: "M38.3,43.3l-0.4-0.1l-0.6,0.3l0.2,0.3l0.4-0.2c0,0.4,0,1,0,1.4l0.4,0.1C38.3,44.5,38.3,43.8,38.3,43.3"
}), /*#__PURE__*/React.createElement("path", {
  className: "sty10",
  d: "M34.2,45.4l0-0.3l0.2,0.1l0,0.3L34.2,45.4 M34.8,44.6l-0.2-0.1L34.5,45l-0.2-0.1l0.1-0.5l-0.2-0.1 L34,44.8l-0.2-0.1v0.2L34,45l0,0.3l-0.2-0.1v0.2l0.2,0.1l-0.1,0.5l0.2,0.1l0.1-0.5l0.2,0.1l-0.1,0.5l0.2,0.1l0.1-0.5l0.2,0.1 v-0.3l-0.2-0.1l0-0.3l0.2,0.1v-0.2l-0.2-0.1L34.8,44.6"
}), /*#__PURE__*/React.createElement("path", {
  className: "sty10",
  d: "M37.2,47.2c-0.2-0.1-0.3-0.4-0.2-0.5c0.2-0.1,0.5,0.2,0.4,0.4C37.4,47.2,37.3,47.2,37.2,47.2 M37.2,46.4 c-0.5-0.2-0.6,0.3-0.4,0.6c0.2,0.4,0.8,0.6,0.9,0.2C37.8,47,37.5,46.6,37.2,46.4 M35.9,45.8c-0.2-0.1-0.3-0.4-0.1-0.5 c0.2-0.1,0.4,0.2,0.4,0.4C36.1,45.8,36,45.9,35.9,45.8 M35.9,45.1c-0.4-0.2-0.6,0.2-0.4,0.5c0.2,0.5,0.8,0.7,0.9,0.3 C36.5,45.7,36.2,45.2,35.9,45.1 M36.9,45.4c-0.6,0.9-0.7,1-1,1.4l0.2,0.2c0.7-0.9,0.7-0.9,1.1-1.4L36.9,45.4"
}), /*#__PURE__*/React.createElement("path", {
  className: "sty10",
  d: "M39.1,46c-0.2,0.2-0.8,0.9,0,2.3l0,0c0.1,0,0.2,0,0.3-0.1c-0.5-0.9-0.5-1.4,0-2L39.1,46"
}), /*#__PURE__*/React.createElement("path", {
  className: "sty10",
  d: "M34.2,48.3C34.1,48.2,34,48,34.1,48c0.1,0,0.2,0.1,0.3,0.1l0.1,0c0,0.1,0,0.2,0,0.2 C34.4,48.3,34.3,48.3,34.2,48.3 M34.3,47.3c-0.3-0.1-0.4-0.1-0.5-0.1c0.1,0.1,0.1,0.2,0.2,0.3c0.2-0.1,0.5,0.1,0.5,0.3 c-0.3-0.1-0.5-0.2-0.7-0.2c-0.1,0-0.1,0.2-0.1,0.4c0.1,0.3,0.5,0.6,0.8,0.4l0,0v0.2l0.3,0.2C34.8,47.7,34.8,47.5,34.3,47.3"
}), /*#__PURE__*/React.createElement("path", {
  className: "sty10",
  d: "M36.2,49.1c-0.4-0.2-0.3-0.6-0.2-0.7c0.2-0.1,0.6,0.3,0.5,0.6C36.5,49.1,36.4,49.2,36.2,49.1 M35.9,47.4 l-0.4-0.2c0,0.5,0,1.3,0,1.9c0,0,0,0.1,0,0.1l0.3,0.1v-0.2c0.4,0.6,0.9,0.5,1,0.1c0.1-0.7-0.6-1.3-0.9-1l0,0l0,0L35.9,47.4"
}), /*#__PURE__*/React.createElement("path", {
  className: "sty10",
  d: "M38.3,48.9c-0.8-0.2-0.8,0.4-0.6,0.8s0.8,0.6,1.1,0.4c-0.1-0.1-0.2-0.2-0.3-0.3C38.3,50,38,49.7,38,49.4 c0-0.2,0.4-0.2,0.5,0l0,0c0.1-0.1,0.2-0.1,0.3-0.2C38.6,49,38.4,49,38.3,48.9"
}), /*#__PURE__*/React.createElement("polyline", {
  className: "sty10",
  points: "36.5,40.8 35.9,40.5 35.9,40.8 36.5,41.1 36.5,40.8  "
}), /*#__PURE__*/React.createElement("path", {
  className: "sty10",
  d: "M37.9,41.4l-0.4-0.6c0.1,0.1,0.3,0.1,0.4,0.2l0.2,0.3l0.2-0.2c0.1,0,0.3,0.1,0.4,0.1l-0.3,0.4l0.5,0.8 l-0.5-0.2l-0.3-0.5L37.8,42l-0.4-0.2L37.9,41.4"
}), /*#__PURE__*/React.createElement("polyline", {
  className: "sty10",
  points: "34.6,49.4 34.3,49.2 34.3,49.7 33.8,49.5 33.8,49.8 34.3,50.1 34.3,50.6 34.6,50.7 34.6,50.2  35.1,50.5 35.1,50.1 34.6,49.9 34.6,49.4  "
}), /*#__PURE__*/React.createElement("path", {
  className: "sty10",
  d: "M34.2,53C34,52.9,34,53.1,34,53.2c0.1,0.2,0.3,0.3,0.4,0.2C34.5,53.3,34.4,53.1,34.2,53 M34.4,51.7 L34,51.6c0,0.4,0,0.9,0,1.2l0.3,0.2C34.4,52.6,34.4,52.1,34.4,51.7"
}), /*#__PURE__*/React.createElement("path", {
  className: "sty10",
  d: "M35.9,53.8c-0.2-0.1-0.3,0.1-0.2,0.3c0.1,0.2,0.4,0.3,0.4,0.1C36.2,54.1,36.1,53.9,35.9,53.8 M36,52.4 c-0.5-0.2-0.6,0.1-0.6,0.3c0.1,0.1,0.3,0.1,0.4,0.2c0-0.2,0.3-0.1,0.4,0c0.1,0.2,0,0.3-0.1,0.3c-0.2,0.1-0.2,0.1-0.2,0.3v0.1 l0.4,0.2c0-0.1,0-0.2,0.1-0.2c0.2-0.1,0.3-0.1,0.3-0.4C36.5,52.8,36.2,52.5,36,52.4"
}), /*#__PURE__*/React.createElement("path", {
  className: "sty10",
  d: "M38.3,53.3l-0.4-0.1l-0.6,0.3l0.2,0.3l0.4-0.2c0,0.4,0,1,0,1.4l0.4,0.1C38.3,54.6,38.3,53.9,38.3,53.3"
}), /*#__PURE__*/React.createElement("path", {
  className: "sty10",
  d: "M34.2,55.5l0-0.3l0.2,0.1l0,0.3L34.2,55.5 M34.8,54.7l-0.2-0.1l-0.1,0.5L34.3,55l0.1-0.5l-0.2-0.1 L34,54.9l-0.2-0.1V55l0.2,0.1l0,0.3l-0.2-0.1v0.2l0.2,0.1l-0.1,0.5l0.2,0.1l0.1-0.5l0.2,0.1l-0.1,0.5l0.2,0.1l0.1-0.5l0.2,0.1 v-0.2l-0.2-0.1l0-0.3l0.2,0.1v-0.2l-0.2-0.1L34.8,54.7"
}), /*#__PURE__*/React.createElement("path", {
  className: "sty10",
  d: "M37.2,57.3c-0.2-0.1-0.3-0.4-0.2-0.5c0.2-0.1,0.5,0.2,0.4,0.4C37.4,57.3,37.3,57.3,37.2,57.3 M37.2,56.5 c-0.5-0.2-0.6,0.3-0.4,0.6c0.2,0.4,0.8,0.6,0.9,0.2C37.8,57.1,37.5,56.6,37.2,56.5 M35.9,55.9c-0.2-0.1-0.3-0.4-0.1-0.5 c0.2-0.1,0.4,0.2,0.4,0.4C36.1,55.9,36,56,35.9,55.9 M35.9,55.2c-0.4-0.2-0.6,0.2-0.4,0.5c0.2,0.5,0.8,0.7,0.9,0.3 C36.5,55.7,36.2,55.3,35.9,55.2 M36.9,55.5c-0.4,0.6-0.7,1-1,1.4l0.2,0.2c0.7-0.9,0.7-0.9,1.1-1.4L36.9,55.5"
}), /*#__PURE__*/React.createElement("path", {
  className: "sty10",
  d: "M39.1,56.1c-0.2,0.2-0.8,0.9,0,2.3l0,0c0.1,0,0.2,0,0.3-0.1c-0.5-0.9-0.5-1.4,0-2L39.1,56.1"
}), /*#__PURE__*/React.createElement("path", {
  className: "sty10",
  d: "M33.8,57.3C33.8,57.3,33.8,57.3,33.8,57.3c0,0.1,0.1,0.2,0.1,0.3c0.2-0.1,0.5,0.1,0.5,0.3 c-0.2-0.1-0.4-0.2-0.5-0.2c0.3,0.1,0.6,0.3,0.9,0.4v-0.1c0-0.4-0.2-0.6-0.6-0.8C34.1,57.3,34,57.2,33.8,57.3"
}), /*#__PURE__*/React.createElement("path", {
  className: "sty10",
  d: "M35.9,58.6c0.1-0.2,0.4,0,0.5,0.2c0,0,0,0,0,0.1C36.3,58.8,36.1,58.7,35.9,58.6 C35.9,58.6,35.9,58.6,35.9,58.6 M35.6,57.3c0,0.4,0,0.9,0,1.2c0.4,0.2,0.9,0.4,1.3,0.5v0c-0.2-0.8-0.8-0.9-1-0.8l0,0v-0.8 L35.6,57.3"
}), /*#__PURE__*/React.createElement("path", {
  className: "sty10",
  d: "M37.6,59.3c0-0.1,0.2-0.4,0.7-0.3c0.2,0.1,0.3,0.2,0.4,0.3c-0.1,0.1-0.2,0.1-0.3,0.2 c-0.1-0.2-0.4-0.3-0.5,0C37.8,59.4,37.7,59.3,37.6,59.3C37.6,59.3,37.6,59.3,37.6,59.3"
}), /*#__PURE__*/React.createElement("polyline", {
  className: "sty10",
  points: "36.5,50.8 35.9,50.6 35.9,50.9 36.5,51.1 36.5,50.8  "
}), /*#__PURE__*/React.createElement("polyline", {
  className: "sty10",
  points: "38.8,51.3 38.4,51.1 38.1,51.4 37.9,50.9 37.5,50.8 37.9,51.5 37.4,52 37.8,52.1 38.1,51.8  38.4,52.3 38.9,52.5 38.4,51.7 38.8,51.3  "
}));

var _ref150 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  className: "sty96",
  d: "M30.3,90.8c0-0.3,0.1-0.7,0.2-1l0.7,0.3c-0.1,0.2-0.1,0.5-0.1,0.7c0,0.4,0.1,0.7,0.2,0.8 c0.1,0.1,0.3,0.2,0.5,0.2c0.3,0,0.5-0.1,0.6-0.2c0.1-0.2,0.2-0.4,0.2-0.7c0-0.4-0.1-0.8-0.2-0.9c-0.1-0.2-0.3-0.2-0.4-0.2h-0.4 v-0.8H32c0.2,0,0.3,0,0.4-0.1c0.1-0.1,0.1-0.2,0.1-0.5c0-0.2-0.3-0.6-0.8-1.1h1.1c0.4,0.3,0.5,0.7,0.5,1.1c0,0.4-0.1,0.7-0.4,1 c0.4,0.4,0.6,0.9,0.6,1.5c0,0.5-0.1,1-0.4,1.2s-0.7,0.4-1.2,0.4c-0.4,0-0.8-0.1-1.1-0.4C30.4,91.8,30.3,91.4,30.3,90.8z"
}), /*#__PURE__*/React.createElement("path", {
  className: "sty96",
  d: "M34.3,89.1c0-0.6,0.2-1.1,0.4-1.4c0.3-0.3,0.7-0.5,1.1-0.5s0.7,0.2,0.9,0.5c0.2-0.3,0.5-0.5,0.9-0.5 c0.4,0,0.7,0.2,0.9,0.5c0.1-0.2,0.2-0.3,0.4-0.4c0.2-0.1,0.3-0.1,0.5-0.1c0.4,0,0.8,0.2,1.1,0.5s0.4,0.8,0.4,1.4 c0,0.4-0.2,1-0.5,1.5h-1.1c0.5-0.6,0.8-1.1,0.8-1.5c0-0.5-0.1-0.8-0.2-0.9C39.9,88,39.8,88,39.6,88c-0.4,0-0.5,0.3-0.5,0.9v0.9 h-0.8v-0.9c0-0.5-0.2-0.9-0.5-0.9c-0.3,0-0.5,0.3-0.5,0.9v0.9h-0.8v-0.9c0-0.6-0.2-0.9-0.5-0.9c-0.2,0-0.3,0.1-0.5,0.2 c-0.2,0.2-0.2,0.4-0.2,0.9c0,0.8,0.5,1.4,1.4,2c1.1,0,1.9,0.1,2.4,0.3c0.5,0.2,0.8,0.5,0.8,1h-1.1c-0.1-0.3-0.3-0.4-0.7-0.5 c-0.3-0.1-0.8-0.1-1.2-0.1c-0.9,0-1.5,0.1-2,0.2v-0.8l0.5-0.1C34.7,90.6,34.3,89.9,34.3,89.1z"
}), /*#__PURE__*/React.createElement("path", {
  className: "sty96",
  d: "M41.9,90.4c0-0.4,0.1-0.8,0.3-1.1l0.8,0.3c-0.1,0.4-0.2,0.7-0.2,0.9c0,0.4,0.1,0.8,0.2,1 c0.1,0.2,0.3,0.3,0.5,0.3c0.3,0,0.5-0.1,0.7-0.4c0.1-0.2,0.2-0.5,0.2-0.9c0-0.6-0.2-1.1-0.7-1.5c-0.5-0.4-0.7-1-0.7-1.7h0.8 c0,0.4,0.2,0.9,0.7,1.4c0.5,0.5,0.7,1.1,0.7,1.9c0,0.5-0.1,1-0.4,1.4s-0.7,0.6-1.2,0.6c-0.5,0-0.9-0.2-1.2-0.6 C42.1,91.5,41.9,91,41.9,90.4z"
}), /*#__PURE__*/React.createElement("path", {
  className: "sty96",
  d: "M46,90.7v-3.5h0.8v3.5c0,0.3,0.1,0.6,0.2,0.8c0.1,0.2,0.3,0.3,0.5,0.3c0.2,0,0.4-0.1,0.6-0.2 c0.1-0.2,0.2-0.4,0.2-0.7c0-0.4-0.1-0.8-0.3-1c-0.2-0.2-0.3-0.7-0.3-1.4h0.8c0,0.5,0.1,1,0.3,1.2c0.2,0.2,0.3,0.7,0.3,1.2 c0,0.5-0.2,0.9-0.5,1.2c-0.3,0.3-0.7,0.5-1.2,0.5c-0.5,0-0.9-0.2-1.2-0.5C46.1,91.6,46,91.2,46,90.7z"
}), /*#__PURE__*/React.createElement("path", {
  className: "sty96",
  d: "M50,90.7c0-0.5,0.2-1,0.4-1.3c0.3-0.3,0.7-0.4,1.2-0.4c0.3,0,0.5,0.1,0.8,0.3v-1.1c0-0.1-0.1-0.2-0.4-0.2 c-0.2,0-0.3,0.1-0.3,0.2v0.4h-0.8v-0.4c0-0.1-0.1-0.2-0.4-0.2H50v-0.8h0.5c0.4,0,0.7,0.1,0.9,0.4c0.2-0.3,0.5-0.4,1-0.4 c0.3,0,0.5,0.1,0.7,0.2c0.2,0.2,0.2,0.4,0.2,0.6v2.6c0,0.6-0.2,1-0.5,1.3c-0.3,0.3-0.7,0.4-1.1,0.4c-0.5,0-0.9-0.1-1.2-0.4 S50,91.3,50,90.7z M50.9,90.7c0,0.3,0.1,0.6,0.2,0.8c0.1,0.2,0.3,0.2,0.6,0.2c0.2,0,0.4-0.1,0.6-0.2c0.1-0.2,0.2-0.4,0.2-0.8 c0-0.3-0.1-0.6-0.2-0.7c-0.1-0.2-0.3-0.2-0.6-0.2c-0.2,0-0.4,0.1-0.6,0.2C50.9,90.2,50.9,90.4,50.9,90.7z"
}), /*#__PURE__*/React.createElement("path", {
  className: "sty96",
  d: "M54,89.7c0-0.8,0.1-1.3,0.4-1.8s0.7-0.7,1.2-0.7s0.9,0.2,1.2,0.7c0.3,0.4,0.4,1.1,0.4,1.8 c0,0.7-0.1,1.6-0.3,2.7H56c0.3-1,0.4-2,0.4-2.8c0-0.6-0.1-1-0.2-1.3c-0.2-0.3-0.3-0.4-0.6-0.4c-0.2,0-0.4,0.1-0.5,0.4 c-0.1,0.3-0.2,0.7-0.2,1.3c0,0.8,0.2,1.8,0.5,2.8h-0.9C54.2,91.3,54,90.4,54,89.7z"
}), /*#__PURE__*/React.createElement("path", {
  className: "sty96",
  d: "M60.1,89.1c0-0.6,0.1-1.1,0.4-1.4c0.3-0.3,0.7-0.5,1.2-0.5c0.4,0,0.7,0.1,1,0.3c0.3-0.2,0.6-0.3,0.9-0.3 c0.4,0,0.9,0.1,1.2,0.4s0.5,0.8,0.5,1.3c0,0.5-0.2,1-0.5,1.3c-0.3,0.3-0.7,0.5-1.1,0.5s-0.8-0.2-1.1-0.5 c-0.3-0.3-0.5-0.8-0.5-1.3c0-0.3,0.1-0.6,0.3-0.9C62.2,88,62,88,61.8,88c-0.2,0-0.4,0.1-0.6,0.3c-0.1,0.2-0.2,0.5-0.2,0.9 c0,0.4,0.1,0.8,0.2,1.1c0.1,0.3,0.4,0.7,0.8,1c0.7,0.1,1.3,0.2,1.6,0.4c0.3,0.2,0.6,0.5,0.7,0.9h-1.2c0-0.1-0.1-0.3-0.2-0.3 c-0.2-0.1-0.5-0.1-1-0.1c-0.5,0-0.9,0-1.3,0.1v-0.9l0.5-0.1C60.4,90.6,60.1,89.9,60.1,89.1z M62.8,89c0,0.4,0.1,0.7,0.2,0.8 c0.2,0.2,0.3,0.2,0.5,0.2s0.4-0.1,0.5-0.3s0.2-0.4,0.2-0.8c0-0.3-0.1-0.6-0.2-0.8c-0.1-0.2-0.3-0.3-0.6-0.3 c-0.2,0-0.4,0.1-0.5,0.3C62.9,88.4,62.8,88.6,62.8,89z"
}), /*#__PURE__*/React.createElement("path", {
  className: "sty96",
  d: "M66,90.4c0-0.4,0.1-0.8,0.3-1.1l0.8,0.3c-0.1,0.4-0.2,0.7-0.2,0.9c0,0.4,0.1,0.8,0.2,1 c0.1,0.2,0.3,0.3,0.5,0.3c0.3,0,0.5-0.1,0.7-0.4c0.1-0.2,0.2-0.5,0.2-0.9c0-0.6-0.2-1.1-0.7-1.5c-0.5-0.4-0.7-1-0.7-1.7h0.8 c0,0.4,0.2,0.9,0.7,1.4c0.5,0.5,0.7,1.1,0.7,1.9c0,0.5-0.1,1-0.4,1.4s-0.7,0.6-1.2,0.6c-0.5,0-0.9-0.2-1.2-0.6 C66.2,91.5,66,91,66,90.4z"
}), /*#__PURE__*/React.createElement("path", {
  className: "sty96",
  d: "M70.1,90.8c0-0.5,0.1-1,0.4-1.3c0.3-0.3,0.7-0.5,1.2-0.5c0.3,0,0.5,0.1,0.8,0.3v-0.7c0-0.2,0-0.3-0.2-0.4 C72.2,88,72,88,71.8,88c-0.3,0-0.4,0-0.5,0.1c-0.1,0.1-0.1,0.2-0.2,0.4h-0.8c0-0.4,0.1-0.8,0.4-1s0.7-0.3,1.1-0.3 c0.4,0,0.8,0.1,1.1,0.4c0.3,0.2,0.4,0.5,0.4,0.9v2.3c0,0.5-0.2,0.9-0.5,1.2c-0.3,0.3-0.7,0.5-1.2,0.5s-0.9-0.2-1.2-0.5 C70.2,91.6,70.1,91.3,70.1,90.8z M70.9,90.8c0,0.3,0.1,0.5,0.2,0.7c0.1,0.2,0.3,0.2,0.5,0.2c0.2,0,0.4-0.1,0.6-0.2 c0.1-0.2,0.2-0.4,0.2-0.7c0-0.4-0.1-0.7-0.2-0.8s-0.3-0.2-0.6-0.2s-0.4,0.1-0.5,0.2C71,90.1,70.9,90.4,70.9,90.8z"
}), /*#__PURE__*/React.createElement("path", {
  className: "sty96",
  d: "M74.1,90.4c0-0.4,0.1-0.8,0.3-1.1l0.8,0.3c-0.1,0.4-0.2,0.7-0.2,0.9c0,0.4,0.1,0.8,0.2,1 c0.1,0.2,0.3,0.3,0.5,0.3c0.3,0,0.5-0.1,0.7-0.4c0.1-0.2,0.2-0.5,0.2-0.9c0-0.6-0.2-1.1-0.7-1.5c-0.5-0.4-0.7-1-0.7-1.7h0.8 c0,0.4,0.2,0.9,0.7,1.4c0.5,0.5,0.7,1.1,0.7,1.9c0,0.5-0.1,1-0.4,1.4c-0.3,0.4-0.7,0.6-1.2,0.6c-0.5,0-0.9-0.2-1.2-0.6 S74.1,91,74.1,90.4z"
}), /*#__PURE__*/React.createElement("path", {
  className: "sty96",
  d: "M78.1,89.9c0-0.9,0.2-1.5,0.6-1.9c0.4-0.3,0.8-0.5,1.1-0.6c0-0.1,0-0.1,0-0.1c0,0,0-0.1,0-0.1h0.9l-0.1,0.2 c0.3,0,0.7,0.2,1.1,0.5c0.4,0.3,0.6,1,0.7,1.9c0,0.8-0.2,1.4-0.5,1.8c-0.4,0.4-0.9,0.7-1.5,0.7c-0.7,0-1.2-0.2-1.5-0.7 C78.3,91.3,78.1,90.7,78.1,89.9z M78.9,89.9c0,0.5,0.1,0.9,0.3,1.3s0.5,0.5,0.9,0.5c0.4,0,0.8-0.2,0.9-0.5 c0.2-0.3,0.3-0.7,0.3-1.3c0-0.6-0.1-1-0.3-1.3c-0.2-0.2-0.4-0.4-0.7-0.5l0.1,2.5h-0.8l0-2.5c-0.2,0.1-0.4,0.3-0.6,0.5 C79,88.9,78.9,89.4,78.9,89.9z"
}), /*#__PURE__*/React.createElement("path", {
  className: "sty96",
  d: "M83,90.9c0-0.3,0.1-0.5,0.2-0.9l0.8,0.4c-0.1,0.2-0.1,0.4-0.1,0.7s0.1,0.4,0.2,0.5s0.3,0.2,0.5,0.2 c0.3,0,0.5-0.1,0.7-0.2c0.1-0.1,0.2-0.4,0.2-0.8v-2.3c0-0.2-0.1-0.3-0.2-0.4C85.1,88,85,88,84.7,88c-0.3,0-0.5,0.1-0.5,0.2 c-0.1,0.1-0.1,0.2-0.1,0.4c0,0.2,0,0.3,0.1,0.5l-0.7,0.3c-0.2-0.3-0.3-0.5-0.3-0.8c0-0.3,0.1-0.7,0.4-0.9 c0.3-0.3,0.7-0.4,1.1-0.4c0.5,0,0.9,0.1,1.2,0.4c0.3,0.2,0.4,0.5,0.4,0.9v2.3c0,0.6-0.2,1.1-0.5,1.3c-0.3,0.3-0.7,0.4-1.2,0.4 c-0.4,0-0.7-0.1-1.1-0.3C83.2,91.9,83,91.5,83,90.9z"
}), /*#__PURE__*/React.createElement("path", {
  className: "sty96",
  d: "M87,90.6c0-0.4,0.1-0.8,0.4-1.1c0.2-0.3,0.5-0.5,0.9-0.5l0.1-0.4c0-0.2-0.1-0.4-0.4-0.5 c-0.3-0.1-0.5-0.4-0.5-0.8h0.9c0,0.2,0.1,0.3,0.4,0.5c0.3,0.1,0.4,0.4,0.4,0.9L89,89.1c0.3,0,0.5,0.2,0.8,0.5 c0.3,0.3,0.4,0.7,0.4,1.1c0,0.5-0.2,1-0.5,1.3c-0.3,0.3-0.7,0.5-1.2,0.5s-0.9-0.2-1.2-0.5C87.2,91.7,87,91.2,87,90.6z M87.9,90.7 c0,0.4,0.1,0.7,0.2,0.8c0.2,0.2,0.3,0.2,0.5,0.2c0.2,0,0.4-0.1,0.6-0.2c0.1-0.1,0.2-0.4,0.2-0.8c0-0.3-0.1-0.5-0.2-0.7 c-0.2-0.1-0.3-0.2-0.5-0.2c-0.3,0-0.5,0.1-0.6,0.2C87.9,90.1,87.9,90.4,87.9,90.7z"
}), /*#__PURE__*/React.createElement("path", {
  className: "sty96",
  d: "M91,90.4c0-0.4,0.1-0.8,0.3-1.1l0.8,0.3c-0.1,0.4-0.2,0.7-0.2,0.9c0,0.4,0.1,0.8,0.2,1 c0.1,0.2,0.3,0.3,0.5,0.3c0.3,0,0.5-0.1,0.7-0.4c0.1-0.2,0.2-0.5,0.2-0.9c0-0.6-0.2-1.1-0.7-1.5c-0.5-0.4-0.7-1-0.7-1.7h0.8 c0,0.4,0.2,0.9,0.7,1.4c0.5,0.5,0.7,1.1,0.7,1.9c0,0.5-0.1,1-0.4,1.4s-0.7,0.6-1.2,0.6c-0.5,0-0.9-0.2-1.2-0.6 C91.2,91.5,91,91,91,90.4z"
})));

var SvgJoinClassroomSmall = function SvgJoinClassroomSmall(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "\\xD1\\xEB\\xEE\\xE9_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 103 101",
    style: {
      enableBackground: "new 0 0 103 101"
    },
    xmlSpace: "preserve",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: 5.5366,
    y1: 6.5366,
    x2: 96.9925,
    y2: 97.9925,
    gradientTransform: "matrix(1 0 0 -1 0 103)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#11998E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1443,
    style: {
      stopColor: "#179A93"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.342,
    style: {
      stopColor: "#299CA2"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5707,
    style: {
      stopColor: "#46A0BA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8206,
    style: {
      stopColor: "#6EA5DB"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#8FA9F7"
    }
  })), _ref3, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_2_",
    gradientUnits: "userSpaceOnUse",
    x1: 17.8169,
    y1: 40.8653,
    x2: 85.6638,
    y2: 40.8653,
    gradientTransform: "matrix(1 0 0 -1 0 103)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#D79FF3"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#400BCD"
    }
  })), _ref4, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_3_",
    gradientUnits: "userSpaceOnUse",
    x1: -21.469,
    y1: 49.5394,
    x2: 56.4385,
    y2: 49.5394,
    gradientTransform: "matrix(0.9756 -1.494187e-02 -1.704390e-02 -1.0194 35.562 102.9749)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#92F7FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#2395E2"
    }
  })), _ref5, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_4_",
    gradientUnits: "userSpaceOnUse",
    x1: -24.6508,
    y1: 49.5394,
    x2: 59.6203,
    y2: 49.5394,
    gradientTransform: "matrix(0.9756 -1.494158e-02 -1.704360e-02 -1.0194 35.562 102.9749)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#92F7FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#2395E2"
    }
  })), _ref6), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_5_",
    gradientUnits: "userSpaceOnUse",
    x1: 17.8877,
    y1: 41.7036,
    x2: 85.6975,
    y2: 41.7036,
    gradientTransform: "matrix(1 0 0 -1 0 103)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#61E2E5"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#1D7FB5"
    }
  })), _ref7, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_6_",
    gradientUnits: "userSpaceOnUse",
    x1: 17.8862,
    y1: 52.8297,
    x2: 85.6631,
    y2: 52.8297,
    gradientTransform: "matrix(1 0 0 -1 0 103)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#92F7FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#2395E2"
    }
  })), _ref8), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_7_",
    gradientUnits: "userSpaceOnUse",
    x1: 22.763,
    y1: 45.4977,
    x2: 80.8224,
    y2: 45.4977,
    gradientTransform: "matrix(1 0 0 -1 0 103)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#9D7DFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#56399E"
    }
  })), _ref9, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_8_",
    gradientUnits: "userSpaceOnUse",
    x1: 22.7613,
    y1: 55.5428,
    x2: 80.8567,
    y2: 55.5428,
    gradientTransform: "matrix(1 0 0 -1 0 103)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#C2B3FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#6B4FC1"
    }
  })), _ref10), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_9_",
    gradientUnits: "userSpaceOnUse",
    x1: 22.7287,
    y1: 78.5805,
    x2: 80.8207,
    y2: 78.5805,
    gradientTransform: "matrix(1 0 0 -1 0 103)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#45DBFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#D79FF3"
    }
  })), _ref11, _ref12), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _ref13, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_10_",
    gradientUnits: "userSpaceOnUse",
    x1: 56.995,
    y1: 62.6498,
    x2: 57.5193,
    y2: 62.6498,
    gradientTransform: "matrix(1 0 0 -1 0 103)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#92F7FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#85D3FF"
    }
  })), _ref14, _ref15)), _ref16, /*#__PURE__*/React.createElement("g", null, _ref17, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_11_",
    gradientUnits: "userSpaceOnUse",
    x1: 52.4144,
    y1: 65.2592,
    x2: 52.9387,
    y2: 65.2592,
    gradientTransform: "matrix(1 0 0 -1 0 103)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#92F7FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#85D3FF"
    }
  })), _ref18, _ref19)), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_12_",
    gradientUnits: "userSpaceOnUse",
    x1: 52.0493,
    y1: 69.1646,
    x2: 67.6075,
    y2: 69.1646,
    gradientTransform: "matrix(1 0 0 -1 0 103)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#A856E2"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3992,
    style: {
      stopColor: "#A957E0"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5444,
    style: {
      stopColor: "#AC5AD9"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6483,
    style: {
      stopColor: "#B15FCD"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7324,
    style: {
      stopColor: "#B967BC"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8045,
    style: {
      stopColor: "#C370A6"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8684,
    style: {
      stopColor: "#CF7C8B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9263,
    style: {
      stopColor: "#DE8B6B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9778,
    style: {
      stopColor: "#EF9B46"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#F7A334"
    }
  })), _ref20, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_13_",
    gradientUnits: "userSpaceOnUse",
    x1: 52.0493,
    y1: 70.0401,
    x2: 67.6125,
    y2: 70.0401,
    gradientTransform: "matrix(1 0 0 -1 0 103)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#D58DFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFB850"
    }
  })), _ref21), /*#__PURE__*/React.createElement("g", null, _ref22, _ref23, _ref24, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_14_",
    gradientUnits: "userSpaceOnUse",
    x1: 60.7281,
    y1: 70.3629,
    x2: 61.7069,
    y2: 72.0582,
    gradientTransform: "matrix(1 0 0 -1 0 103)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#6ABEDB"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1469,
    style: {
      stopColor: "#82CFE4"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3666,
    style: {
      stopColor: "#9FE3F0"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5844,
    style: {
      stopColor: "#B4F2F8"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7974,
    style: {
      stopColor: "#C1FBFD"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#C5FEFF"
    }
  })), _ref25, _ref26, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_15_",
    gradientUnits: "userSpaceOnUse",
    x1: 58.6814,
    y1: 69.0775,
    x2: 59.7794,
    y2: 70.9792,
    gradientTransform: "matrix(1 0 0 -1 0 103)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#C5FEFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#B3E8FF"
    }
  })), _ref27), _ref28, _ref29, _ref30, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _ref31, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_16_",
    gradientUnits: "userSpaceOnUse",
    x1: 67.2676,
    y1: 62.1692,
    x2: 67.6425,
    y2: 62.1692,
    gradientTransform: "matrix(1 0 0 -1 0 103)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#92F7FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#85D3FF"
    }
  })), _ref32, _ref33)), /*#__PURE__*/React.createElement("g", null, _ref34, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_17_",
    gradientUnits: "userSpaceOnUse",
    x1: 64.5235,
    y1: 63.6798,
    x2: 64.8983,
    y2: 63.6798,
    gradientTransform: "matrix(1 0 0 -1 0 103)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#92F7FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#85D3FF"
    }
  })), _ref35, _ref36)), /*#__PURE__*/React.createElement("g", null, _ref37, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_18_",
    gradientUnits: "userSpaceOnUse",
    x1: 64.8266,
    y1: 61.0362,
    x2: 65.2015,
    y2: 61.0362,
    gradientTransform: "matrix(1 0 0 -1 0 103)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#92F7FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#85D3FF"
    }
  })), _ref38, _ref39)), /*#__PURE__*/React.createElement("g", null, _ref40, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_19_",
    gradientUnits: "userSpaceOnUse",
    x1: 62.0825,
    y1: 62.3065,
    x2: 62.4574,
    y2: 62.3065,
    gradientTransform: "matrix(1 0 0 -1 0 103)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#92F7FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#85D3FF"
    }
  })), _ref41, _ref42)), _ref43, _ref44, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_20_",
    gradientUnits: "userSpaceOnUse",
    x1: 65.0914,
    y1: 66.5295,
    x2: 68.4861,
    y2: 66.5295,
    gradientTransform: "matrix(1 0 0 -1 0 103)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#D58DFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFB850"
    }
  })), _ref45, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_21_",
    gradientUnits: "userSpaceOnUse",
    x1: 65.3107,
    y1: 66.3922,
    x2: 68.7054,
    y2: 66.3922,
    gradientTransform: "matrix(1 0 0 -1 0 103)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#A856E2"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.623,
    style: {
      stopColor: "#DA8773"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#F7A334"
    }
  })), _ref46), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_22_",
    gradientUnits: "userSpaceOnUse",
    x1: 65.3065,
    y1: 64.4738,
    x2: 68.2718,
    y2: 64.4738,
    gradientTransform: "matrix(1 0 0 -1 0 103)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#92F7FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#85D3FF"
    }
  })), _ref47)), /*#__PURE__*/React.createElement("g", null, _ref48, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_23_",
    gradientUnits: "userSpaceOnUse",
    x1: 31.9643,
    y1: 78.3573,
    x2: 46.6933,
    y2: 78.3573,
    gradientTransform: "matrix(1 0 0 -1 0 103)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#81EABD"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#55B58E"
    }
  })), _ref49, _ref50, _ref51, _ref52, _ref53), _ref54, _ref55, _ref56, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_24_",
    gradientUnits: "userSpaceOnUse",
    x1: 34.3834,
    y1: 73.8009,
    x2: 34.3834,
    y2: 75.7394,
    gradientTransform: "matrix(1 0 0 -1 0 103)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#A86BF7"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E4BDFF"
    }
  })), _ref57, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_25_",
    gradientUnits: "userSpaceOnUse",
    x1: 37.291,
    y1: 75.3017,
    x2: 37.7048,
    y2: 75.3017,
    gradientTransform: "matrix(1 0 0 -1 0 103)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#E4BDFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#A86BF7"
    }
  })), _ref58), /*#__PURE__*/React.createElement("g", null, _ref59, _ref60, _ref61, _ref62, _ref63, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_26_",
    gradientUnits: "userSpaceOnUse",
    x1: 31.2576,
    y1: 65.904,
    x2: 33.1621,
    y2: 65.904,
    gradientTransform: "matrix(1 0 0 -1 0 103)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#892758"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#B7326F"
    }
  })), _ref64, _ref65, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_27_",
    gradientUnits: "userSpaceOnUse",
    x1: 29.6724,
    y1: 65.2698,
    x2: 31.9804,
    y2: 65.2698,
    gradientTransform: "matrix(1 0 0 -1 0 103)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#B7326F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#892758"
    }
  })), _ref66, _ref67), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_28_",
    gradientUnits: "userSpaceOnUse",
    x1: 29.7299,
    y1: 72.9296,
    x2: 33.2202,
    y2: 72.9296,
    gradientTransform: "matrix(1 0 0 -1 0 103)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#D58DFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#8036CE"
    }
  })), _ref68, _ref69, _ref70, _ref71, /*#__PURE__*/React.createElement("g", null, _ref72, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_29_",
    gradientUnits: "userSpaceOnUse",
    x1: 29.1314,
    y1: 71.4966,
    x2: 30.6128,
    y2: 71.4966,
    gradientTransform: "matrix(1 0 0 -1 0 103)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#E4BDFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#A86BF7"
    }
  })), _ref73, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_30_",
    gradientUnits: "userSpaceOnUse",
    x1: 29.5079,
    y1: 68.023,
    x2: 30.2372,
    y2: 68.023,
    gradientTransform: "matrix(1 0 0 -1 0 103)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#E4BDFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#A86BF7"
    }
  })), _ref74)), _ref75, _ref76, _ref77, _ref78, _ref79, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _ref80, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_31_",
    gradientUnits: "userSpaceOnUse",
    x1: 42.5153,
    y1: 53.4485,
    x2: 43.0395,
    y2: 53.4485,
    gradientTransform: "matrix(1 0 0 -1 0 103)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#92F7FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#85D3FF"
    }
  })), _ref81, _ref82)), _ref83, _ref84, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_32_",
    gradientUnits: "userSpaceOnUse",
    x1: 37.5732,
    y1: 59.9632,
    x2: 53.1262,
    y2: 59.9632,
    gradientTransform: "matrix(1 0 0 -1 0 103)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#A856E2"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3992,
    style: {
      stopColor: "#A957E0"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5444,
    style: {
      stopColor: "#AC5AD9"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6483,
    style: {
      stopColor: "#B15FCD"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7324,
    style: {
      stopColor: "#B967BC"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8045,
    style: {
      stopColor: "#C370A6"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8684,
    style: {
      stopColor: "#CF7C8B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9263,
    style: {
      stopColor: "#DE8B6B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9778,
    style: {
      stopColor: "#EF9B46"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#F7A334"
    }
  })), _ref85, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_33_",
    gradientUnits: "userSpaceOnUse",
    x1: 37.5692,
    y1: 60.8044,
    x2: 53.1308,
    y2: 60.8044,
    gradientTransform: "matrix(1 0 0 -1 0 103)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#D58DFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFB850"
    }
  })), _ref86), /*#__PURE__*/React.createElement("g", null, _ref87, _ref88, _ref89, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_34_",
    gradientUnits: "userSpaceOnUse",
    x1: 46.252,
    y1: 61.1491,
    x2: 47.2308,
    y2: 62.8443,
    gradientTransform: "matrix(1 0 0 -1 0 103)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#6ABEDB"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1469,
    style: {
      stopColor: "#82CFE4"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3666,
    style: {
      stopColor: "#9FE3F0"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5844,
    style: {
      stopColor: "#B4F2F8"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7974,
    style: {
      stopColor: "#C1FBFD"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#C5FEFF"
    }
  })), _ref90, _ref91, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_35_",
    gradientUnits: "userSpaceOnUse",
    x1: 44.2054,
    y1: 59.8636,
    x2: 45.3034,
    y2: 61.7654,
    gradientTransform: "matrix(1 0 0 -1 0 103)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#C5FEFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#B3E8FF"
    }
  })), _ref92), _ref93, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _ref94, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_36_",
    gradientUnits: "userSpaceOnUse",
    x1: 52.7878,
    y1: 52.9335,
    x2: 53.1627,
    y2: 52.9335,
    gradientTransform: "matrix(1 0 0 -1 0 103)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#92F7FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#85D3FF"
    }
  })), _ref95, _ref96)), /*#__PURE__*/React.createElement("g", null, _ref97, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_37_",
    gradientUnits: "userSpaceOnUse",
    x1: 50.0438,
    y1: 54.4442,
    x2: 50.4186,
    y2: 54.4442,
    gradientTransform: "matrix(1 0 0 -1 0 103)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#92F7FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#85D3FF"
    }
  })), _ref98, _ref99)), /*#__PURE__*/React.createElement("g", null, _ref100, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_38_",
    gradientUnits: "userSpaceOnUse",
    x1: 50.3469,
    y1: 51.8304,
    x2: 50.7218,
    y2: 51.8304,
    gradientTransform: "matrix(1 0 0 -1 0 103)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#92F7FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#85D3FF"
    }
  })), _ref101, _ref102)), /*#__PURE__*/React.createElement("g", null, _ref103, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_39_",
    gradientUnits: "userSpaceOnUse",
    x1: 47.6028,
    y1: 53.1052,
    x2: 47.9777,
    y2: 53.1052,
    gradientTransform: "matrix(1 0 0 -1 0 103)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#92F7FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#85D3FF"
    }
  })), _ref104, _ref105)), _ref106, _ref107, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_40_",
    gradientUnits: "userSpaceOnUse",
    x1: 50.6117,
    y1: 57.2938,
    x2: 54.0064,
    y2: 57.2938,
    gradientTransform: "matrix(1 0 0 -1 0 103)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#D58DFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFB850"
    }
  })), _ref108, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_41_",
    gradientUnits: "userSpaceOnUse",
    x1: 50.831,
    y1: 57.1908,
    x2: 54.2257,
    y2: 57.1908,
    gradientTransform: "matrix(1 0 0 -1 0 103)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#A856E2"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.623,
    style: {
      stopColor: "#DA8773"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#F7A334"
    }
  })), _ref109), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_42_",
    gradientUnits: "userSpaceOnUse",
    x1: 50.8268,
    y1: 55.2725,
    x2: 53.7921,
    y2: 55.2725,
    gradientTransform: "matrix(1 0 0 -1 0 103)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#92F7FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#85D3FF"
    }
  })), _ref110, _ref111)), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _ref112, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_43_",
    gradientUnits: "userSpaceOnUse",
    x1: 63.5694,
    y1: 50.0495,
    x2: 64.0937,
    y2: 50.0495,
    gradientTransform: "matrix(1 0 0 -1 0 103)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#92F7FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#85D3FF"
    }
  })), _ref113, _ref114)), _ref115, /*#__PURE__*/React.createElement("g", null, _ref116, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_44_",
    gradientUnits: "userSpaceOnUse",
    x1: 58.9889,
    y1: 52.6555,
    x2: 59.5131,
    y2: 52.6555,
    gradientTransform: "matrix(1 0 0 -1 0 103)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#92F7FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#85D3FF"
    }
  })), _ref117, _ref118)), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_45_",
    gradientUnits: "userSpaceOnUse",
    x1: 58.6413,
    y1: 56.5642,
    x2: 74.1943,
    y2: 56.5642,
    gradientTransform: "matrix(1 0 0 -1 0 103)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#A856E2"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3992,
    style: {
      stopColor: "#A957E0"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5444,
    style: {
      stopColor: "#AC5AD9"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6483,
    style: {
      stopColor: "#B15FCD"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7324,
    style: {
      stopColor: "#B967BC"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8045,
    style: {
      stopColor: "#C370A6"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8684,
    style: {
      stopColor: "#CF7C8B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9263,
    style: {
      stopColor: "#DE8B6B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9778,
    style: {
      stopColor: "#EF9B46"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#F7A334"
    }
  })), _ref119, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_46_",
    gradientUnits: "userSpaceOnUse",
    x1: 58.6413,
    y1: 57.4054,
    x2: 74.2044,
    y2: 57.4054,
    gradientTransform: "matrix(1 0 0 -1 0 103)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#D58DFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFB850"
    }
  })), _ref120), /*#__PURE__*/React.createElement("g", null, _ref121, _ref122, _ref123, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_47_",
    gradientUnits: "userSpaceOnUse",
    x1: 67.299,
    y1: 57.7511,
    x2: 68.2777,
    y2: 59.4464,
    gradientTransform: "matrix(1 0 0 -1 0 103)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#6ABEDB"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1469,
    style: {
      stopColor: "#82CFE4"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3666,
    style: {
      stopColor: "#9FE3F0"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5844,
    style: {
      stopColor: "#B4F2F8"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7974,
    style: {
      stopColor: "#C1FBFD"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#C5FEFF"
    }
  })), _ref124, _ref125, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_48_",
    gradientUnits: "userSpaceOnUse",
    x1: 65.2781,
    y1: 56.4508,
    x2: 66.376,
    y2: 58.3526,
    gradientTransform: "matrix(1 0 0 -1 0 103)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#C5FEFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#B3E8FF"
    }
  })), _ref126), _ref127, _ref128, _ref129, /*#__PURE__*/React.createElement("g", null, _ref130, /*#__PURE__*/React.createElement("g", null, _ref131, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_49_",
    gradientUnits: "userSpaceOnUse",
    x1: 73.842,
    y1: 49.5345,
    x2: 74.2169,
    y2: 49.5345,
    gradientTransform: "matrix(1 0 0 -1 0 103)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#92F7FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#85D3FF"
    }
  })), _ref132, _ref133)), /*#__PURE__*/React.createElement("g", null, _ref134, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_50_",
    gradientUnits: "userSpaceOnUse",
    x1: 71.0979,
    y1: 51.0452,
    x2: 71.4728,
    y2: 51.0452,
    gradientTransform: "matrix(1 0 0 -1 0 103)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#92F7FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#85D3FF"
    }
  })), _ref135, _ref136)), /*#__PURE__*/React.createElement("g", null, _ref137, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_51_",
    gradientUnits: "userSpaceOnUse",
    x1: 71.4011,
    y1: 48.4015,
    x2: 71.776,
    y2: 48.4015,
    gradientTransform: "matrix(1 0 0 -1 0 103)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#92F7FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#85D3FF"
    }
  })), _ref138, _ref139)), /*#__PURE__*/React.createElement("g", null, _ref140, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_52_",
    gradientUnits: "userSpaceOnUse",
    x1: 68.657,
    y1: 49.7062,
    x2: 69.0318,
    y2: 49.7062,
    gradientTransform: "matrix(1 0 0 -1 0 103)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#92F7FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#85D3FF"
    }
  })), _ref141, _ref142)), _ref143, _ref144, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_53_",
    gradientUnits: "userSpaceOnUse",
    x1: 71.6659,
    y1: 53.8948,
    x2: 75.0606,
    y2: 53.8948,
    gradientTransform: "matrix(1 0 0 -1 0 103)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#D58DFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFB850"
    }
  })), _ref145, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_54_",
    gradientUnits: "userSpaceOnUse",
    x1: 71.8851,
    y1: 53.7575,
    x2: 75.2798,
    y2: 53.7575,
    gradientTransform: "matrix(1 0 0 -1 0 103)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#A856E2"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.623,
    style: {
      stopColor: "#DA8773"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#F7A334"
    }
  })), _ref146), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_55_",
    gradientUnits: "userSpaceOnUse",
    x1: 71.881,
    y1: 51.8735,
    x2: 74.8463,
    y2: 51.8735,
    gradientTransform: "matrix(1 0 0 -1 0 103)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#92F7FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#85D3FF"
    }
  })), _ref147)), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_56_",
    gradientUnits: "userSpaceOnUse",
    x1: 22.7405,
    y1: 60.7443,
    x2: 39.6668,
    y2: 60.7443,
    gradientTransform: "matrix(1 0 0 -1 0 103)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#D79FF3"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#45DBFF"
    }
  })), _ref148, _ref149))), _ref150));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgJoinClassroomSmall, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/join-classroom-small.71177ca6.svg";
export { ForwardRef as ReactComponent };